{
  "common": {
    "address": "Adresas",
    "id": "ID",
    "yes": "Taip",
    "no": "Ne",
    "all": "Visi",
    "mixed": "Mišrus",
    "unknown": "Nežinoma",
    "read_more_button": "Skaityti daugiau",
    "click_to_learn_more": "Spustelėkite, kad sužinotumėte daugiau",
    "none": "Nėra",
    "other": "Kita",
    "edit": "Redaguoti",
    "date": "Data: {date}",
    "kw": "kW",
    "kwh": "kWh",
    "mwh": "MWh",
    "gwh": "GWh",
    "eur": "€",
    "months_abbrev": {
      "1": "Sau",
      "2": "Vas",
      "3": "Kov",
      "4": "Bal",
      "5": "Geg",
      "6": "Bir",
      "7": "Lie",
      "8": "Rugp",
      "9": "Rugs",
      "10": "Spa",
      "11": "Lapk",
      "12": "Gruod"
    },
    "next": "Kitas",
    "back": "Atgal",
    "save": "Išsaugoti",
    "saving": "Saugoma",
    "cancel": "Atšaukti",
    "confirm": "Patvirtinti",
    "continue": "Tęsti",
    "step": "Žingsnis",
    "optional": "Neprivaloma",
    "saved_successfully": "Sėkmingai išsaugota",
    "unsaved_changes_confirm": "Turite neišsaugotų pakeitimų. Išeiti iš puslapio ir jų atsisakyti?",
    "clear": "Išvalyti",
    "filter": "Filtruoti",
    "search": "Ieškoti",
    "select": "Pasirinkti",
    "select_all": "Pasirinkti viską",
    "clear_all": "Išvalyti pasirinkimą",
    "pricing_loading_messages": {
      "retrieving_market_levels": "Gaunami rinkos kainų lygiai...",
      "applying_sourcing_criteria": "Taikomi pirkimo kriterijai...",
      "calculating_fees": "Skaičiuojami mokesčiai..."
    },
    "selected": "pasirinkta",
    "total_volume": "Bendra apimtis",
    "last_updated": "Paskutinį kartą atnaujinta",
    "certificate": "Sertifikatas",
    "volume": "Apimtis",
    "technology_label": "Technologija",
    "uploaded": "Įkelta",
    "not_uploaded": "Neįkelta",
    "any_file_format": "Visi failų formatai yra tinkami",
    "pdf_file_format": "Įkelti failai turi būti .pdf formato",
    "invalid_file_error": "Šis failas neteisingas, įkelkite teisingą failą",
    "invalid_file_contact_support": "Jei manote, kad tai klaida ir šis dokumentas iš tiesų galioja, susisiekite su mūsų klientų aptarnavimo tarnyba. Norėdami tai padaryti, spustelėkite pokalbių burbulą apatiniame dešiniajame ekrano kampe arba pasirinkite 'Susisiekite su mumis' iš viršutinio meniu.",
    "coming_soon": "Netrukus!",
    "contactSupport": "Susisiekti su pagalba",
    "loading": "Kraunama",
    "uploading": "Įkeliama...",
    "pending": "Laukiama",
    "rejected": "Atmesta",
    "active": "Aktyvus",
    "status": "Būsena:",
    "add": "Pridėti",
    "creating": "Kuriama...",
    "create_device": "Kurti įrenginį",
    "not_specified": "Nenurodyta",
    "page_navigation": "Puslapių navigacija",
    "previous_page": "Ankstesnis puslapis",
    "next_page": "Kitas puslapis",
    "remove": "Pašalinti",
    "delete": "Ištrinti",
    "deleted": "(ištrinta)",
    "add_another_unit": "Pridėti dar vieną vienetą",
    "saved": "Išsaugota",
    "retry": "Pakartoti",
    "download": "Atsisiųsti",
    "close": "Užverti",
    "open_pdf": "Atidaryti PDF",
    "success": "Sėkmingai",
    "unexpected_error": "Netikėta klaida, bandykite dar kartą vėliau!",
    "select_option": "Pasirinkite...",
    "year": "Metai",
    "years": "Metų",
    "month": "Mėnuo",
    "months": "Mėnesiai",
    "day": "Diena",
    "select_month": "Pasirinkite mėnesį",
    "select_day": "Pasirinkite dieną",
    "full_name": "Vardas ir pavardė",
    "name": "Pavadinimas",
    "start_date": "Pradžios data",
    "end_date": "Pabaigos data",
    "email": "El. paštas",
    "company_search": {
      "label": "Įmonių paieška",
      "description": "Ieškoti įmonės pagal pavadinimą, įmonės kodą ar PVM kodą",
      "placeholder": "Įveskite įmonės pavadinimą, kodą ar PVM kodą",
      "ai_extracted": "AI išgauta",
      "custom_entry": "Pasirinktinis įrašas",
      "unavailable": "Įmonių paieška nepasiekiama, įveskite įmonės duomenis rankiniu būdu"
    },
    "counterparty_picker": {
      "company_label": "Įmonės pavadinimas",
      "account_label": "Registro sąskaitos numeris",
      "account_invalid": "Sąskaitos numerį gali sudaryti tik raidės ir skaitmenys",
      "account_invalid_aib": "Turi būti galiojantis EECS identifikatorius (2 skaitmenys, X ir 7 raidiniai-skaitmeniniai simboliai)",
      "account_invalid_rego": "Turi būti Ofgem sąskaitos numeris (GEN, PAR, SUP arba AGE ir 7 skaitmenys)",
      "account_invalid_rgp": "Turi būti TGE nario kodas (raidės ir skaitmenys, pvz., RESENENC)",
      "account_unrecognized_warning": "Neatpažintas sąskaitos numerio formatas - registro šalies negalima nustatyti automatiškai.",
      "internal_account_label": "Registro vidinės sąskaitos numeris",
      "internal_account_help": "Neprivaloma. Reikalinga tik registrams, naudojantiems subsąskaitas.",
      "internal_account_placeholder": "Neprivalomas subsąskaitos ID"
    },
    "eecs_name_mismatch": {
      "both": "Įmonės pavadinimas ir EECS nesutampa. {name} atitinka EECS: {expectedEecs}, o {eecs} atitinka įmonę {expectedName}",
      "eecs_only": "Įmonės pavadinimas ir EECS nesutampa. Įmonei {name} nerasta EECS, o {eecs} atitinka įmonę {expectedName}",
      "name_only": "Įmonės pavadinimas ir EECS nesutampa. {name} atitinka EECS: {expectedEecs}, o {eecs} neatitinka jokios įmonės",
      "unknown_counterparty": "Patikrinkite įmonės pavadinimą ir sąskaitos numerį sutartyje."
    },
    "no_results": "Nerasta rezultatų",
    "partial_results": "Rodomi pirmieji {shown} iš {total} atitikmenų — tikslinkite paiešką",
    "technology": {
      "solar": "Saulės",
      "wind": "Vėjo",
      "hydro": "Hidro",
      "biomass": "Biomasės",
      "nuclear": "Branduolinė energija",
      "mixed": "Mišrus"
    },
    "country": {
      "AD": "Andora",
      "AE": "Jungtiniai Arabų Emyratai",
      "AF": "Afganistanas",
      "AG": "Antigva ir Barbuda",
      "AI": "Angilija",
      "AL": "Albanija",
      "AM": "Armėnija",
      "AO": "Angola",
      "AQ": "Antarktida",
      "AR": "Argentina",
      "AS": "Amerikos Samoa",
      "AT": "Austrija",
      "AU": "Australija",
      "AW": "Aruba",
      "AX": "Alandų Salos",
      "AZ": "Azerbaidžanas",
      "BA": "Bosnija ir Hercegovina",
      "BB": "Barbadosas",
      "BD": "Bangladešas",
      "BE": "Belgija",
      "BF": "Burkina Fasas",
      "BG": "Bulgarija",
      "BH": "Bahreinas",
      "BI": "Burundis",
      "BJ": "Beninas",
      "BL": "Sen Bartelemi",
      "BM": "Bermuda",
      "BN": "Brunėjus",
      "BO": "Bolivija",
      "BQ": "Karibų Nyderlandai",
      "BR": "Brazilija",
      "BS": "Bahamos",
      "BT": "Butanas",
      "BV": "Buvė Sala",
      "BW": "Botsvana",
      "BY": "Baltarusija",
      "BZ": "Belizas",
      "CA": "Kanada",
      "CC": "Kokosų (Kilingo) Salos",
      "CD": "Kongas-Kinšasa",
      "CF": "Centrinės Afrikos Respublika",
      "CG": "Kongas-Brazavilis",
      "CH": "Šveicarija",
      "CI": "Dramblio Kaulo Krantas",
      "CK": "Kuko Salos",
      "CL": "Čilė",
      "CM": "Kamerūnas",
      "CN": "Kinija",
      "CO": "Kolumbija",
      "CR": "Kosta Rika",
      "CU": "Kuba",
      "CV": "Žaliasis Kyšulys",
      "CW": "Kiurasao",
      "CX": "Kalėdų Sala",
      "CY": "Kipras",
      "CZ": "Čekija",
      "DE": "Vokietija",
      "DJ": "Džibutis",
      "DK": "Danija",
      "DM": "Dominika",
      "DO": "Dominikos Respublika",
      "DZ": "Alžyras",
      "EC": "Ekvadoras",
      "EE": "Estija",
      "EG": "Egiptas",
      "EH": "Vakarų Sachara",
      "ER": "Eritrėja",
      "ES": "Ispanija",
      "ET": "Etiopija",
      "FI": "Suomija",
      "FJ": "Fidžis",
      "FK": "Folklando Salos",
      "FM": "Mikronezija",
      "FO": "Farerų Salos",
      "FR": "Prancūzija",
      "GA": "Gabonas",
      "GB": "Jungtinė Karalystė",
      "GD": "Grenada",
      "GE": "Gruzija",
      "GF": "Prancūzijos Gviana",
      "GG": "Gernsis",
      "GH": "Gana",
      "GI": "Gibraltaras",
      "GL": "Grenlandija",
      "GM": "Gambija",
      "GN": "Gvinėja",
      "GP": "Gvadelupa",
      "GQ": "Pusiaujo Gvinėja",
      "GR": "Graikija",
      "GS": "Pietų Džordžija ir Pietų Sandvičo salos",
      "GT": "Gvatemala",
      "GU": "Guamas",
      "GW": "Bisau Gvinėja",
      "GY": "Gajana",
      "HK": "Ypatingasis Administracinis Kinijos Regionas Honkongas",
      "HM": "Herdo ir Makdonaldo Salos",
      "HN": "Hondūras",
      "HR": "Kroatija",
      "HT": "Haitis",
      "HU": "Vengrija",
      "ID": "Indonezija",
      "IE": "Airija",
      "IL": "Izraelis",
      "IM": "Meno Sala",
      "IN": "Indija",
      "IO": "Indijos Vandenyno Britų Sritis",
      "IQ": "Irakas",
      "IR": "Iranas",
      "IS": "Islandija",
      "IT": "Italija",
      "JE": "Džersis",
      "JM": "Jamaika",
      "JO": "Jordanija",
      "JP": "Japonija",
      "KE": "Kenija",
      "KG": "Kirgizija",
      "KH": "Kambodža",
      "KI": "Kiribatis",
      "KM": "Komorai",
      "KN": "Sent Kitsas ir Nevis",
      "KP": "Šiaurės Korėja",
      "KR": "Pietų Korėja",
      "KW": "Kuveitas",
      "KY": "Kaimanų Salos",
      "KZ": "Kazachstanas",
      "LA": "Laosas",
      "LB": "Libanas",
      "LC": "Sent Lusija",
      "LI": "Lichtenšteinas",
      "LK": "Šri Lanka",
      "LR": "Liberija",
      "LS": "Lesotas",
      "LT": "Lietuva",
      "LU": "Liuksemburgas",
      "LV": "Latvija",
      "LY": "Libija",
      "MA": "Marokas",
      "MC": "Monakas",
      "MD": "Moldova",
      "ME": "Juodkalnija",
      "MF": "Sen Martenas",
      "MG": "Madagaskaras",
      "MH": "Maršalo Salos",
      "MK": "Šiaurės Makedonija",
      "ML": "Malis",
      "MM": "Mianmaras (Birma)",
      "MN": "Mongolija",
      "MO": "Ypatingasis Administracinis Kinijos Regionas Makao",
      "MP": "Marianos Šiaurinės Salos",
      "MQ": "Martinika",
      "MR": "Mauritanija",
      "MS": "Montseratas",
      "MT": "Malta",
      "MU": "Mauricijus",
      "MV": "Maldyvai",
      "MW": "Malavis",
      "MX": "Meksika",
      "MY": "Malaizija",
      "MZ": "Mozambikas",
      "NA": "Namibija",
      "NC": "Naujoji Kaledonija",
      "NE": "Nigeris",
      "NF": "Norfolko sala",
      "NG": "Nigerija",
      "NI": "Nikaragva",
      "NL": "Nyderlandai",
      "NO": "Norvegija",
      "NP": "Nepalas",
      "NR": "Nauru",
      "NU": "Niujė",
      "NZ": "Naujoji Zelandija",
      "OM": "Omanas",
      "PA": "Panama",
      "PE": "Peru",
      "PF": "Prancūzijos Polinezija",
      "PG": "Papua Naujoji Gvinėja",
      "PH": "Filipinai",
      "PK": "Pakistanas",
      "PL": "Lenkija",
      "PM": "Sen Pjeras ir Mikelonas",
      "PN": "Pitkerno salos",
      "PR": "Puerto Rikas",
      "PS": "Palestinos teritorija",
      "PT": "Portugalija",
      "PW": "Palau",
      "PY": "Paragvajus",
      "QA": "Kataras",
      "RE": "Reunjonas",
      "RO": "Rumunija",
      "RS": "Serbija",
      "RU": "Rusija",
      "RW": "Ruanda",
      "SA": "Saudo Arabija",
      "SB": "Saliamono Salos",
      "SC": "Seišeliai",
      "SD": "Sudanas",
      "SE": "Švedija",
      "SG": "Singapūras",
      "SH": "Šv. Elenos Sala",
      "SI": "Slovėnija",
      "SJ": "Svalbardas ir Janas Majenas",
      "SK": "Slovakija",
      "SL": "Siera Leonė",
      "SM": "San Marinas",
      "SN": "Senegalas",
      "SO": "Somalis",
      "SR": "Surinamas",
      "SS": "Pietų Sudanas",
      "ST": "San Tomė ir Prinsipė",
      "SV": "Salvadoras",
      "SX": "Sint Martenas",
      "SY": "Sirija",
      "SZ": "Svazilandas",
      "TC": "Terkso ir Kaikoso Salos",
      "TD": "Čadas",
      "TF": "Prancūzijos Pietų sritys",
      "TG": "Togas",
      "TH": "Tailandas",
      "TJ": "Tadžikija",
      "TK": "Tokelau",
      "TL": "Rytų Timoras",
      "TM": "Turkmėnistanas",
      "TN": "Tunisas",
      "TO": "Tonga",
      "TR": "Turkija",
      "TT": "Trinidadas ir Tobagas",
      "TV": "Tuvalu",
      "TW": "Taivanas",
      "TZ": "Tanzanija",
      "UA": "Ukraina",
      "UG": "Uganda",
      "UM": "Jungtinių Valstijų Mažosios Tolimosios Salos",
      "US": "Jungtinės Valstijos",
      "UY": "Urugvajus",
      "UZ": "Uzbekistanas",
      "VA": "Vatikano Miesto Valstybė",
      "VC": "Šventasis Vincentas ir Grenadinai",
      "VE": "Venesuela",
      "VG": "Didžiosios Britanijos Mergelių Salos",
      "VI": "Jungtinių Valstijų Mergelių Salos",
      "VN": "Vietnamas",
      "VU": "Vanuatu",
      "WF": "Volisas ir Futūna",
      "WS": "Samoa",
      "XK": "Kosovas",
      "YE": "Jemenas",
      "YT": "Majotas",
      "ZA": "Pietų Afrika",
      "ZM": "Zambija",
      "ZW": "Zimbabvė",
      "BE_BRU": "Belgija (Briuselis)",
      "BE_FED": "Belgija (Federalinė)",
      "BE_FLA": "Belgija (Flandrija)",
      "BE_WAL": "Belgija (Valonija)",
      "other": "Kitos"
    },
    "done": "Atlikta",
    "company": "Įmonė",
    "companies": "Įmonės",
    "search_companies": "Ieškoti įmonių",
    "select_companies": "Pasirinkti įmones",
    "documents": "Dokumentai",
    "contracts": "Sutartys",
    "devices": "Įrenginiai",
    "hide_admin_options": "Slėpti administratoriaus parinktis",
    "show_admin_options": "Rodyti administratoriaus parinktis",
    "actions": {
      "title": "Veiksmai",
      "send": "Siųsti",
      "receive": "Gauti",
      "portfolios": "Portfeliai",
      "buy": "Pirkti",
      "buy_and_cancel": "Pirkti ir atšaukti",
      "sell": "Parduoti",
      "cancel": "@:common.cancel",
      "confirm_send": "Patvirtinti siuntimo užsakymą",
      "confirm_sell": "Patvirtinti pardavimo nustatymą",
      "accept": "Priimti"
    },
    "eacs_in_inventory": "kilmės garantijų inventoriuje",
    "settings": "Nustatymai",
    "action_items": "Reikia veiksmų",
    "type_here": "Įveskite savo pranešimą čia...",
    "placeholderText": "Vieta rezervuotas tekstas - jei įmanoma, pateikite konkretesnį kontekstą.",
    "production_period": "Gamybos laikotarpis",
    "production_year": "Gamybos metai"
  },
  "primevue": {
    "startsWith": "Prasideda nuo",
    "contains": "Turi",
    "notContains": "Neturi",
    "endsWith": "Baigiasi su",
    "equals": "Lygu",
    "notEquals": "Nelygu",
    "noFilter": "Be filtro",
    "lt": "Mažiau nei",
    "lte": "Mažiau arba lygu",
    "gt": "Daugiau nei",
    "gte": "Daugiau arba lygu",
    "dateIs": "Data yra",
    "dateIsNot": "Data nėra",
    "dateBefore": "Data prieš",
    "dateAfter": "Data po",
    "clear": "Išvalyti",
    "apply": "Taikyti",
    "matchAll": "Atitinka visus",
    "matchAny": "Atitinka bet kurį",
    "addRule": "Pridėti taisyklę",
    "removeRule": "Pašalinti taisyklę",
    "today": "Šiandien"
  },
  "language": {
    "en": "Anglų",
    "et": "Estų",
    "lv": "Latvių",
    "lt": "Lietuvių",
    "sv": "Švediškas"
  },
  "settings": {
    "title": "Nustatymai",
    "select_language": "Pasirinkite kalbą",
    "name": "Vardas",
    "email": "El. paštas",
    "phone": "Telefono numeris",
    "email_cannot_be_changed": "Norėdami pakeisti paskyros el. paštą, pakvieskite naują komandos narį iš Įmonės nustatymų puslapio",
    "receive_transaction_emails": "Gauti pardavimo pranešimų el. laiškus",
    "receive_transaction_emails_hint": "El. laiškai apie jūsų kilmės garantijų pardavimus su pridėtomis mokesčio sąskaitomis faktūromis. Įmonės nustatymuose nurodykite sąskaitų el. paštą, kad jūsų buhalteris gautų sąskaitas net tada, kai tai išjungta."
  },
  "app": {
    "development_environment": "Tai yra kūrimo aplinka",
    "staging_environment": "Tai yra parengiamoji aplinka",
    "managing_client_account": "Valdoma kliento paskyra: {email}",
    "stop_managing": "Baigti valdymą",
    "log_in": "Prisijungti",
    "log_out": "Atsijungti",
    "error_occurred": "Įvyko klaida",
    "error_message_code": "Klaidos kodas: {errorCode}",
    "contact_support": "Norėdami išspręsti šią problemą, susisiekite su palaikymo tarnyba. Spustelėkite pokalbio burbulą apatiniame dešiniajame ekrano kampe arba pasirinkite „Susisiekite su mumis\" iš viršutinio meniu."
  },
  "signup": {
    "choose_company_country": "Jūsų gamybos įrenginio šalis",
    "select_country_placeholder": "Pasirinkite šalį",
    "legal": {
      "byJoining": "Užsiregistruodami sutinkate su",
      "membershipAgreement": "Soldera platformos sutartimi.",
      "personalDataNote": "Jūsų asmens duomenys bus tvarkomi pagal mūsų",
      "privacyPolicy": "privatumo politiką."
    },
    "modal": {
      "hello_button": "Pradėti registraciją",
      "hello": "👋 Sveiki atvykę!",
      "soldera_faq": "„Soldera\" DUK",
      "lv": {
        "section1": "Džiaugiamės, kad nusprendėte prisijungti prie „Soldera\". Jei turite klausimų, atsakymus į pagrindinius klausimus rasite čia",
        "section2": "Užpildę žemiau pateiktą informaciją, suteiksite prieigą „Soldera\" valdyti jūsų kilmės garantijas AST informacinėje sistemoje. Taip pat paprašysime jūsų pasirašyti dokumentų rinkinį „Dokobit\" sistemoje. Šie dokumentai automatiškai sugeneruojami pagal jūsų pateiktus duomenis. Jei kyla problemų, rašykite mums apatiniame dešiniajame kampe arba skambinkite mūsų Latvijos atstovui numeriu +371 26417883"
      },
      "ee": {
        "section1": "Sveiki atvykę",
        "section2": "Džiaugiamės, kad nusprendėte prisijungti prie „Soldera\". Jei turite papildomų klausimų, atsakymus į pagrindinius klausimus rasite čia:",
        "section3": "Jei dar negaunate kilmės garantijų",
        "section4": "Padėsime jums parengti ir pateikti visus reikalingus dokumentus kilmės garantijų gavimui. Pirmas žingsnis – įkelkite tinklo sutartį. Šis dokumentas, kurio reikalauja „Elering\", apima daugumą duomenų, reikalingų kilmės garantijoms.",
        "section5": "Įkėlus tinklo sutartį, pateiksime jūsų duomenų apžvalgą ir paprašysime trūkstamos informacijos. Jums patvirtinus visus duomenis, parengsime reikiamus dokumentus (įskaitant sutartį su mumis), paprašysime juos pasirašyti ir tada juos pateiksime „Elering\".",
        "section6": "Jei jau gaunate kilmės garantijas",
        "section7": "Jei norite, kad mes valdytume jūsų kilmės garantijų pardavimą, spustelėkite čia arba nuorodą tinklo sutarties puslapyje. Mums reikės gamybos įrenginio savininko ir pasirašančiojo duomenų. Remdamiesi šiais duomenimis, parengsime atitinkamus įgaliojimo laiškus ir sudarysime su jumis sutartį."
      }
    },
    "message_rate_limited_title": "Per daug žinučių",
    "message_rate_limited": "Per trumpą laiką išsiuntėte kelias žinutes. Prieš siųsdami kitą, palaukite valandą arba rašykite adresu support@soldera.org.",
    "new_country": {
      "ask_for_message": "Svarstome plėstis į šią šalį.",
      "ask_for_message_2": "Supaprastinkite kilmės garantijų procesą - nuo išdavimo ir ataskaitų teikimo iki pardavimo. Susisiekite su mumis, pateikdami trumpą savo elektros energijos gamybos įrenginio aprašymą, ir mes parodysime, kaip automatizuoti šias užduotis.",
      "send_message": "Siųsti žinutę",
      "message_sent": "Žinutė išsiųsta",
      "success_message": "Jūsų žinutė sėkmingai išsiųsta!",
      "error_message": "Žinutės išsiųsti nepavyko, bandykite dar kartą vėliau!",
      "placeholder": "Įveskite savo žinutę čia"
    },
    "grid_contract_upload": {
      "title": "Tinklo sutarties įkėlimas",
      "description": "Mums reikia jūsų galiojančios gamybos įrenginio tinklo sutarties, kad galėtume užpildyti ir pateikti reikiamus registracijos dokumentus.",
      "link_text": "Jei jūsų gamybos įrenginys jau gauna kilmės garantijas iš „Elering\", spustelėkite čia.",
      "upload_prompt": "Spustelėkite čia, kad įkeltumėte tinklo sutartį.",
      "supported_formats": "Šiuo metu palaikome tik .pdf formato dokumentus.",
      "existing_contract_error": "Įrenginys {eic} jau užregistruotas. {link}",
      "manage_devices_link": "Valdykite įrenginius čia.",
      "wrong_file_error": "Atrodo, kad įkėlėte failą, kuris nėra tinklo sutartis. Daugiau informacijos apie tai, kur rasti tinklo sutartis, rasite žemiau.",
      "contact_support": "Jei manote, kad tai klaida ir pateiktas dokumentas iš tikrųjų yra tinklo sutartis, susisiekite su mūsų klientų palaikymo tarnyba. Norėdami tai padaryti, spustelėkite pokalbio burbulą apatiniame dešiniajame ekrano kampe arba pasirinkite „Susisiekite su mumis\" iš viršutinio meniu.",
      "finding_contract_title": "Kur rasti tinklo sutartį?",
      "elektrilevi_contract_info": "Norėdami rasti tinklo sutartį su „Elektrilevi\"",
      "elektrilevi_contract_link_text": "spustelėkite čia, kad įeitumėte į jų e-paslaugą.",
      "vkg_contract_info": "Norėdami rasti tinklo sutartį su „VKG Elektrivõrgud\"",
      "vkg_contract_link_text": "spustelėkite čia, kad įeitumėte į jų e-paslaugą."
    },
    "multiple_upload": {
      "title": "Dokumentų įkėlimas",
      "description": "Norėdami tęsti registraciją, įkelkite šiuos dokumentus.",
      "lt_inspection_report": "VERT išduotas patikrinimo aktas",
      "lt_inspection_report_where_to_find": "Šį dokumentą galite rasti <a href=\"https://www.epaslaugos.lt/portal/service/92420/16020\" target=\"_blank\"> Elektroniniai valdžios vartai </a>",
      "lt_property_limit_scheme": "Nuosavybės ribų schemos",
      "lt_property_limit_scheme_where_to_find": "Šio dokumento ieškokite tarp gamybos įrenginio įrengimo dokumentų",
      "lt_power_of_attorney": "Įgaliojimas (pvz.: JAR ESI)",
      "lt_power_of_attorney_where_to_find": "Bet koks dokumentas, patvirtinantis jūsų teisę atstovauti susijusią įmonę. Jei gamybos įrenginys turi kelis savininkus, įgaliojimas turi būti pasirašytas visų savininkų.",
      "where_to_find_this_document": "Kur rasti šį dokumentą?",
      "lt_invalid_power_of_attorney": "Prašome įkelti galiojantį įgaliojimą",
      "UF_lv_document_of_device_auxiliaries": "Įrenginio pagalbinių sistemų dokumentas",
      "UF_lv_document_of_device_auxiliaries_where_to_find": "Šiame dokumente turi būti pateikta informacija apie visas pagalbines sistemas ar įrangą, palaikančią jūsų gamybos įrenginio veikimą",
      "UF_lv_grid_connection_scheme": "Tinklo prijungimo schema",
      "UF_lv_grid_connection_scheme_where_to_find": "Šį dokumentą turite gauti iš savo tinklo operatoriaus (PSO arba SSO). Jame parodoma, kaip jūsų gamybos įrenginys prijungtas prie tinklo ir nurodyti atitinkami matavimo taškai",
      "UF_lv_power_of_attorney": "Įgaliojimas",
      "UF_lv_power_of_attorney_where_to_find": "Gamybos įrenginio savininko(-ų) pasirašytas įgaliojimas (tuo atveju, jei Sąskaitos turėtojas nėra savininkas arba nėra vienintelis gamybos įrenginio savininkas)"
    },
    "add_generator_component": {
      "title": "Generatoriaus informacija",
      "subsidy_title": "Generatoriaus valstybinės subsidijos",
      "subsidy_question": "Ar šis generatorius gavo valstybės subsidiją?",
      "elering_support": "„Elering\" gamybos parama",
      "battery_section_title": "Saugojimo įrenginys (Baterija)",
      "battery_question": "Ar generatorius susijęs su saugojimo įrenginiu?",
      "battery_details": "Įveskite saugojimo įrenginio duomenis",
      "unit_power": "Vieneto galia (kW)",
      "capacity": "Talpa (kWh)",
      "ppa_section_title": "Tiesioginio pirkimo sutartis (PPA)",
      "ppa_question": "Ar generatoriaus elektra parduodama pagal ilgalaikę tiesioginio pirkimo sutartį (PPA)?",
      "ppa_include_certificates_question": "Ar ši PPA apima kilmės garantijų pardavimą?",
      "ppa_details": "Įveskite PPA duomenis",
      "ppa_start_date": "Pradžios data",
      "ppa_mwh": "@:common.mwh",
      "ppa_client_name": "Kliento įmonės pavadinimas",
      "ppa_country": "Šalis",
      "enter_subsidies": "Įveskite subsidijas",
      "add_subsidy": "Pridėti subsidiją",
      "device_technology_title": "Įrenginio technologija",
      "device_technology_description": "Pasirinkite įrenginio technologiją",
      "device_technology_solar": "Saulės energija",
      "device_technology_wind": "Vėjo energija",
      "device_technology_hydro": "Hidroenergija",
      "device_technology_mixed": "Skirtingos technologijos viename matavimo taške"
    },
    "add_subsidy_component": {
      "subsidy_provider": "Subsidijos teikėjas",
      "decision_date": "Sprendimo data",
      "subsidy_plan": "Subsidijos planas",
      "amount": "Suma",
      "placeholder_provider": "Pvz.: Kredex, PRIA",
      "placeholder_plan": "Pvz.: Diversifikavimo parama",
      "investment": "Investicinė parama",
      "objective": "Valstybės pagalbos tikslas",
      "placeholder_number": "Pvz.: 1234567890",
      "placeholder_objective": "Pvz.: Atsinaujinanti energija",
      "production": "Gamybos parama",
      "select_type": "Pasirinkite paramos tipą",
      "subsidy_number": "Paramos schemos numeris",
      "subsidy_type": "Paramos schemos tipas"
    },
    "contact_review_component": {
      "signer_title": "Pasirašiusiojo asmens duomenys",
      "generator_owner_title": "Gamybos įrenginio savininko duomenys",
      "generator_owner_subtext": "Įveskite gamybos įrenginio savininko duomenis tiksliai taip, kaip jie nurodyti tinklo sutartyje. Savininkas gali būti jūs arba jūsų įmonė.",
      "select_company": "Pasirinkti savininką",
      "add_new_company": "Naujas savininkas"
    },
    "role_selection": {
      "title": "Pasirinkite savo vaidmenį",
      "subtitle": "Pradėdami pasirinkite, kuris kelias geriausiai atitinka jūsų poreikius",
      "corporate_title": "Esu įmonė",
      "corporate_perfect_if": "Puikiai tinka, jei:",
      "corporate_benefit1": "Reikia AI pagrįstos ESG/CBAM/CSRD ir SBTi ataskaitų automatizacijos",
      "corporate_benefit2": "Norite įsigyti atsinaujinančią energiją (EAC) tiesiogiai iš gamintojų geriausiais kainomis",
      "corporate_benefit3": "Norite sumažinti atitikties sąnaudas daugiau nei 50%",
      "corporate_benefit4": "Reikia centralizuotų daugiavalstybinių audito ataskaitų",
      "producer_title": "Esu energijos gamintojas",
      "producer_perfect_if": "Puikiai tinka, jei:",
      "producer_benefit1": "Turite ar valdote vėjo, saulės, hidro arba biomasės įrenginius",
      "producer_benefit2": "Norite maksimaliai padidinti pajamas iš Kilmės garantijų (KG)",
      "producer_benefit3": "Reikia automatizuotos registro valdymo ir prekybos",
      "producer_benefit4": "Norite stabilizuoti pajamas pasitelkiant forward pardavimus",
      "help_title": "Nežinote, kuris kelias jums tinkamas?",
      "help_description": "Turite mišrų atvejį? Įmonė su šiek tiek gamybos? Tiesiog papasakokite mums apie savo įmonę ir padėsime pasirinkti tinkamą kelią.",
      "help_button": "Padėkite man nuspręsti",
      "help_form_label": "Papasakokite apie savo įmonę",
      "help_form_placeholder": "Pavyzdžiui: 'Esame gamybos įmonė su 2 MW stogo saulės baterijų. Daugiausia mums reikia atitikties pagalbos, bet taip pat norime valdyti savo nedidelę gamybą.'",
      "help_submit": "Siųsti užklausą",
      "help_success": "Dėkojame! Netrukus susisieksime su jumis, kad padėtume pasirinkti tinkamą kelią."
    },
    "corporate": {
      "title": "Įmonės registracija",
      "rate_limit_error": "Pasiektas įmonių kūrimo limitas. Jei prijungiate didelį portfelį, susisiekite su {supportEmail}.",
      "description": "Automatizuokite ESG/CBAM/CSRD atitiktį su AI ir įsigykite EAC tiesiogiai iš atsinaujinančios energijos gamintojų",
      "form_title": "Įmonės informacija",
      "company_name": "Įmonės pavadinimas",
      "registry_code": "Įmonės kodas",
      "address": "Adresas",
      "phone_number": "Telefono numeris",
      "vat": "PVM mokėtojo kodas",
      "vat_optional": "Neprivaloma",
      "country": "Šalis",
      "select_country": "Pasirinkite šalį",
      "submit": "Užbaigti registraciją",
      "platform_agreement_checkbox_label": "Spustelėdami Sutinku, sutinkate su {link}."
    },
    "international": {
      "submit": "Pateikti",
      "confirmation_title": "Dėkojame, kad užsiregistravote!",
      "confirmation_message": "Mūsų komanda netrukus su jumis susisieks, kad užbaigtų jūsų paskyros nustatymą.",
      "duplicate_company_error": "Įmonė su šiuo registracijos kodu jau egzistuoja šioje šalyje. Mūsų komanda su jumis susisieks, kad užbaigtų registraciją."
    },
    "generator_license_review": {
      "title": "Gamybos įrenginio licencijos numeris",
      "description": "Raskite licencijos numerį, susijusį su jūsų gamybos įrenginio gamybos arba plėtros leidimu.",
      "directions": "Norėdami rasti licencijos numerį, ieškokite <a href=\"https://www.licencijavimas.lt/lis-epp-app/public/licenceSearch\" target=\"_blank\">Licencijų informacinė sistema.</a>.",
      "licenseHints": "Galimi licencijos numeriai iš Litgrid"
    },
    "user_type": {
      "select_title": "Pasirinkite savininko tipą",
      "select_description": "Prašome pasirinkti, ar registruojate įrenginį kaip privatus asmuo, ar kaip įmonė.",
      "private": {
        "button": "Registruotis kaip privatus asmuo",
        "description": "Pasirinkite šį variantą, jei registruojate savo namų saulės elektrines ar kitus asmeninius atsinaujinančios energijos įrenginius."
      },
      "company": {
        "button": "Registruotis kaip įmonė",
        "description": "Pasirinkite šį variantą, jei registruojate įmonės ar organizacijos, kuriai priklauso atsinaujinančios energijos įrenginiai, vardu."
      },
      "selection_prefix": "Jūs pasirinkote:",
      "selected_private": "Registruotis kaip privatus asmuo",
      "selected_company": "Registruotis kaip įmonė"
    },
    "pl": {
      "authorization": {
        "title": "Ar jau turite kilmės garantijų?",
        "description": "Siekdami pritaikyti jūsų patirtį ir užtikrinti geriausią paslaugą, prašome pranešti apie jūsų dabartinį statusą su kilmės garantijomis.",
        "add_authorization": "Taip, turiu kilmės garantijų.",
        "add_authorization_description": "Turite esamų kilmės garantijų ir norite suteikti Soldera įgaliojimą jas valdyti.",
        "not_sure": "Nesu tikras dėl savo statuso.",
        "contact_support": "Susisiekti su palaikymu"
      }
    },
    "contract_review_component": {
      "data_review_title": "Duomenų peržiūra",
      "data_review_subtext": "Paskutinį kartą peržiūrėkite, ar visi duomenys įvesti teisingai",
      "data_signer_title": "Pasirašiusiojo asmens duomenys",
      "data_company_title": "Gamybos įrenginio savininko duomenys",
      "data_generator_title": "Gamybos įrenginio duomenys",
      "documents_review_title": "Dokumentų peržiūra",
      "documents_review_subtext": "Kitame puslapyje paprašysime jūsų pasirašyti dokumentų rinkinį „Dokobit\" sistemoje. Dokumentai automatiškai sugeneruojami pagal jūsų duomenis. Čia pateikiama dokumentų, laukiančių pasirašymo, apžvalga:",
      "self_uploaded_file_text": "Tai dokumentas, kurį anksčiau įkėlėte. Jis bus įtrauktas į pasirašymo voką.",
      "documents_signed": "Pasirašytas dokumentas",
      "documents_remaining": "Liko pasirašyti {count} dokumentai",
      "ee": {
        "origin_certificate_account_application_title": "Prašymas atidaryti kilmės garantijų sąskaitą",
        "origin_certificate_account_application_description": "Dokumentas, kuriuo išreiškiamas noras atidaryti kilmės garantijų sąskaitą su „Elering\". Šis dokumentas taip pat suteikia teisę „Soldera\" valdyti šiuos sertifikatus.",
        "type_conditions_title": "Standartinės kilmės garantijų naudojimo sąlygos",
        "type_conditions_description": "Standartinės sąlygos ir taisyklės, kurias „Elering\" nustatė kilmės garantijų rinkoje.",
        "authorization_application_title": "Prašymas dėl kilmės garantijų sąskaitos įgaliojimo",
        "authorization_application_description": "Dokumentas, kuriuo išreiškiamas noras įgalioti „Soldera\" valdyti kilmės garantijas „Elering\" informacinėje sistemoje.",
        "investment_support_confirmation_title": "Investicijų paramos gavimo / atmetimo patvirtinimo laiškas",
        "investment_support_confirmation_description": "Dokumentas, patvirtinantis „Elering\" jūsų gamybos įrenginiui suteiktas subsidijas.",
        "network_contract_title": "Tinklo sutartis",
        "network_contract_description": "Jūsų įkelta tinklo sutartis, kurios reikalauja „Elering\" jūsų gamybos įrenginio registravimui.",
        "device_registration_form_title": "Įrenginio registracijos forma",
        "device_registration_form_description": "„Elering\" reikalaujama forma jūsų gamybos įrenginio duomenims pateikti.",
        "soldera_membership_agreement_title": "„Soldera\" platformos sutartis",
        "soldera_membership_agreement_description": "Sutartis tarp jūsų ir „Soldera\", kuria nustatomos bendradarbiavimo sąlygos.",
        "elering_data_title": "„Elering\" duomenys",
        "elering_data_description": "Dokumentas, skirtas jūsų duomenims pateikti „Elering\", kad būtų palengvinta gamybos įrenginio registracija."
      },
      "lv": {
        "lv_account_authorization_form_title": "Prašymas dėl kilmės garantijų sąskaitos įgaliojimo",
        "lv_account_authorization_form_text": "Dokumentas, kuriuo išreiškiamas noras įgalioti „Soldera\" valdyti kilmės garantijas. Šis dokumentas suteikia „Soldera\" prieigą prie jūsų kilmės garantijų AST informacinėje sistemoje.",
        "lv_soldera_membership_agreement_title": "„Soldera\" platformos sutartis",
        "lv_soldera_membership_agreement_text": "Sutartis tarp jūsų ir „Soldera\", kuria nustatomos bendradarbiavimo sąlygos. Reikalinga, jei ankstesnė sutartis nebuvo sudaryta. Apima nuorodas į „Soldera\" privatumo politiką, prekybos taisykles ir pagrindines sąlygas, kurios pateikiamos „Soldera\" svetainėje.",
        "lv_new_device_application_text": "Gamybos įrenginio registracijos forma su nepriklausomo akredituoto gamybos auditoriaus patvirtinta informacija",
        "lv_new_device_application_title": "Gamybos įrenginio registracijos forma",
        "lv_ast_terms_and_service_title": "AST terminai ir paslaugos",
        "lv_ast_terms_and_service_text": "AST informacinės sistemos terminai ir sąlygos.",
        "lv_soldera_account_holder_registration_form_title": "Grexel sąskaitos turėtojo registracijos forma",
        "lv_soldera_account_holder_registration_form_text": "Dokumentas, kuriuo išreiškiamas noras registruotis kaip sąskaitos turėtojui Grexel sistemoje. Šis dokumentas suteikia Soldera prieigą prie jūsų kilmės garantijų AST informacinėje sistemoje."
      },
      "lt": {
        "lt_request_for_go_contract_title": "Prašymas dėl kilmės garantijų paslaugos sutarties sudarymo",
        "lt_request_for_go_contract_description": "Dokumentas, kuriuo išreiškiamas noras sudaryti sutartį su „Litgrid\" dėl kilmės garantijų sąskaitos atidarymo.",
        "lt_soldera_membership_agreement_title": "„Soldera\" platformos sutartis",
        "lt_soldera_membership_agreement_text": "Sutartis tarp jūsų ir „Soldera\", kuria nustatomos bendradarbiavimo sąlygos. Reikalinga, jei ankstesnė sutartis nebuvo sudaryta. Apima nuorodas į „Soldera\" privatumo politiką, prekybos taisykles ir pagrindines sąlygas, kurios pateikiamos „Soldera\" svetainėje.",
        "lt_authotization_application_title": "Prašymas dėl kilmės garantijų sąskaitos įgaliojimo",
        "lt_authorization_application_text": "Dokumentas, išreiškiantis norą įgalioti Soldera valdyti kilmės garantijas Litgrid informacinėje sistemoje.",
        "lt_litgrid_terms_service_title": "Litgrid paslaugų teikimo sąlygos",
        "lt_litgrid_terms_service_description": "Litgrid informacinės sistemos naudojimo sąlygos.",
        "lt_device_registration_title": "Litgrid įrenginio registracijos forma",
        "lt_device_registration_description": "Dokumentas, kurio reikalauja Litgrid, kad būtų galima užregistruoti naują įrenginį."
      },
      "se": {
        "se_account_authorization_form_title": "Energimyndigheten įgaliojimo forma",
        "se_account_authorization_form_text": "Ši forma įgalioja Soldera užregistruoti jūsų paskyrą Energimyndigheten (Švedijos energetikos agentūra) ir tvarkyti jūsų kilmės garantijas.",
        "se_access_cesar_freja_eid_authorization_application_title": "Prašymas dėl Cesar konto įgaliojimo",
        "se_access_cesar_freja_eid_authorization_application_text": "Ši forma įgalioja Soldera prieigos prie jūsų Cesar konto Energimyndigheten (Švedijos energetikos agentūra) ir tvarkyti jūsų kilmės garantijas.",
        "se_soldera_membership_agreement_title": "Soldera platformos sutartis",
        "se_soldera_membership_agreement_text": "Ši sutartis nustato jūsų narystę Soldera ir apibrėžia mūsų platformos bei paslaugų naudojimo sąlygas.",
        "se_application_for_go_title": "Kilmės garantijų paraiška",
        "se_application_for_go_text": "Paraiškos forma gamybos įrenginio registravimui kilmės garantijų gavimui Švedijos energetikos agentūroje.",
        "se_appendix_production_units_title": "Gamybos vienetų priedas",
        "se_appendix_production_units_text": "Išsami informacija apie jūsų gamybos vienetus, kurie bus registruojami kilmės garantijų gavimui.",
        "se_application_for_eecs_go_title": "EECS kilmės garantijų paraiška",
        "se_application_for_eecs_go_text": "Paraiška Europos energijos sertifikatų sistemos (EECS) kilmės garantijų registracijai.",
        "se_application_for_special_account_title": "Specialios paskyros paraiška",
        "se_application_for_special_account_text": "Paraiška specialios paskyros atidarymui Švedijos energetikos agentūros kilmės garantijų valdymo sistemoje.",
        "se_application_for_cesar_access_title": "Cesar sistemos prieigos paraiška",
        "se_application_for_cesar_access_text": "Paraiška prieigai prie Cesar sistemos, kuri naudojama kilmės garantijų valdymui Švedijoje."
      },
      "fi": {
        "fi_soldera_membership_agreement_title": "„Soldera\" platformos sutartis",
        "fi_soldera_membership_agreement_text": "Sutartis tarp jūsų ir „Soldera\", kuria nustatomos bendradarbiavimo sąlygos. Reikalinga, jei ankstesnė sutartis nebuvo sudaryta. Apima nuorodas į „Soldera\" privatumo politiką, prekybos taisykles ir pagrindines sąlygas, kurios pateikiamos „Soldera\" svetainėje.",
        "fi_authorization_application_title": "Prašymas dėl kilmės garantijų sąskaitos įgaliojimo",
        "fi_authorization_application_text": "Dokumentas, kuriuo išreiškiamas pageidavimas įgalioti „Solderą\" valdyti kilmės garantijas.",
        "fi_transfer_application_title": "Kilmės garantijų sąskaitos perkelimo paraiška",
        "fi_transfer_application_text": "Dokumentas, kuriuo išreiškiamas pageidavimas perkelti kilmės garantijų sąskaitą į „Soldera\"."
      },
      "generic": {
        "soldera_membership_agreement_title": "„Soldera\" platformos sutartis",
        "soldera_membership_agreement_text": "Sutartis tarp jūsų ir „Soldera\", kuria nustatomos bendradarbiavimo sąlygos. Reikalinga, jei ankstesnė sutartis nebuvo sudaryta. Apima nuorodas į „Soldera\" privatumo politiką, prekybos taisykles ir pagrindines sąlygas, kurios pateikiamos „Soldera\" svetainėje.",
        "authorization_application_title": "Prašymas dėl kilmės garantijų sąskaitos įgaliojimo",
        "authorization_application_text": "Dokumentas, kuriuo išreiškiamas pageidavimas įgalioti „Solderą\" valdyti kilmės garantijas."
      },
      "es": {
        "es_soldera_membership_agreement_title": "Soldera platformos sutartis",
        "es_soldera_membership_agreement_text": "Ši sutartis nustato jūsų narystę Soldera ir apibrėžia mūsų platformos bei paslaugų naudojimo sąlygas.",
        "es_account_authorization_form_title": "Įgaliojimo paraiška",
        "es_account_authorization_form_text": "Šis dokumentas įgalioja Soldera tvarkyti jūsų kilmės garantijas."
      },
      "pl": {
        "pl_authorization_application_title": "Įgaliojimo prašymas",
        "pl_authorization_application_text": "Šis dokumentas įgalioja Soldera valdyti jūsų kilmės garantijas Lenkijoje.",
        "pl_soldera_membership_agreement_title": "Soldera platformos sutartis",
        "pl_soldera_membership_agreement_text": "Ši sutartis nustato jūsų narystę su Soldera ir nurodo mūsų platformos ir paslaugų naudojimo sąlygas Lenkijoje."
      }
    },
    "navsteps": {
      "next": "Kitas",
      "back": "Atgal",
      "to_signature_page": "Perskaitykite dokumentus",
      "ee": {
        "authorization": {
          "1": "Pradžia",
          "2": "Kontaktiniai duomenys",
          "3": "Sutarties peržiūra"
        },
        "new_device": {
          "1": "Tinklo sutartis",
          "2": "Generatorius",
          "3": "Kontaktiniai duomenys",
          "4": "Sutarties peržiūra"
        }
      },
      "lv": {
        "new_device": {
          "1": "Pradžia",
          "2": "Paskyros duomenys",
          "3": "Įrenginio dokumentai",
          "4": "Įrenginio duomenys",
          "5": "Įmonės informacija",
          "6": "Pasirašymas"
        },
        "authorization": {
          "1": "Paskyros duomenys",
          "2": "Pasirašymas",
          "3": "Pasirašymas"
        },
        "step1": "Sveiki",
        "step2": "Kontaktinė informacija"
      },
      "lt": {
        "choose_onboarding": "Reg. tipas",
        "contact_review": "Kontaktai",
        "multiple_upload": "@:common.documents",
        "generator_license": "Licencija",
        "contract_review": "Pasirašymas"
      },
      "se": {
        "step1": "Pradžia",
        "authorization": {
          "contact_review": "Kontaktiniai duomenys",
          "contract_review": "Sutarties peržiūra"
        },
        "new_device": {
          "contact_review": "Kontaktiniai duomenys",
          "generator_review": "Generatoriaus duomenys",
          "contract_review": "Sutarties peržiūra",
          "grid_review": "Tinklo operatoriaus duomenys"
        },
        "contract_review": "Sutarties peržiūra"
      },
      "fi": {
        "flow_selection": "Lietuvių kalba",
        "contact_details": "Kontaktai",
        "contract_review": "Pasirašymas"
      },
      "default": {
        "contact_review": "Kontaktai",
        "contract_review": "Pasirašymas"
      },
      "es": {
        "step1": "Sveiki atvykę",
        "step2": "Kontaktinė informacija",
        "step3": "Sutarties peržiūra",
        "authorization": {
          "1": "Pradžia",
          "2": "Paskyros duomenys",
          "3": "Pasirašymas"
        }
      },
      "pl": {
        "step1": "Sveiki atvykę",
        "step2": "Kontaktinė informacija",
        "step3": "Sutarties peržiūra",
        "authorization": {
          "1": "Pradėti",
          "2": "Paskyros duomenys",
          "3": "Pasirašymas"
        }
      }
    },
    "lv": {
      "authorization": {
        "title": "Ar anksčiau gaminote kilmės garantijas?",
        "description": "„Soldera\" yra automatizuotas kilmės garantijų pardavimo agentas. Norėdami maksimaliai padidinti savo kilmės garantijų pajamas su „Soldera\", atlikite toliau pateiktą pasirinkimą",
        "add_authorization": "Aš anksčiau gaminau kilmės garantijas",
        "create_new_account": "Atidarykite naują Kilmės garantijų sąskaitą AST",
        "create_new_account_description": "Pasirinkite šią parinktį, jei negaunate Kilmės garantijų ir norite užregistruoti naują įrenginį AST informacinėje sistemoje.",
        "add_authorization_description": "Pasirinkite šią parinktį, jei jau gaunate Kilmės garantijas ir norite įgalioti Soldera jas valdyti. Vėliau galėsime padėti jums užregistruoti daugiau įrenginių AST.",
        "not_sure": "Nesate tikri?",
        "contact_support": "Susisiekite su mūsų pagalbos komanda",
        "existing_account_title": "Užregistruoti naują įrenginį esamam savininkui",
        "alternative_instructions": "Jei norite atidaryti naują sąskaitą įrenginio savininkui, kurio dar neužregistravote Soldera, vadovaukitės toliau pateiktomis instrukcijomis."
      },
      "do_you_have_subsidy": "Ar gavote arba gaunate valstybės pagalbą?",
      "generator_review": {
        "device_address": {
          "title": "Gamybos įrenginio adresas"
        },
        "device_eic": {
          "title": "Skaitiklio ID (EIC kodas)"
        },
        "device_grid_operator": {
          "options": {
            "grid_operator_dso": "SSO tinklas",
            "grid_operator_tso": "PSO tinklas"
          },
          "title": "Tinklo prijungimas"
        },
        "device_name": {
          "title": "Gamybos įrenginio pavadinimas"
        },
        "device_power": {
          "title": "Įrengta galia (kW)"
        },
        "device_power_in_permit": {
          "title": "Sistemos operatoriaus leidime nurodyta galia (kW)"
        },
        "device_technology": {
          "options": {
            "device_technology_hydro": "Hidro",
            "device_technology_solar": "Saulės",
            "device_technology_wind": "Vėjo"
          },
          "title": "Technologija"
        },
        "grid_contract_start_date": {
          "title": "Pirmoji eksploatacijos pradžios data"
        },
        "lat": {
          "title": "@:ecolabels.table.latitude"
        },
        "lng": {
          "title": "@:ecolabels.table.longitude"
        },
        "only_device_output": {
          "title": "Skaitiklis atitinka grynosios elektros energijos išvestį"
        }
      }
    },
    "lt": {
      "authorization": {
        "title": "Ar jau turite kilmės garantijas?",
        "description": "Kad galėtume pritaikyti jūsų patirtį, mums reikia žinoti, ar jau gaunate kilmės garantijas. Tai padės mums nustatyti jums tinkamiausius tolesnius žingsnius.",
        "add_authorization": "Taip, turiu kilmės garantijas.",
        "add_authorization_description": "Pasirinkite šią parinktį, jei jau gaunate kilmės garantijas ir norite įgalioti „Soldera\" jas valdyti. Vėliau galėsime padėti jums užregistruoti daugiau įrenginių Litgrid sistemoje.",
        "create_new_account": "Ne, neturiu kilmės garantijų.",
        "create_new_account_description": "Pasirinkite šią parinktį, jei negaunate kilmės garantijų ir norite užregistruoti naują įrenginį „Litgrid\" informacinėje sistemoje.",
        "not_sure": "Nesate tikri?",
        "contact_support": "Susisiekite su mūsų pagalbos komanda dėl pagalbos",
        "existing_account_title": "Registruoti naują įrenginį esamam savininkui",
        "alternative_instructions": "Jei norite atidaryti naują paskyrą įrenginio savininkui, kurio dar nesate užregistravę Soldera sistemoje, vadovaukitės žemiau pateiktomis instrukcijomis."
      },
      "extra_info": {
        "title": "Papildoma informacija apie įmonę",
        "description": "Prašome pateikti šią Litgrid reikalaujamą informaciją."
      }
    },
    "se": {
      "authorization": {
        "title": "Ar anksčiau gaminote kilmės garantijas?",
        "description": "Soldera yra automatizuotas kilmės garantijų pardavimo agentas. Norėdami maksimaliai padidinti savo pajamas iš kilmės garantijų su Soldera, pasirinkite žemiau.",
        "add_authorization": "Aš gaunu EECS kilmės garantijas",
        "create_new_account": "Atidaryti naują kilmės garantijų sąskaitą Švedijos energetikos agentūroje",
        "create_new_account_description": "Pasirinkite šią parinktį, jei negaunate kilmės garantijų ir norite užregistruoti naują įrenginį Švedijos energetikos agentūros informacinėje sistemoje.",
        "add_authorization_description": "Pasirinkite šią parinktį, jei gaunate EECS kilmės garantijas ir norite įgalioti Soldera jas tvarkyti. Vėliau galėsime padėti jums užregistruoti daugiau įrenginių Švedijos energetikos agentūroje.",
        "not_sure": "Nesate tikri?",
        "contact_support": "Susisiekite su mūsų palaikymo komanda pagalbos",
        "existing_account_title": "Registruoti naują įrenginį esamam savininkui",
        "alternative_instructions": "Jei norite atidaryti naują sąskaitą įrenginio savininkui, kurio dar neužregistravote Soldera, vadovaukitės žemiau pateiktomis instrukcijomis.",
        "add_eecs_conversion": "Aš gaunu nacionalines kilmės garantijas",
        "add_eecs_conversion_description": "Pasirinkite šią parinktį, jei gaunate nacionalines kilmės garantijas ir norite vietoje jų pradėti gauti EECS kilmės garantijas (Europos perkeliamas kilmės garantijas)."
      },
      "generator_review": {
        "basic_information": "Pagrindinė informacija",
        "metering_information": "Matavimo informacija",
        "investment_support": "Investicinė parama",
        "device_name": {
          "title": "Įrenginio pavadinimas"
        },
        "device_power": {
          "title": "Instaliuota galia (kW)",
          "description": "Įveskite įdiegto įrenginio galią kW"
        },
        "grid_area_id": {
          "title": "Tinklo zonos ID",
          "description": "Įveskite tinklo zonos ID (trys raidės arba 'IKN')"
        },
        "grid_production_device_id": {
          "title": "Gamybos įrenginio ID",
          "description": "Įveskite unikalų 18 simbolių gamybos įrenginio ID"
        },
        "grid_eidel_id": {
          "title": "Ediel ID",
          "description": "Įveskite ID numerį, skirtą bendravimui su Svenska Kraftnät"
        },
        "device_power_in_permit": {
          "title": "Įrenginio galia leidime (MW)"
        },
        "device_eic": {
          "title": "Įrenginio EIC kodas"
        },
        "only_device_output": {
          "title": "Tik įrenginio išvestis"
        },
        "device_address": {
          "title": "Įrenginio adresas"
        },
        "lat": {
          "title": "@:ecolabels.table.latitude"
        },
        "lng": {
          "title": "@:ecolabels.table.longitude"
        },
        "device_grid_operator": {
          "title": "Tinklo operatorius",
          "grid_operator_tso": "TSO",
          "grid_operator_dso": "DSO"
        },
        "grid_contract_start_date": {
          "title": "Tinklo sutarties pradžios data"
        },
        "postal_address": {
          "title": "Pašto adresas",
          "description": "Įveskite pilną gatvės adresą"
        },
        "postal_code": {
          "title": "Pašto kodas",
          "description": "Įveskite pašto kodą"
        },
        "city": {
          "title": "Miestas",
          "description": "Įveskite miesto pavadinimą"
        },
        "company_address": "Įmonės adresas",
        "invoice_address": "Sąskaitos adresas",
        "same_as_company_address": "Sąskaitos adresas sutampa su įmonės adresu",
        "production_unit": "Gamybos vieneto informacija",
        "cesar_application": "Cesar paraiška",
        "go_application": "Kilmės garantijų paraiška",
        "investment_support_question": "Ar šis gamybos vienetas gavo investicinę paramą?",
        "investment_support_options": {
          "yes": "Taip",
          "no": "Ne",
          "do_not_know": "Nežinau"
        },
        "property_designation": {
          "title": "Turto žymėjimas",
          "description": "Įveskite turto žymėjimą"
        },
        "technology": {
          "title": "Technologija",
          "description": "Pasirinkite gamybos technologiją",
          "options": {
            "BTN_Land based": "Sausumos vėjo energija",
            "BTN_Ocean based": "Jūros vėjo energija",
            "BTN_Sun": "Saulės energija",
            "BTN_Water": "Hidroenergija",
            "BTN_Thermal": "Šiluminė energija"
          }
        },
        "thermal_subtype": {
          "title": "Šiluminės energijos technologijos tipas",
          "description": "Pasirinkite konkretų šiluminės energijos technologijos tipą",
          "options": {
            "BTN_Industrial back pressure": "Pramoninis priešslėgis",
            "BTN_Condensing power": "Kondensacinė energija",
            "BTN_Gas engine": "Dujų variklis"
          }
        },
        "thermal_is_chp": {
          "title": "Ar tai CHP įrenginys?",
          "description": "Pažymėkite, jei tai yra kombinuoto šilumos ir energijos (CHP) įrenginys"
        },
        "holding_percentage": {
          "title": "Valdymo procentas",
          "description": "Įveskite savo valdymo procentinę dalį"
        },
        "metering_location": {
          "title": "Matavimo vieta",
          "description": "Pasirinkite, kur atliekami gamybos matavimai",
          "options": {
            "Directly_after_generator": "Iškart po generatoriaus",
            "After_auxiliary_equipment": "Po pagalbinės įrangos",
            "After_net_pumping_equipment": "Po grynojo siurbimo įrangos",
            "Directly_before_grid_connection": "Iškart prieš tinklo prijungimą"
          }
        },
        "commissioning_date": {
          "title": "Eksploatacijos pradžios data",
          "description": "Įveskite eksploatacijos pradžios datą"
        },
        "correction_factor_info": {
          "title": "Korekcijos koeficientas",
          "description": "Bus deklaruojamas standartinis korekcijos koeficientas. Jei įrengta galia viršija 10 MW, kreipkitės į pagalbos tarnybą, kad deklaruotumėte individualų korekcijos koeficientą"
        },
        "grid_owner_name": {
          "title": "Tinklo operatoriaus pavadinimas",
          "description": "Įveskite tinklo operatoriaus įmonės pavadinimą"
        },
        "grid_owner_corporate_id": {
          "title": "Tinklo operatoriaus įmonės kodas",
          "description": "Įveskite tinklo operatoriaus įmonės registracijos kodą"
        },
        "invoice_co_address": {
          "title": "C/O Sąskaitos faktūros adresas",
          "description": "Įveskite sąskaitos faktūros C/O adresą (jei reikia)"
        },
        "invoice_contact_telephone": {
          "title": "Konkrečios sąskaitos faktūros kontakto telefono numeris",
          "description": "Įveskite arve kontaktinio asmens telefono numerį"
        },
        "invoice_email": {
          "title": "Sąskaitos faktūros el",
          "description": "Įveskite el. pašto adresą, kuriuo bus siunčiama arve"
        },
        "specific_name": {
          "title": "Sąskaitos faktūros konkretaus kontaktinio asmens pavadinimas",
          "description": "Įveskite konkretaus kontaktinio asmens pavadinimą"
        },
        "reference_number": {
          "title": "Sąskaitos faktūros nuorodos numeris",
          "description": "Įveskite sąskaitos faktūros nuorodos numerį"
        },
        "invoice_country": {
          "title": "Sąskaitos faktūros šalis",
          "description": "Įveskite sąskaitos faktūros šalies kodą"
        },
        "investment_support_amount": {
          "title": "Investicinės paramos suma",
          "description": "Įveskite gautą investicinės paramos sumą"
        },
        "investment_support_date": {
          "title": "Investicinės paramos data",
          "description": "Įveskite datą, kada gauta investicinė parama"
        },
        "grid_metered_by_hour": {
          "title": "Tinklas matuojamas valandomis",
          "description": "Pasirinkite, ar tinklas matuojamas valandomis"
        },
        "grid_concession": {
          "title": "Tinklo koncesija",
          "description": "Pasirinkite, ar galioja tinklo koncesija"
        }
      }
    },
    "fi": {
      "flow_selection": {
        "title": "Pridėti naują įmonę",
        "choose_onboarding": "Pasirinkite onboarding",
        "description": "Pasirinkite perkėlimo parinktį, jei registre jau yra gamybos įrenginių. Jei registruotų prietaisų neturite, susisiekite su mumis ir aptarsime jūsų galimybes.",
        "not_sure": "Reikia pagalbos?",
        "contact_support": "Susisiekite su mūsų palaikymo komanda",
        "transfer": {
          "title": "Gamybos įrenginių perkėlimas į „Soldera\"",
          "description": "Jūsų gamybos įrenginius perkelsime į savo registro paskyrą ir juos valdysime už jus."
        },
        "authorization": {
          "title": "Suteikite „Solderai\" prieigą prie savo paskyros registre",
          "description": "Mes turėsime prieigą prie jūsų paskyros registre ir tvarkysime sertifikatus už jus. Sertifikatai lieka jūsų paskyroje."
        }
      },
      "quickfill": {
        "search": "„Fingrid\" jau registruotos įmonės paieška",
        "search_placeholder": "Įmonės paieška „Fingrid\"",
        "error": "Nepavyko įkelti įmonių",
        "quickfill_helper": "Greitas pildymas su „Fingrid\" jau registruota įmone",
        "manual_entry": "Įveskite duomenis rankiniu būdu"
      }
    },
    "fallback": {
      "flow_selection": {
        "title": "Pridėti naują įmonę",
        "intro": "„Soldera\" yra pirmoji kilmės garantijų valdymo platforma. Optimizuokite pelningumą ir sumažinkite administracinio darbo krūvį. Aptarnauja pramonės lyderius ir tūkstančius atsinaujinančiosios energijos gamybos padalinių visoje Europoje.",
        "description": "Pasirinkite autorizavimo parinktį, jei registre jau yra gamybinių įrenginių. Jei registruotų prietaisų neturite, susisiekite su mumis ir aptarsime jūsų galimybes.",
        "not_sure": "Reikia pagalbos?",
        "contact_support": "Susisiekite su mūsų palaikymo komanda",
        "authorization": {
          "title": "Įgaliokite „Soldera\" valdyti jūsų gamybos įrenginius",
          "description": "Už jus valdysime jūsų gamybos įrenginius."
        }
      }
    },
    "es": {
      "authorization": {
        "title": "Ar jau turite kilmės garantijų?",
        "description": "Kad galėtume pritaikyti jūsų patirtį, mums reikia žinoti, ar jau gaunate kilmės garantijas. Tai padės mums nustatyti jums tinkamiausius tolesnius žingsnius.",
        "add_authorization": "Taip, turiu kilmės garantijas.",
        "add_authorization_description": "Pasirinkite šią parinktį, jei jau gaunate kilmės garantijas ir norite įgalioti Soldera jas tvarkyti.",
        "create_new_account": "Ne, neturiu kilmės garantijų.",
        "create_new_account_description": "Pasirinkite šią parinktį, jei negaunate kilmės garantijų ir norite užregistruoti naują įrenginį registro informacinėje sistemoje.",
        "not_sure": "Nesate tikri?",
        "contact_support": "Susisiekite su mūsų palaikymo komanda pagalbos",
        "existing_account_title": "Registruoti naują įrenginį esamam savininkui",
        "alternative_instructions": "Jei norite atidaryti naują sąskaitą įrenginio savininkui, kurio dar neužregistravote Soldera, vadovaukitės žemiau pateiktomis instrukcijomis."
      },
      "extra_info": {
        "title": "Papildoma informacija apie įmonę",
        "description": "Prašome pateikti šią registro reikalaujamą informaciją."
      }
    }
  },
  "bulk_buy": {
    "upload_description": "Įkelkite dokumentus, kad išgautumėte įmonės duomenis ir atšaukimo reikalavimus",
    "upload_description_new": "Įkelkite tvarumo ataskaitą ir vartojimo duomenis. AI užpildys visus laukus už jus.",
    "quick_info": "Greita informacija",
    "upload_hint": "Įkelkite vieną ar kelis dokumentus, kad automatiškai išgautumėte įmonės duomenis",
    "manual_add_hint": "Arba pridėkite įmones rankiniu būdu, užpildydami tuščią eilutę apačioje",
    "purchase_settings": "Pirkimo nustatymai",
    "overview": "Apžvalga",
    "purchase_mode": {
      "CHEAPEST": "Pigiausias",
      "GHG": "GHG",
      "RE100": "RE100",
      "ADVANCED": "Premium parinktys",
      "OTHER": "Kita"
    },
    "ghg_description": "SBTi, ERI, CDB",
    "re100_description": "Vėjas + Saulė, COD ≤ 15 metų",
    "cheapest_description": "Ekonomiškiausios parinktys",
    "premium_description": "Pasirinktiniai pirkimo reikalavimai",
    "go_source": "EAC šaltinis",
    "technology": "Technologija",
    "ecolabel": "Ekologinis ženklas",
    "vintage": "Metai",
    "support": "Paramos statusas",
    "cod_requirement": "COD reikalavimas",
    "matching_mode": {
      "yearly": "Metinis derinimas",
      "monthly": "Mėnesinis derinimas",
      "hourly": "24/7 valandinis derinimas (Premium)"
    },
    "destination_companies": "Gavėjai",
    "destination_companies_description": "Kiekviena eilutė reiškia įmonę, kuriai bus atliktas KG atšaukimas jos vardu.",
    "companies": "@:common.companies",
    "no_companies": "Gavėjų dar nepridėta. Įkelkite dokumentus arba pridėkite rankiniu būdu.",
    "company_name": "Gavėjas",
    "country": "Gavėjo šalis",
    "registry_code": "Įmonės ID",
    "volume": "Suvartojimas (MWh)",
    "match_origin": "Atitinka kilmę",
    "price": "Orientacinė kaina",
    "tooltip_company_name": "Juridinis asmuo, kuris bus nurodytas kaip atšaukimo pareiškimo gavėjas — šalis, reikalaujanti atsinaujinančios energijos suvartojimo.",
    "tooltip_country": "Šalis, kurioje gavėjas yra ir vartoja elektros energiją. Nustato, kur sertifikatai turi būti atšaukti.",
    "tooltip_registry_code": "Įmonės kodas — ne PVM mokėtojo kodas. Rodomas atšaukimo pareiškime.",
    "tooltip_address": "Gavėjo registruotas arba objekto adresas. Naudojamas identifikavimui atšaukimo pareiškime.",
    "tooltip_volume": "Metinis elektros energijos suvartojimas, kurį reikia padengti atsinaujinančios energijos sertifikatais, megavatvalandėmis (MWh). 1 MWh = 1 sertifikatas.",
    "tooltip_price": "Orientacinė kaina pagal dabartines rinkos kainas ir pasirinktus pirkimo parametrus — tai orientacinis, o ne įpareigojantis pasiūlymas. Spauskite 'Prašyti kainos', kad apskaičiuotumėte.",
    "eac_type": "EAC tipas",
    "tooltip_eac_type": "Sertifikatų schema, naudojama naudos gavėjo šalyje. Nustatoma automatiškai pagal šalį; šalims už mūsų registrų ribų pasirinkite patys.",
    "pricing_idle": "Neapskaičiuota",
    "rfq_notice": "Soldera atliks kainų užklausą (RFQ)",
    "global_cancellation_settings": "Bendrieji atšaukimo nustatymai",
    "period_start": "Periodo pradžia",
    "period_end": "Periodo pabaiga",
    "beneficiary_type": "Gavėjo tipas",
    "beneficiary_types": {
      "ELECTRICITY_SELLER": "Elektros pardavėjas",
      "CONSUMER": "Vartotojas",
      "CONVERSION_PLANT_OPERATOR": "Pertvarkymo stoties operatorius"
    },
    "summary": "Santrauka",
    "total_volume": "Bendras kiekis",
    "total_price": "Orientacinė bendra kaina",
    "illiquid_companies": "nė vienai įmonei kaina nebus nustatyta per RFQ | {count} įmonei kaina bus nustatyta per RFQ | {count} įmonėms kaina bus nustatyta per RFQ",
    "confirm_order": "Patvirtinti užsakymą",
    "ask_for_quotes": "Prašyti pasiūlymų",
    "cancellation_details_title": "Atšaukimo informacija",
    "beneficiary_name": "Gavėjo pavadinimas",
    "residency": "Rezidencija",
    "company_address": "Įmonės adresas",
    "address": "@:common.address",
    "cancellation_purpose": "Atšaukimo tikslas",
    "cancellation_purpose_text": "Atšaukimo tikslas",
    "operation_notes_placeholder_consumer": "Suvartojimo įrodymas",
    "operation_notes_placeholder_seller": "Elektros tiekimas",
    "cancellation_purposes": {
      "DISCLOSURE": "Atskleidimas",
      "GRID_LOSSES": "Nuostoliai tinkle",
      "SELF_CONSUMPTION": "Sunaudojimas sau",
      "SUPPORT_SCHEME": "Paramos schema",
      "OTHER": "Kita"
    },
    "operation_notes": "Pastabos",
    "confirm_title": "Patvirtinti pirkimo ir atšaukimo užsakymą",
    "order_summary": "Užsakymo santrauka",
    "illiquid_warning": "nė vienai įmonei kaina nebus nustatyta per kainų užklausą (RFQ) | {count} įmonei kaina bus nustatyta per kainų užklausą (RFQ) | {count} įmonėms kaina bus nustatyta per kainų užklausą (RFQ)",
    "total_known_price": "Bendra žinoma kaina",
    "cancellation_not_supported_title": "Atšaukimas tiesiogiai nepalaikomas",
    "cancellation_not_supported_description": "Šios įmonės yra registruose, kuriuose negalime tiesiogiai atlikti atšaukimo. Pasirinkite, kaip norėtumėte tęsti:",
    "cancellation_option_agent": "Soldera organizuoja atšaukimą vietiniame registre pilnam atitikimui",
    "cancellation_option_any_registry": "Atšaukti bet kuriame AIB registre (standartinė atšaukimo kaina)",
    "companies_with_pricing": "Įmonės su žinoma kaina ({count})",
    "confirm_and_submit": "Patvirtinti ir pateikti užsakymus",
    "quoted_pricing": "Siūlyta kaina",
    "base_price": "Bazinė kaina",
    "price_per_mwh": "Kaina už MWh",
    "no_pricing_info": "Nėra kainos informacijos šiam užsakymui",
    "cancellation_fee": "Atšaukimo mokestis",
    "minimum_cancellation_fee": "Minimalus atšaukimo mokestis",
    "brokerage_fee": "Pirkimo mokestis",
    "incl_brokerage": "įsk. €{amount}/MWh pirkimo mokestį",
    "incl_cancellation": "įsk. €{amount}/MWh atšaukimo mokestį",
    "incl_min_cancellation": "įsk. €{amount} min. atšaukimo mokestį",
    "eac_source": "EAC šaltinis",
    "matching": "Derinimas",
    "cancellation_settings": "Atšaukimo nustatymai",
    "purchase_settings_title": "Pirkimo nustatymai",
    "purchase_mode_label": "Pirkimo režimas",
    "pricing_error": "Nepavyko apskaičiuoti kainos. Bandykite dar kartą arba susisiekite su palaikymo tarnyba.",
    "volume_required": "Apimtis turi būti ne mažesnė kaip 1 MWh",
    "country_required": "Kainai apskaičiuoti reikalinga šalis",
    "intro": "Pirkite atsinaujinančios energijos sertifikatus ir panaikinkite juos savo naudos gavėjų vardu — vienu žingsniu. Pasirinkite, kaip sertifikatai bus įsigyjami, pridėkite kiekvieną naudos gavėją žemiau ir patvirtinkite.",
    "accelerator_title": "Pradėkite nuo dokumento",
    "sourcing_preference_description": "Kaip įsigyjame sertifikatus kiekvienam naudos gavėjui.",
    "sourcing_cheapest_title": "Pigiausia",
    "sourcing_cheapest_desc": "Ekonomiškiausi galimi variantai",
    "sourcing_ghg_title": "ŠESD",
    "sourcing_ghg_desc": "Atitinka SBTi, ERI ir CDP ataskaitų kriterijus",
    "sourcing_re100_title": "RE100",
    "sourcing_re100_desc": "Vėjas + saulė, COD ≤ 15 metų",
    "sourcing_other_title": "Kita",
    "sourcing_other_desc": "Aprašykite savo įsigijimo reikalavimą",
    "custom_requirement_label": "Individualus įsigijimo reikalavimas",
    "custom_requirement_placeholder": "Papasakokite, ko jums reikia — konkreti technologija, šalis, derlius, ekologiniai ženklai ar bet koks kitas įsigijimo reikalavimas. Mūsų komanda pateiks pritaikytą pasiūlymą.",
    "custom_requirement_advisory": "Individualūs reikalavimai įkainojami per kainų užklausą (RFQ) — mūsų komanda atsakys indikatyviu pasiūlymu, paprastai per vieną darbo dieną.",
    "shared_cancellation_settings": "Bendri panaikinimo nustatymai",
    "add_beneficiary": "Pridėti naudos gavėją",
    "add_another_beneficiary": "Pridėti dar vieną naudos gavėją",
    "no_beneficiaries_title": "Naudos gavėjų dar nepridėta",
    "no_beneficiaries_description": "Įkelkite dokumentą aukščiau, kad jie būtų užpildyti automatiškai, arba pridėkite pirmąjį naudos gavėją rankiniu būdu.",
    "total_consumption": "Bendras suvartojimas",
    "estimated_cost": "Orientacinės išlaidos",
    "add_at_least_one_beneficiary": "Pridėkite bent vieną naudos gavėją",
    "ask_for_quote": "Prašyti pasiūlymo",
    "fetching_quotes": "Gaunami pasiūlymai…",
    "review": "Peržiūrėti",
    "request_custom_quote": "Prašyti individualaus pasiūlymo",
    "custom_quote_reassurance": "Soldera atliks kainų užklausą (RFQ) ir atsakys indikatyviu pasiūlymu prieš ką nors perkant.",
    "manual_quote": "Kaina per RFQ",
    "by_quote": "Pagal RFQ",
    "priced_subline": "Įkainota {known} iš {total} MWh · {perMwh}/MWh",
    "rfq_reassurance": "Įkainotos eilutės pateikiamos vykdyti nurodyta kaina. Likusiems kiekiams Soldera atliks kainų užklausą (RFQ) mūsų tiekėjų tinkle ir pateiks indikatyvų pasiūlymą — paprastai per vieną darbo dieną. RFQ eilutėms niekas neperkama, kol nepatvirtinsite pasiūlymo.",
    "review_order_title": "Peržiūrėti pirkimo ir panaikinimo užsakymą",
    "average_unit_price": "Vidutinė vieneto kaina",
    "indicative_bid_note": "Visos rodomos kainos yra orientacinės, pagrįstos dabartiniu rinkos lygiu — tai nėra įpareigojantis pasiūlymas. Galutinė kaina patvirtinama vykdant užsakymą.",
    "quotes_indicative_note": "Visi pasiūlymai yra indikatyvūs — galutinė kaina patvirtinama vykdant sandorį.",
    "market_levels_as_of": "Rinkos kainų lygiai {date}",
    "quote_reference": "Nuoroda {id}",
    "quote_reference_label": "Pasiūlymo nuoroda",
    "consumption_period": "Suvartojimo laikotarpis",
    "cancellation_mode_selection_aria": "Atšaukimo būdo pasirinkimas",
    "remove_beneficiary_row_aria": "Pašalinti naudos gavėjo eilutę {index}"
  },
  "dashboard": {
    "issuance_chart": {
      "title": "Išdavimo diagrama",
      "description": "Per pastaruosius 12 mėnesių išduotos MWh kiekvienam gamybos įrenginiui.",
      "y_axis": "Išduotos MWh",
      "y_axis_log": "Išduotos MWh (logaritminė skalė)",
      "scale_absolute": "Absoliuti",
      "scale_log": "Logaritminė skalė",
      "zero_marker_note": "Logaritminė skalė negali parodyti nulio: mėnesiai be išdavimų pažymėti ✕ ant bazinės linijos.",
      "no_data": "Nėra išdavimo duomenų už pastaruosius 12 mėnesių",
      "load_failed": "Nepavyko įkelti išdavimo diagramos. Bandykite dar kartą."
    },
    "devices_in_registry": "Įrenginiai, kurie valdomi registre",
    "no_devices_in_registry": "Registre nėra įrenginių",
    "add_device_description": "Pridėkite savo pirmą įrenginį, kad pradėtumėte tvarkyti sertifikatus",
    "add_first_device": "Pridėti pirmą įrenginį",
    "add_registry_device": "Pridėti registro įrenginį",
    "add_registry_device_description": "Rankiniu būdu pridėkite naują įrenginį į savo registrą sertifikatų tvarkymui",
    "select_company": "Pasirinkite įmonę",
    "action_required": "Reikalingas veiksmas",
    "consolidated_view": "Konsoliduotas vaizdas",
    "consolidated_view_description": "Žiūrėti visas įmones kartu",
    "company_id_label": "ID: {id}",
    "market": {
      "base_price": "Bazinė kaina"
    },
    "consolidated": {
      "overview_for": "{email}",
      "devices_overview": "{count} įrenginiai su bendra galia {power} kW",
      "back_to_dashboard": "Atgal į darblapą",
      "pending_payouts": "Laukiami pinigai",
      "paid_out_30d": "Išmokėta (30 dienų)",
      "projected_production": "Projektuotas gamyba",
      "projected_production_description": "Gamybos prognozė pagal prietaiso galią",
      "projected_production_by_company": "Prognozuojama gamyba pagal bendroves",
      "projected_production_by_company_description": "Išrikiuoti pagal bendrą numatomą gamybą",
      "production_volume": "Gamybos tūris",
      "production_volume_description": "Sumos rodomos MWh vienetais",
      "production_volume_table": {
        "quarter": "Ketvirtis",
        "month": "Mėnuo",
        "monthly": "Mėnuo",
        "quarterly": "Kvartalas",
        "total": "Kokybiškai",
        "current": "Praktiskai"
      },
      "production_distribution": "Prognozuojamas gamybos šaltinių pasiskirstymas",
      "production_distribution_description": "Paskutiniai 12 mėnuo",
      "production_devices": "Įrenginio tootnės įrenginiai",
      "production_devices_description": "{deviceCount} įrenginiai {companyCount} įmonėje",
      "production_devices_table": {
        "company_name": "Įmonės",
        "total": "Kokybiškai",
        "technology": "Technologija",
        "device_count": "Įrenginiai",
        "device_name": "Pavadinimas",
        "device_id": "ID",
        "capacity": "Galia",
        "status": "Statusas",
        "no_devices": "Nėra įrenginių rodymui",
        "more_devices": "Dar {count} įrenginių",
        "view_projection": "Peržiūrėti prognozę",
        "view_breakdown": "Peržiūrėti suvestinę",
        "scheduled_transactions_tooltip": "registre sukonfigūruoti automatiniai pervedimai"
      },
      "company_filter_hint": "Pasirinkite įmones, kurių duomenis norite matyti konsoliduotoje peržiūroje",
      "selector_no_companies": "Įmonių nėra",
      "selector_all_companies": "Visos įmonės",
      "selector_countries_companies": "{countries} šalys · {companies} įmonės",
      "selector_company_count": "Įmonių nėra | {count} įmonė | {count} įmonių",
      "selector_selected_count": "Pasirinkta {selected}/{total}",
      "selector_only": "tik",
      "selector_show_only": "Rodyti tik {country}",
      "selector_remove_country": "Pašalinti {country}",
      "no_companies_selected_title": "Nepasirinkta nė viena įmonė",
      "no_companies_selected_hint": "Pasirinkite bent vieną įmonę ar šalį viršuje, kad matytumėte duomenis."
    },
    "buyer": {
      "consolidated_view": "Pirkėjo konsoliduotas vaizdas",
      "go_cancelled": "Energijos atributų sertifikatai atšaukti",
      "certificates_this_year": "sertifikatai šiais metais",
      "membership_agreement": "Platformos sutartis",
      "agree_to_terms": "Sutinku su sąlygomis",
      "terms_accepted": "Sąlygos sėkmingai priimtos",
      "manage_inventory": "Pirkti ir atšaukti",
      "platform_agreement_clickwrap_intro": "Spustelėdami Sutinku, sutinkate su {link}",
      "platform_agreement_link_text": "Soldera platformos sutartimi"
    },
    "corporate": {
      "sections": {
        "energy_attribute_certificates": "Energijos atributų sertifikatai"
      }
    },
    "companies": "@:common.companies",
    "sign_document": "Pasirašyti dokumentą",
    "continue_registration": "Tęsti registraciją",
    "add_company_or_device": "Pridėti įmonę ar įrenginį",
    "add_company_access": "Pridėti įmonės prieigą",
    "company_id": "Įmonės ID",
    "company_ids_placeholder": "Įmonės ID - vienas arba atskirtas kableliais",
    "add_company": "Pridėti įmonę",
    "internal_role": "Vidinis vaidmuo",
    "user": "Naudotojas",
    "super_admin": "Super administratorius",
    "sales_admin": "Pardavimų administratorius",
    "fee_model": "Mokėjimo modelis",
    "standard": "Standartinis",
    "special_free": "Specialus nemokamas",
    "special_5pct": "Specialus 5 %",
    "special_1eur_per_mw": "Specialus 1 €/MW",
    "registry_excluded_devices": "Į registrą neįtraukti įrenginiai (atskirti kableliais)",
    "allowed_invite_domains_label": "Leidžiami pakvietimų domenai (atskirti kableliais)",
    "allowed_invite_domains_help": "Komandos pakvietimus galima siųsti tik šių domenų el. pašto adresams. Palikite tuščią, kad būtų leidžiami visi domenai.",
    "is_test_company": "Ar tai testinė įmonė?",
    "hosted_account_regions_label": "Talpinamų sąskaitų regionai (KG gavimas)",
    "hosted_account_regions_help": "Pasirinkite, kurių šalių registro sąskaitas ši įmonė gali naudoti KG gavimui į Soldera talpinamas sąskaitas.",
    "save_changes": "Išsaugoti pakeitimus",
    "all_trackings": "Visi sekimo duomenys",
    "referrer_company_id": "Nukreipėjo ID",
    "utm_source": "UTM šaltinis",
    "utm_medium": "UTM terpė",
    "utm_term": "UTM terminas",
    "utm_content": "UTM turinys",
    "utm_campaign": "UTM kampanija",
    "created_at": "Sukurta",
    "admin_only_transfer_and_delete_company": "Tik administratoriui: perkelti visą turtą į kitą įmonę ir IŠTRINTI įmonę:",
    "transfer_to": "{name} - {id}",
    "transfer": "Perkelti",
    "nda_signed_link": "Nuoroda į NDA sutartį, kurią pasirašėme su klientu",
    "client_nda_signed_link_title": "Specialiųjų sąlygų dokumentai",
    "client_nda_signed_link": "Prašome spustelėti čia, kad pasiektumėte specialias sąlygas, pasirašytas tarp „Soldera\" ir {name}.",
    "custom_percentage": "Tinkintas procentas",
    "custom_percentage_hint": "Palaikomi tinkinti procentai nuo 5 iki 20",
    "automaticReporting": {
      "title": "Automatinis gamybos deklaravimas",
      "requiresAction": "Reikia veiksmo",
      "lastUpdated": "Paskutinį kartą atnaujinta:",
      "lastDeclaredMonth": "Paskutinis deklaruotas gamybos mėnuo:",
      "lastDeclaredAmount": "Paskutinė deklaruota suma:",
      "helpNeeded": "Mums reikia jūsų pagalbos užtikrinti, kad teisingas gamybos įrenginys ESO sistemoje būtų susietas su teisingu įrenginiu Litgrid Grexel registre.",
      "missingAssociation": "Trūksta susiejimo su matavimo tašku",
      "automaticallyDeclared": "Automatiškai deklaruota",
      "declaredFor": "Deklaruota už:",
      "amount": "Kiekis:",
      "pendingApproval": "Laukiama patvirtinimo"
    },
    "sales_transactions": {
      "title": "Sandorių istorija",
      "description": "Kilmės garantijų kainos yra nepastovios ir gali keistis kasdien. Žemiau rasite visų jūsų sandorių apžvalgą.",
      "description_link": "Objektyviam palyginimui tarp jūsų sandorių ir rinkos kainų rekomenduojame perskaityti mūsų straipsnį apie kilmės garantijų viešuosius kainų signalus.",
      "no_sales_transactions": "Ateityje čia rasite savo sandorių istoriją su pasiūlymo informacija!",
      "notificationInfo": "Kai įvyks pardavimo sandoriai, mes pranešime jums el. paštu.",
      "date": "Sandorio data",
      "item": "Prekė",
      "final_unit_price": "Vieneto kaina",
      "amount": "Kiekis",
      "offer_range": "Pasiūlymų diapazonas",
      "final_country": "Laimėjusio pasiūlymo šalis",
      "status": "Statusas",
      "processing_explanation": "Soldera laukia gauti pinigus iš sandorio partnerio. Kai pinigai bus gauti, mes pranešsime jums apie sandorį.",
      "completed": "Atliktas",
      "processing": "Apdorojimas",
      "pending_sales_details": "Pardavimo informacija laukia",
      "export_xlsx": "Eksportuoti į Excel",
      "view_aggregated": "Bendras vaizdas",
      "view_by_company": "Pagal įmonę",
      "view_by_power_plant": "Pagal elektrinę",
      "power_plant": "Elektrinė",
      "revenue": "Pajamos",
      "soldera_fees": "Soldera mokesčiai (be PVM)",
      "registry_fees": "Registro mokesčiai (be PVM)",
      "fees_pending": "Mokesčiai laukia"
    },
    "income_estimate": {
      "view_estimate": "Žiūrėti pajamų prognozę"
    },
    "companyData": {
      "automatic_sale_with_highest_offer": "Automatinis pardavimas už didžiausią pasiūlymą",
      "fresh_production_sale_above_minimum_price": "Šviežios gamybos pardavimas virš minimalios kainos {price}€/MWh",
      "modify": "Keisti",
      "money_pending": "Laukiami pinigai",
      "transaction_history": "Sandorių istorija",
      "origin_certificates": "Kilmės garantijos",
      "view_details": "Peržiūrėti detales",
      "hide_details": "Slėpti detales",
      "submit_invoice": "Pateikti sąskaitą",
      "invoice_history": "Sąskaitų istorija",
      "documents": "@:common.documents",
      "continue_authorization_creation": "Tęsti prašymą",
      "thank_you_for_joining": "Ačiū, kad prisijungėte prie „Soldera\"!",
      "thank_you_message": "Jūsų vardu kreipsimės į registrą ir atliksime visas procedūras. Dabar jums tereikia laukti, kol registras atliks savo operacijas, o mes parduosime jūsų sertifikatus. Kai pardavimas įvyks, mes jums pranešime ir paprašysime suformuoti sąskaitą faktūrą, kad galėtume pervesti pinigus.",
      "add_companies_or_devices_while_waiting": "Laukdami turite galimybę pridėti įmonių ar įrenginių",
      "add_companies_while_waiting": "Kol laukiate, galite pridėti kitą įmonę",
      "invite_a_friend": "Pakviesti draugą",
      "invite_a_friend_message": "Ar pažįstate ką nors, kas taip pat galėtų pasinaudoti „Soldera\"? 30 % nuo kiekvieno pakviesto draugo sumokėtų pirmųjų metų mokesčių gausite jūs!",
      "click_to_copy_link": "Spustelėkite čia, kad nukopijuotumėte nuorodą, kurią reikėtų siųsti draugui",
      "production_settings": "Gamybos nustatymai",
      "measurement_points": "Matavimo taškai",
      "documents_signed_with_soldera": "Dokumentai, pasirašyti su „Soldera\"",
      "other_documents": "Kiti dokumentai",
      "device_contract": "Įrenginio {deviceName} sutartis",
      "contract_between_company_and_soldera": "Sutartis tarp {companyName} ir „Soldera\"",
      "company_contract": "Sutartis su {companyName}",
      "link_copied": "Nuoroda sėkmingai nukopijuota!",
      "link_copied_fallback": "Nuoroda nukopijuota į iškarpinę (atsarginis metodas).",
      "link_copy_failed": "Nepavyko nukopijuoti nuorodos. Prašome kopijuoti ją rankiniu būdu.",
      "update_min_price_success": "Minimalios kainos atnaujinimas buvo sėkmingas!",
      "new_min_price_effective_immediately": "Nauja minimali kaina įsigalioja nedelsiant",
      "update_min_price_failed": "Nepavyko atnaujinti minimalios kainos",
      "invoice_submission_success": "Sąskaitos pateikimas buvo sėkmingas!",
      "invoice_paid_within_7_days": "Sąskaita sėkmingai pateikta ir bus apmokėta per 7 dienas.",
      "fetch_pending_invoice_items_failed": "Nepavyko gauti laukiamų sąskaitų elementų",
      "fetch_certificates_failed": "Nepavyko gauti sertifikatų",
      "add_device": "Pridėti įrenginį",
      "add_device_message": "Pridėkite įrenginį, kad galėtumėte pradėti gamybos deklaravimą.",
      "no_devices": "Jūs neturite registruotų įrenginių",
      "team": {
        "title": "Komanda",
        "invite_title": "Pakviesti į komandą",
        "not_trusted_tooltip": "Komandos narių pridėjimas galimas aktyvavus paskyrą. Susisiekite su support@soldera.org.",
        "delete": "Ištrinti",
        "invite": "Pakviesti",
        "send_invite_email": "Siųsti pakvietimo el. laišką",
        "invalidName": "Vardas turi būti bent 2 simbolių ilgio",
        "invalidEmail": "Neteisingas el. pašto formatas",
        "domain_not_allowed": "Galima pakviesti tik šių el. pašto domenų adresus: {domains}",
        "allowed_domains_hint": "Pakvietimai leidžiami tik šiems el. pašto domenams: {domains}",
        "confirmDelete": "Ar tikrai norite pašalinti {account_name} prieigą prie {company_name}?"
      },
      "available_guarantees_of_origin": "Galimos kilmės garantijos",
      "manage_inventory": "Valdyti inventorių",
      "projected_production": "Prognozuojama gamyba",
      "manage_production_strategy": "Valdyti gamybos strategiją",
      "invoice_management": "Sąskaitų valdymas",
      "cancellation_documents": "Atšaukimo dokumentai"
    },
    "devices": "Registruoti įrenginiai",
    "generator": {
      "license_number": "Įrenginys su licencijos numeriu {license_number}",
      "hide_documents": "Slėpti susijusius dokumentus",
      "show_documents": "Rodyti susijusius dokumentus"
    },
    "documents": {
      "last_updated": "Paskutinį kartą atnaujinta",
      "section_title": "{document_count} dokumentai",
      "expand": "Peržiūrėti visus {document_count} dokumentus",
      "collapse": "Slėpti dokumentus",
      "hide_details": "Slėpti dokumentus konteineryje",
      "show_details": "Rodyti dokumentus konteineryje",
      "document_title": "{document_name}",
      "other_document": "Dokumentas atnaujintas {updated_at}",
      "show_associated_device": "Rodyti susietą įrenginį",
      "hide_associated_device": "Slėpti susietą įrenginį",
      "no_documents": "Dokumentų dar nėra",
      "no_documents_message": "Čia bus rodomi jūsų įkelti arba gauti dokumentai"
    },
    "portfolio": {
      "no_portfolio_data_title": "Jūsų portfelio duomenys dar nėra prieinami",
      "no_portfolio_data_subtitle": "Jūsų portfelio duomenys bus rodomi čia, kai mes gausime savo registracijos duomenis.",
      "all_portfolios": "Visi portfeliai",
      "total_volumes": "Bendri kiekiai",
      "available_volumes": "Galimi kiekiai",
      "expired_volumes": "Pasibaigę kiekiai",
      "sold_volumes": "Parduoti kiekiai",
      "monthly_technology_breakdown": "Mėnesinis pagal technologiją",
      "monthly_sales_status": "Mėnesinis pagal pardavimo būseną",
      "company_breakdown": "Kiekiai pagal įmonę",
      "guarantees_of_origin_in_portfolios": "Kilmės garantijos portfeliuose",
      "projected_production": "Prognozuojama gamyba",
      "pending_payouts": "Laukiami mokėjimai",
      "production_devices": "Gamybos įrenginiai",
      "documents": "@:common.documents",
      "recipient_eecs_account_number": "Gavėjo EECS sąskaitos numeris",
      "recipient_internal_account_number": "Registro vidinės sąskaitos numeris",
      "recipient_internal_account_help": "Pasirinktinai. Reikalinga tik registrams, kurie naudoja sub-sąskaitas.",
      "recipient_internal_account_placeholder": "Pasirinktinio sub-sąskaitos ID",
      "certificatesTableTitle": "Portfelio sertifikatai",
      "sendGoChatWelcome": "Sveiki! Kuo galiu padėti šiandien siunčiant kilmės garantijas?",
      "sendGoChatWelcomeWithCerts": "Sveiki! Matau, kad pasirinkote {count} sertifikatą(-us). Kokia gavėjo informacija?",
      "sendGoChatAssistant": "KG siuntimo asistentas",
      "sendGoChatPlaceholder": "Klauskite apie KG siuntimą, pateikite gavėjo informaciją arba įkelkite failą...",
      "sendGoChatInputPlaceholder": "Įveskite gavėjo informaciją arba MWh kiekį...",
      "sendGoOrderSummary": "Siuntimo užsakymo suvestinė",
      "selected_certificates": "Pasirinkti sertifikatai",
      "selected_certificates_summary": "Pasirinktų sertifikatų suvestinė",
      "disabledReasonPortfolio": "Šio sertifikatų paketo negalima siųsti, nes jis jau paskirtas {portfolio} portfeliui",
      "disabledReasonStatus": "Šis sertifikatas negalimas pasirinktoje būsenoje.",
      "disabledReasonUnknown": "Šis sertifikatas negalimas pasirinktame portfelyje.",
      "recipientRegistryId": "Gavėjo registro ID",
      "recipientCountry": "Gavėjo šalis",
      "recipientCompanyName": "Gavėjo įmonės pavadinimas",
      "certificatesToSend": "Siunčiami sertifikatai",
      "noCertificatesSelected": "Nepasirinkta siunčiamų sertifikatų.",
      "totalMwhToSend": "Bendra siunčiama MWh",
      "totalMwhInTable": "Pasirinkta MWh",
      "sendGoDropFile": "Vilkite failą čia, kad išgautumėte informaciją",
      "sendGoUploadingFile": "Įkeliamas {name}...",
      "sendGoUploadSuccess": "Sėkmingai įkeltas {name}.",
      "sendGoSuccessMessage": "Siuntimo užsakymas sėkmingai pateiktas!",
      "fileUpload": {
        "title": "Įkelti sutartį",
        "description": "Įkelkite sutartį, kad automatiškai išgautumėte gavėjo duomenis",
        "dropzone": "Vilkite sutartį čia arba spustelėkite naršyti",
        "supportedFormats": "Palaikomi formatai: PDF, Word, Excel ir kt.",
        "analyzing": "Analizuojama sutartis...",
        "extractionComplete": "Analizė baigta! Radau gavėjo informaciją.",
        "apply": "Taikyti išgautus duomenis",
        "reset": "Atkurti",
        "uploadPrompt": "Vilkite sutartį čia arba spustelėkite, kad įkeltumėte",
        "drop_prompt": "Paleiskite failą, kad įkeltumėte",
        "uploadAnother": "Įkelti kitą failą",
        "analysisSuccessTitle": "Sutartis sėkmingai išanalizuota.",
        "analysisSuccessMessage": "Failo duomenys išgauti ir pritaikyti formai.",
        "analysisNoMatchTitle": "Nėra atitinkančių sertifikatų.",
        "analysisNoMatchMessage": "Dokumento kriterijai (technologija, įrenginys ar gamybos laikotarpis) neatitinka nė vieno iš jūsų turimų sertifikatų, todėl nieko nepavyko pasirinkti. Peržiūrėkite užklausą arba filtrus.",
        "analysisShortfallTitle": "Nepakanka atitinkančių sertifikatų.",
        "analysisShortfallMessage": "Iš atitinkančių sertifikatų pavyko pasirinkti tik {selected} MWh iš prašytų {requested} MWh. Prieš patvirtindami peržiūrėkite trūkumą."
      },
      "no_certificates_to_display": "Nėra sertifikatų, atitinkančių dabartinius filtrus.",
      "disabled_reason_portfolio": "Sertifikatas yra „{portfolio}\" portfelyje.",
      "disabled_reason_status_sold": "Šio sertifikato negalima pasirinkti, nes jis buvo parduotas.",
      "disabled_reason_status_ongoing_sale": "Šio sertifikato negalima pasirinkti, nes vyksta pardavimas.",
      "disabled_reason_status_expired": "Šio sertifikato negalima pasirinkti, nes jo galiojimas baigėsi.",
      "disabled_reason_status_non_transferrable": "Šio sertifikato negalima pasirinkti, nes jis neperleidžiamas.",
      "disabled_reason_status_reserved": "Šio sertifikato negalima pasirinkti, nes jis rezervuotas kitoms užduotims.",
      "disabled_reason_status_waiting_for_sale": "Šio sertifikato negalima pasirinkti, nes jis laukia pardavimo.",
      "disabled_reason_status_pending": "Šio sertifikato negalima pasirinkti, nes laukiama sistemos veiksmo.",
      "disabled_reason_status_unknown": "Šio sertifikato negalima pasirinkti dėl jo būsenos: {status}.",
      "disabled_reason_unknown": "Negalima pasirinkti",
      "recipient_registry_id": "Gavėjo registro ID",
      "recipient_country": "Gavėjo šalis",
      "recipient_company_name": "Gavėjo įmonės pavadinimas",
      "certificates_to_send": "Siunčiami sertifikatai",
      "no_certificates_selected": "Nepasirinkta siunčiamų sertifikatų.",
      "total_mwh_to_send": "Bendra siunčiama MWh",
      "available_certificates_title": "Galimi sertifikatai pačių valdomame portfelyje",
      "table": {
        "more_certificates": "Dar {count} sertifikatų",
        "select_columns": "Pasirinkti stulpelius",
        "columns_selected": "{count} stulpelių pasirinkta",
        "filters": {
          "search_company": "Ieškoti įmonės",
          "search_accounts": "Ieškoti paskyrų",
          "search_portfolio": "Ieškoti portfelio / projekto",
          "search_device": "Ieškoti įrenginio",
          "month_placeholder": "YYYY-MM",
          "cod_age_year_placeholder": "Metai",
          "cod_age_add_condition": "Pridėti sąlygą",
          "active": "@:common.active"
        },
        "filter_chips": {
          "group_label": "Aktyvūs filtrai",
          "label": "Filtrai",
          "none": "Nėra",
          "value": "{column}: {value}",
          "remove": "Pašalinti filtrą „{column}“",
          "hiding": "paslėpta {values}",
          "count_of_total": "{shown} iš {total}",
          "contains": "turi „{text}“",
          "cod_age_years": "{conditions} m.",
          "tag_default": "Numatytasis",
          "tag_document": "Iš dokumento",
          "tag_unavailable": "Atsargose nėra atitikmens",
          "reset": "Atkurti numatytuosius filtrus",
          "clear_all": "Išvalyti viską"
        },
        "filtered_total": "Iš viso",
        "count_cell": {
          "of": "iš {count}",
          "editor": "MWh, pasirenkami iš šios eilutės",
          "full_title": "Spustelėkite, kad pasirinktumėte tik dalį šios eilutės",
          "full_label": "Pasirinkta visa {count} MWh, pasirinkti tik dalį šios eilutės",
          "partial_title": "Spustelėkite, kad pakeistumėte kiekį",
          "partial_label": "Pasirinkta {selected} iš {count} MWh, keisti kiekį"
        }
      },
      "footer": {
        "action": "Veiksmai",
        "technology_amount": "Technologija ir kiekis",
        "production_period": "@:common.production_period",
        "production_support": "Gamybos parama",
        "no_certificates_selected": "Nepasirinkta sertifikatų",
        "review_send_title": "Siuntimo peržiūra",
        "review_sell_title": "Pardavimo peržiūra",
        "review_cancel_title": "Atšaukimo peržiūra",
        "confirm_send_btn": "Siųsti dabar",
        "confirm_sell_btn": "Parduoti dabar",
        "confirm_cancel_btn": "Atšaukti dabar",
        "cancel_btn": "@:common.cancel",
        "missing": "Trūksta",
        "overselected": "Pasirinkta per daug",
        "matched": "Sutampa",
        "strategy_auto_high": "Automatinis aukštas pasiūlymas",
        "strategy_min_price": "Šviežia gamyba virš minimalios kainos",
        "strategy_min_price_detailed": "Minimali kaina €{price}/MWh pirmus {duration} mėnesius, po to automatinis pardavimas rinkos kaina",
        "risk_flags": "Rizikos",
        "risk_region_mismatch": "Aptiktas regiono neatitikimas",
        "risk_insufficient_inventory": "Nepakankamas kiekis",
        "selected_mwh": "{mwh} MWh",
        "of_available": "iš {mwh} prieinamų",
        "rows": "Eilutės",
        "rows_selected": "nepasirinkta nė viena | pasirinkta {count} | pasirinkta: {count}",
        "rows_partial": "nė viena nėra dalinė | {count} dalinė | dalinių: {count}",
        "rows_hidden": "filtrai nepaslėpė nė vienos | filtrai paslėpė {count} | filtrai paslėpė: {count}",
        "partial_hint": "Spustelėkite kiekį, kad pasirinktumėte dalį eilutės"
      },
      "cancelGoChatAssistant": "KG atšaukimo asistentas",
      "cancelGoChatPlaceholder": "Patvirtinkite atšaukiamus sertifikatus arba užduokite klausimus...",
      "cancelGoChatInputPlaceholder": "Įveskite patvirtinimą arba priežastį...",
      "cancelGoOrderSummary": "Atšaukimo suvestinė",
      "certificatesToCancel": "Atšaukiami / Nurašomi sertifikatai",
      "noCertificatesSelectedCancel": "Nepasirinkta atšaukiamų sertifikatų.",
      "totalMwhToCancel": "Bendra atšaukiama MWh",
      "cancelGoChatIntro": "Pasirinkote {count} sertifikatą(-us) atšaukimui. Prašome patvirtinti arba nurodyti priežastį.",
      "sellGoChatAssistant": "KG pardavimo asistentas",
      "sellGoChatPlaceholder": "Patvirtinkite sertifikatus ir pardavimo strategiją...",
      "sellGoChatInputPlaceholder": "Patvirtinkite pardavimo strategiją arba užduokite klausimus...",
      "sellGoOrderSummary": "Pardavimo suvestinė",
      "certificatesToSell": "Parduodami sertifikatai",
      "noCertificatesSelectedSell": "Nepasirinkta parduodamų sertifikatų.",
      "totalMwhToSell": "Bendra parduodama MWh",
      "sellGoChatIntro": "Pasirinkote {count} sertifikatą(-us) pardavimui. Prašome patvirtinti pardavimo strategiją.",
      "receiveGoChatAssistant": "KG gavimo asistentas",
      "receiveGoChatPlaceholder": "Apibūdinkite KG, kuriuos tikitės gauti...",
      "receiveGoChatInputPlaceholder": "Įveskite siuntėjo informaciją arba užduokite klausimus...",
      "receiveGoOrderSummary": "Gavomo suvestinė",
      "senderRegistryId": "Siuntėjo registro ID",
      "senderCountry": "Siuntėjo šalis",
      "senderCompanyName": "Siuntėjo įmonės pavadinimas",
      "expectedMwh": "Numatoma MWh",
      "receiveGoTablePlaceholder": "Numatomi gaunami pervedimai bus rodomi čia.",
      "buyGoChatAssistant": "KG pirkimo asistentas",
      "buyGoChatPlaceholder": "Kokių KG ieškote? Apibūdinkite kiekį, technologiją, kainų intervalą ir t.t.",
      "buyGoChatInputPlaceholder": "Nurodykite kiekį, technologiją, kainų intervalą...",
      "buyGoOrderSummary": "Pirkimo užklausa / Pasiūlymai",
      "buyVolume": "Kiekis (MWh)",
      "buyTechnology": "Technologija (neprivaloma)",
      "buyMaxPrice": "Maksimali kaina (€/MWh, neprivaloma)",
      "buyOffersPlaceholder": "Jūsų užklausą atitinkantys pasiūlymai atsiras čia.",
      "buyGoTablePlaceholder": "Potencialūs pirkti KG bus rodomi čia.",
      "sellGoSuccessMessage": "Pardavimo užsakymas sėkmingai pateiktas!",
      "sellGoSuccessTitle": "Pardavimo nustatymas baigtas",
      "confirmSellTitle": "Patvirtinti pardavimo nustatymą",
      "confirmSellMessage": "Jūs ketinate prašyti parduoti {mwh} MWh atsinaujinančios energijos sertifikatų per Soldera rinkos kainos sistemą.",
      "confirm_sell_minimum_price_message": "Jūs prašote parduoti {mwh} MWh atsinaujinančios energijos sertifikatų naudojant minimalios kainos strategiją. Štai kaip tai veikia:",
      "confirm_phase_1_title": "Pirmieji {duration} mėnesiai nuo gamybos",
      "confirm_phase_1_description": "Sertifikatai bus parduodami tik tada, jei rinkos kaina atitiks arba viršys jūsų minimalią kainą €{price}/MWh.",
      "confirm_phase_2_title": "Po {duration} mėnesių nuo gamybos",
      "confirm_phase_2_description": "Visi likę sertifikatai bus automatiškai parduodami aukščiausia rinkos kaina, kad neprarastų vertės.",
      "technologies": "Technologijos",
      "production_months": "Gamybos mėnesiai",
      "spotSalesPortfolio": "Spot pardavimai",
      "spotSalesPortfolioDescription": "Galimas pardavimas rinkos kaina",
      "spot_sales_min_price_description": "Pirma taikoma minimali kaina, po to automatinis pardavimas rinkos kaina",
      "oldCertificatesWarningTitle": "Sertifikatų amžiaus perspėjimas",
      "oldCertificatesWarningMessage": "Pasirinkote {count} MWh sertifikatų, kurie yra senesni nei {duration} mėnesiai nuo jų išdavimo datos. Minimalios kainos strategija taikoma tik sertifikatams per pirmus {duration} mėnesius po išdavimo. Pašalinkite šiuos senesnius sertifikatus, kad tęstumėte su minimalios kainos strategija.",
      "document": {
        "title": "@:common.documents",
        "company": "@:common.company",
        "status": "Būsena",
        "last_updated": "Paskutinį kartą atnaujinta",
        "actions": "@:common.actions.title",
        "contract_details": "Sutarties informacija"
      },
      "disabled_reason_status_own_use": "Šio sertifikato negalima pasirinkti, nes jis skirtas savoms reikmėms ir juo negalima prekiauti."
    }
  },
  "document": {
    "document_container": "Pasirašymo rinkinys",
    "send_elering_email": "Siųsti „Elering\" el. laišką",
    "resend_email": "Siųsti el. laišką",
    "signed": "Pasirašyta",
    "awaiting_signature": "Laukiamas parašas",
    "download": "Atsisiųsti dokumentą",
    "sign_document": "Pasirašyti dokumentą",
    "delete_document": "Ištrinti dokumentą",
    "admin_delete_document": "Administratorius ištrina dokumentą",
    "confirm_delete": "Ar tikrai norite ištrinti šį dokumentą?",
    "confirm_admin_delete": "Ar tikrai norite ištrinti šį dokumentą kaip administratorius?",
    "unfinished_document": "Nebaigta registracija",
    "forward_service_appendix": {
      "title": "Soldera išankstinio pardavimo sandorių sutartis",
      "description": "Dokumente apibrėžiamos numatytosios sąlygos, taikomos bet kokiems Išankstinio pardavimo sandoriams, kuriuos sudaro Narys ir Soldera, ir nustatomas pagrindas Šalims susitarti dėl Instrukcijų dėl išankstinio pardavimo sandorių. Abi Šalys turi susitarti dėl Išankstinio pardavimo sandorių ir (arba) Instrukcijų dėl išankstinio pardavimo sandorių atskirai nuo šios Sutarties."
    }
  },
  "cancellation": {
    "list_title": "Atšaukimo pareiškimai",
    "add_new_statement": "Pridėti naują atšaukimo pareiškimą",
    "not_trusted_tooltip": "Pareiškimų pridėjimas galimas aktyvavus paskyrą. Susisiekite su support@soldera.org.",
    "no_cancellations": "Nėra atšaukimo pareiškimų",
    "no_cancellations_info": "Jūsų atšaukimo pareiškimai atsiras čia po jų įkėlimo",
    "view_details": "Peržiūrėti detales",
    "download_documents": "Atsisiųsti dokumentus",
    "download_shown": "Atsisiųsti rodomus (dokumentų nėra) | Atsisiųsti rodomus (dokumentų: {count}) | Atsisiųsti rodomus (dokumentų: {count})",
    "download_preparing": "Ruošiama {current} / {total}…",
    "download_preparing_documents": "Ruošiami dokumentai…",
    "download_none_selected": "Dabartiniame pasirinkime nėra dokumentų",
    "download_too_many_documents": "Per daug dokumentų atsisiųsti vienu metu ({count}). Susiaurinkite filtrus iki ne daugiau kaip {max}.",
    "download_too_many_bytes": "Pasirinktų dokumentų bendra apimtis – {total} MB; riba – {max} MB. Susiaurinkite filtrus ir bandykite dar kartą.",
    "download_too_large_title": "Pasirinkimas per didelis atsisiųsti",
    "bulk_download_failed": "Nepavyko atsisiųsti atšaukimo pareiškimų",
    "bulk_download_no_documents_title": "Nėra dokumentų atsisiuntimui",
    "bulk_download_no_documents": "Nė vienas pasirinktas dokumentas nebepasiekiamas. Sąrašas atnaujintas.",
    "create_statement": "Sukurti pareiškimą",
    "drop_to_create": "Nuvilkite failus čia, kad sukurtumėte naują atšaukimo pareiškimą",
    "table": {
      "id": "@:common.id",
      "created": "Sukurta",
      "beneficiary_name": "Gavėjo vardas",
      "period": "Laikotarpis",
      "mwh_cancelled": "Atšaukta MWh",
      "purpose": "Tikslas",
      "registry": "Registras",
      "registry_code": "Registro kodas",
      "more_statements": "Dar {count} pareiškimų"
    },
    "details_title": "Atšaukimo pareiškimo detalės",
    "details": {
      "basic_info": "Pareiškimo informacija",
      "documents": "Įkelti dokumentai",
      "no_documents": "Dokumentų neįkelta",
      "period": "@:cancellation.table.period",
      "order_id": "Užsakymo ID",
      "load_error": "Nepavyko įkelti atšaukimo duomenų",
      "download_all": "Atsisiųsti visus dokumentus",
      "registry_document": "Registro dokumentas",
      "view_registry_document": "Peržiūrėti registre",
      "add_documents": "Pridėti dokumentų",
      "upload_selected": "Įkelti"
    },
    "upload": {
      "drop_files": "Nuvilkite failus čia arba spustelėkite naršymui",
      "supported_formats": "Palaikomi formatai: PDF, DOC, DOCX, XLS, XLSX, CSV, TXT, PNG, JPG, JPEG (maks. 25MB kiekvienas)"
    },
    "modal": {
      "upload_documents": "Įkelti dokumentus",
      "uploaded_files": "Įkelti failai",
      "files_required": "Reikalingas bent vienas failas",
      "order_selection": "Susieti su atšaukimo užsakymu",
      "order_selection_description": "Pasirinktinai susiekite šį pareiškimą su esamu atšaukimo užsakymu formos duomenų automatiniam užpildymui.",
      "linked_order": "Susietas atšaukimo užsakymas",
      "no_order_selected": "Nėra (rankinis įvedimas)",
      "order_option": "Užsakymas #{id} - {date}",
      "order_help_text": "Pasirinkite užsakymą automatiniam formos užpildymui esamais duomenimis arba pasirinkite 'Nėra' rankiniam įvedimui.",
      "statement_selection": "Pasirinkite pareiškimą",
      "no_statement_selected": "Pasirinkite pareiškimą",
      "statement_help_text": "Pasirinkite konkretų pareiškimą iš pasirinkto užsakymo formos duomenų automatiniam užpildymui.",
      "statement_details": "Pareiškimo detalės",
      "auto_fill_from_statement_notice": "Formos duomenys automatiškai užpildyti iš pasirinkto pareiškimo. Galite keisti bet kurį lauką pagal poreikį.",
      "select_statement_notice": "Pasirinkite pareiškimą iš aukščiau esančio išskleidžiamojo sąrašo formos automatiniam užpildymui.",
      "upload_description_with_ai": "Įkelkite atšaukimo sutartis ar atitikties dokumentus automatiniam formos laukų užpildymui arba pridėkite papildomą dokumentaciją.",
      "analyzing_document": "Dokumento analizė su AI...",
      "ai_analysis_applied": "AI analizė pritaikyta formai",
      "ai_populated": "AI užpildyta",
      "clear_ai_data": "Išvalyti AI duomenis",
      "confirm_override_ai_data": "Tai pakeistų AI užpildytus duomenis užsakymo duomenimis. Ar tikrai norite tęsti?",
      "analysis_complete_title": "Analizė baigta",
      "analysis_success_with_fields": "Dokumentas sėkmingai išanalizuotas ir atnaujinti {count} laukai.",
      "analysis_success_no_fields": "Dokumentas sėkmingai išanalizuotas, tačiau nerastas naujos informacijos formos atnaujinimui.",
      "analysis_success_multiple_statements_with_fields": "Dokumente rasti {total_statements} pareiškimai. Pritaikytas pirmasis pareiškimas ir atnaujinti {count} laukai. Prašome peržiūrėti likusius pareiškimus rankiniu būdu.",
      "analysis_success_multiple_statements_no_fields": "Dokumente rasti {total_statements} pareiškimai, tačiau nerastas naujos informacijos formos atnaujinimui.",
      "multiple_statements_warning": "Dokumente aptikti keli pareiškimai ({total_statements}). Formos užpildymui panaudotas tik pirmasis pareiškimas. Prašome peržiūrėti likusius pareiškimus rankiniu būdu.",
      "field": {
        "operation_notes": "Veiklos pastabos"
      }
    },
    "purpose": {
      "DISCLOSURE": "Atskleidimas",
      "GRID_LOSSES": "Tinklo nuostoliai",
      "SELF_CONSUMPTION": "Savarankiškas suvartojimas",
      "SUPPORT_SCHEME": "Paramos schema",
      "OTHER": "Kita"
    },
    "success": {
      "title": "Pareiškimas sukurtas!",
      "message": "Jūsų atšaukimo pareiškimas sėkmingai sukurtas."
    }
  },
  "followup": {
    "international_self_signup": {
      "title": "Netrukus su jumis susisieksime!",
      "message": "Dėkojame, kad užsiregistravote! Mūsų komanda su jumis susisieks, kad užbaigtų registraciją ir padėtų pasirašyti reikalingus dokumentus."
    },
    "latvia_manual_auth": {
      "title": "Įgaliokite Soldera Grexel sistemoje, kad užbaigtumėte registraciją",
      "message": "Kad Soldera galėtų pradėti valdyti jūsų Kilmės garantijas, turite rankiniu būdu įgalioti mus Grexel sistemoje. Norėdami užbaigti šį procesą, vadovaukitės toliau pateiktame dokumente esančiomis instrukcijomis.",
      "button": "Peržiūrėti įgaliojimo instrukcijas"
    },
    "latvia_sales_followup": {
      "title": "Netrukus su jumis susisieksime!",
      "message": "Prieš AST priimant jūsų naujus įrenginius, jiems reikės nepriklausomo audito. Netrukus su jumis susisieksime aptarti tolesnius veiksmus. Tuo tarpu galite pridėti kitą įmonę ar įrenginį.",
      "button": "Pridėti įmones ar įrenginius"
    }
  },
  "validations": {
    "required": "Šis laukas yra privalomas.",
    "maxValue": "Maksimali reikšmė yra {max}.",
    "required_and_min": "Šis laukas yra privalomas ir reikšmė turi būti bent {min}.",
    "required_and_range": "Šis laukas yra privalomas ir reikšmė turi būti tarp {min} ir {max}.",
    "exactStringLength": "Šis laukas turi būti tik {length} simbolių ilgio.",
    "exactDigitLength": "Šis laukas turi būti tik {length} skaitmenų ilgio.",
    "minLength": "Šiuo metu šis laukas yra „{model}\" simbolių ilgio, bet turi būti bent {min} simbolių ilgio.",
    "maxLength": "Šis laukas turi būti ne ilgesnis kaip {max} simbolių.",
    "estonianPersonalID": "Šiame lauke turi būti galiojantis asmens kodas.",
    "estonianCompanyCode": "Šiame lauke turi būti galiojantis įmonės registracijos kodas.",
    "estonianIDorCompanyCode": "Šiame lauke turi būti arba įmonės registracijos kodas, arba savininko asmens kodas.",
    "estonianYourPersonalIDifID": "Asmens kodas turi sutapti su savininko asmens kodu.",
    "estonianDeviceEIC": "Šiame lauke turi būti galiojantis įrenginio EIC kodas (pvz.: 38ZEE-12345678-X).",
    "estonianVATNumber": "Įveskite galiojantį PVM kodą.",
    "latvianCompanyNumber": "Šiame lauke turi būti galiojantis įmonės registracijos kodas.",
    "lithuanianCompanyNumber": "Šiame lauke turi būti galiojantis įmonės registracijos kodas.",
    "latvianIDorVATNumber": "Šiame lauke turi būti įmonės PVM kodas arba asmens kodas privatiems asmenims",
    "latvianYourPersonalIDifID": "Asmens kodas turi atitikti savininko asmens kodą.",
    "latvianIDorRegistryCode": "Šiame lauke turi būti įmonių registracijos kodas arba fizinių asmenų asmens kodas",
    "notExampleEIC": "EIC neturi būti pateiktame pavyzdyje nurodytas kodas, bet tikras įrenginio EIC kodas.",
    "alpha": "Šiame lauke gali būti tik raidės.",
    "personalName": "Įveskite savo vardą taip, kaip jis nurodytas asmens dokumente.",
    "phoneNumber": "Šiame lauke turi būti  galiojantis telefono numeris.",
    "someSubsidies": "Jei gamybos įrenginys gavo subsidijas, jos turi būti nurodytos čia.",
    "generatorExists": "Įkelkite savo gamybos įrenginio tinklo sutartį, kad galėtumėte tęsti.",
    "reasonableDate": "Įsitikinkite, kad data yra teisinga.",
    "iban": "Įveskite galiojantį IBAN numerį.",
    "fileRequired": "Įkelkite privalomą dokumentą.",
    "swedishPersonalID": "Šiame lauke turi būti galiojantis Švedijos asmens kodas.",
    "swedishCompanyCode": "Šiame lauke turi būti galiojantis Švedijos įmonės kodas.",
    "swedishIDorCompanyCode": "Šiame lauke turi būti galiojantis Švedijos asmens kodas arba įmonės kodas.",
    "finnishPersonalID": "Šajā laukā jānorāda derīgs Somijas personas kods.",
    "finnishBusinessID": "Šajā laukā jānorāda derīgs Somijas uzņēmuma ID (Y-tunnus).",
    "finnishIDorBusinessID": "Šajā laukā jānorāda derīgs Somijas personas kods vai uzņēmuma ID.",
    "integer": "Šiame lauke turi būti sveikasis skaičius.",
    "required_and_integer": "Šis laukas yra privalomas ir turi būti sveikasis skaičius.",
    "required_integer_and_min": "Šis laukas yra privalomas, turi būti sveikasis skaičius ir bent {min}.",
    "required_integer_and_range": "Šis laukas yra privalomas, turi būti sveikasis skaičius ir tarp {min} ir {max}.",
    "selection_required": "Būtinas bent vienas pasirinkimas.",
    "between": "Vertė turi būti tarp {min} ir {max}.",
    "validRegistryCode": "Registracijos kodas turi būti 3-20 raidžių ir skaitmenų simbolių (raidės, skaičiai, brūkšniai leidžiami).",
    "validAddress": "Adresas turi būti nuo 5 iki 200 simbolių ilgio.",
    "validVATNumber": "Įveskite galiojantį PVM kodą (formatas: XX123456789 arba CHE123456789).",
    "swedishVATNumber": "Įveskite galiojantį Švedijos PVM kodą (formatas: SE + 10 skaitmenų + 01, pvz., SE556229657301).",
    "validRepresentativeName": "Vardas turi būti 2-100 simbolių ilgio ir turėti tiek vardą, tiek pavardę.",
    "validRepresentativePhone": "Telefono numeris turi būti 6-25 simbolių ilgio ir teisingame formate.",
    "minValue": "Minimali reikšmė yra {min}.",
    "polishVATNumber": "Šiame lauke turi būti galiojantis Lenkijos PVM numeris (PL + 10 skaitmenų).",
    "polishRegistryCode": "Šiame lauke turi būti galiojantis Lenkijos įmonės registracijos kodas (10 skaitmenų KRS).",
    "productionValue": "Gamybos vertė turi būti didesnė už nulį.",
    "dateCannotBeFuture": "Data negali būti ateityje.",
    "email": "Prašome įvesti galiojantį el. pašto adresą.",
    "eecs_account_format": "Neteisingas EECS sąskaitos numerio formatas",
    "unit_price_pln_format": "Turi būti teigiama suma su ne daugiau kaip 2 skaičiais po kablelio"
  },
  "validation": {
    "pl": {
      "invalid_vat_number": "Prašome įvešti galiojantį Lenkijos PVM numerį (PL + 10 skaitmenų).",
      "invalid_registry_code": "Prašome įvešti galiojantį Lenkijos įmonės registracijos kodą (10 skaitmenų KRS)."
    }
  },
  "registry_device": {
    "device_name": "Įrenginio pavadinimas",
    "device_power": "Įrenginio galia",
    "supported_device": "Palaikomas įrenginys",
    "fetch_failed": "Nepavyko gauti įrenginių",
    "device_code": "Įrenginys su kodu {code}",
    "technology_code": "Technologijos kodas",
    "commercial_operation_date": "Komercinės veiklos pradžios data",
    "ecolabel_approved": "Ekologinis ženklas patvirtintas",
    "address": "@:common.address",
    "device_eic_placeholder": "Įveskite įrenginio identifikacijos kodą",
    "device_name_placeholder": "Įveskite įrenginio pavadinimą",
    "device_power_placeholder": "Įveskite galią kW",
    "device_eic_description": "Unikalus įrenginio identifikatorius registre",
    "commercial_operation_date_description": "Data, kada įrenginys pradėjo komercinę veiklą",
    "polish_fields": {
      "title": "Papildoma informacija, reikalinga išdavimo duomenų įgaliojimui",
      "installation_address": "Įrengimo adresas",
      "installation_address_placeholder": "Įveskite fizinį įrenginio įrengimo adresą",
      "installation_address_description": "Fizinis adresas, kuriame įrengtas atsinaujinančios energijos įrenginys",
      "metering_system_number": "Matavimo sistemos numeris",
      "metering_system_number_placeholder": "Įveskite matavimo sistemos identifikatorių",
      "metering_system_number_description": "Unikalus matavimo sistemos identifikatorius",
      "metering_system_multiplier": "Matavimo sistemos daugiklis",
      "metering_system_multiplier_placeholder": "Įveskite daugiklio vertę",
      "metering_system_multiplier_description": "Daugiklis, taikomas skaitiklio rodmenims",
      "osd_name": "Skirstomųjų tinklų operatoriaus (OSD) pavadinimas",
      "osd_name_placeholder": "Įveskite OSD pavadinimą ir filialą (jei taikoma), pvz., PGE Dystrybucja S.A. Oddział Łódź",
      "osd_name_description": "Skirstomųjų tinklų operatoriaus ir konkretaus filialo, prijungto prie jūsų įrenginio, pavadinimas",
      "osd_address": "OSD adresas",
      "osd_address_placeholder": "Įveskite OSD adresą (jei taikoma, filialo adresą), pvz., ul. Tuwima 58, 90-021 Łódź",
      "osd_address_description": "Prie jūsų įrenginio prijungto skirstomųjų tinklų operatoriaus filialo adresas"
    },
    "poa": {
      "generate": "Generuoti įgaliojimą",
      "generating": "Generuojamas įgaliojimas...",
      "generated_successfully": "Įgaliojimas sėkmingai sugeneruotas",
      "description": "Sukurkite įgaliojimo dokumentą, kad suteiktumėte \"Solderai\" prieigą prie savo įrenginio išdavimo duomenų",
      "missing_polish_data_error": "Šiam įrenginiui trūksta reikalingos informacijos įgaliojimo generavimui",
      "required_for_issuance": "Ši informacija yra reikalinga norint generuoti įgaliojimą prieigai prie išdavimo duomenų."
    },
    "production_estimate_override": {
      "title": "Gamybos prognozės perrašymas",
      "save": "Išsaugoti",
      "saving": "Saugoma...",
      "use_manual_estimates": "Naudoti rankines prognozes",
      "use_automatic_estimates": "Naudoti automatines prognozes",
      "monthly_production_estimates": "Mėnesinės gamybos prognozės",
      "automatic_vs_manual": "Automatinis vs rankinis",
      "automatic_calculated": "Automatinis (apskaičiuotas)",
      "automatic": "Automatinis",
      "manual": "Rankinis",
      "override_button": "Perrašyti prognozes",
      "projected_production": "Prognozuojama gamyba",
      "configured_values": "Sukonfigūruotos reikšmės",
      "calculated_values": "Apskaičiuota iš istorinių duomenų",
      "feasibility_warning": "Remiantis naujomis prognozėmis, jūsų išankstinių pardavimų telkiniai gali nebepadengti įsipareigojimų: {period} laikotarpiu įsipareigota {demand} MWh, tačiau prognozei trūksta {shortfall} MWh. Prašome peržiūrėti savo išankstinius kiekius.",
      "feasibility_warning_title": "Išankstinio pardavimo strategijos įspėjimas"
    }
  },
  "account": {
    "name": "Vardas ir pavardė",
    "email": "El. paštas",
    "phone_number": "Telefono numeris",
    "registry_code": "Asmens kodas",
    "comment": "Komentaras"
  },
  "company": {
    "payout_currency": "Išmokos valiuta",
    "payout_currency_hint": "Išmokas kitomis valiutomis įjungia Soldera palaikymo komanda.",
    "name": "@:common.name",
    "registry_code": "Registracijos arba asmens kodas",
    "address": "@:common.address",
    "vat": "PVM kodas",
    "vat_or_personal_id": "PVM kodas arba asmens kodas",
    "bank_account": "Banko sąskaitos IBAN",
    "bank_name": "Banko pavadinimas",
    "bank_swift": "Banko SWIFT/BIC kodas",
    "invalid_vat": "PVM kodas turi būti tuščias arba formatu XX999999999 (šalies kodas + 8-12 skaitmenų)",
    "contact_email": "Kontaktinis el. paštas",
    "invoice_email": "Sąskaitos el. paštas",
    "billing_email": "Atsiskaitymo el. pašto adresas",
    "billing_email_tooltip": "Sąskaitos taip pat bus siunčiamos šiuo adresu papildomai prie jūsų paskyros el. pašto. Naudinga persiuntimui buhalteriui ar finansų skyriui.",
    "monthly_rollup": "Praleisti pardavimo pranešimus — gauti vieną mėnesinį el. laišką 1 dieną",
    "monthly_rollup_tooltip": "Apie kiekvieną pardavimą el. laiško negausite. Vietoj to kiekvieno mėnesio 1 dieną gausite vieną el. laišką su praėjusio mėnesio pardavimais ir komisinio mokesčio sąskaita faktūra. Išmokėjimo sąskaitos faktūros vis tiek siunčiamos, kai prašote išmokėjimo."
  },
  "generator": {
    "device_name": "Inverterio modelis",
    "device_eic": "Įrenginio EIC",
    "device_power": "Bendra galia (KW)",
    "device_address": "Įrenginio adresas",
    "grid_contract_start_date": "Gamybos pradžios data",
    "subsidies": "Subsidijos",
    "battery": "Saugojimo įrenginys",
    "ppa": "Tiesioginio pirkimo sutartis",
    "no_subsidies": "Nėra subsidijų",
    "no_storage_device": "Nėra saugojimo įrenginio",
    "no_ppa": "Nėra tiesioginio pirkimo sutarties",
    "no_battery": "Nėra saugojimo įrenginio",
    "subsidy_provider": "Subsidijos teikėjas: {provider}",
    "subsidy_plan": "Subsidijos planas: {plan}",
    "unit_power": "Vieneto galia: {power}",
    "capacity": "Talpa: {capacity}",
    "ppa_start_date": "Pradžios data: {date}",
    "ppa_mwh": "MWh: {mwh}",
    "ppa_client_name": "Kliento įmonė: {name}",
    "ppa_country": "Kliento šalis: {country}",
    "EIC": "EIC",
    "status": {
      "1": "Neregistruotas",
      "2": "Dokumentas turi būti pasirašytas",
      "3": "Registruotas"
    },
    "continue_registration": "Tęsti registraciją",
    "sign_document": "Pasirašyti dokumentą",
    "edit": "Redaguoti",
    "properties": {
      "device_name": "Inverterio modelis",
      "solar_panel_model": "Saulės modulio modelis",
      "device_address": "Adresas",
      "device_power": "Galia",
      "battery": "Saugojimo įrenginys",
      "subsidies": "Subsidijos"
    },
    "unspecified": "Nenustatyta",
    "documents": "@:common.documents",
    "document_title": "Sutartis dėl įrenginio EIC: {eic}",
    "license_number": "Licencijos numeris"
  },
  "invoice": {
    "status": {
      "paid": "Apmokėta",
      "canceled": "Atšaukta",
      "requested": "Prašoma",
      "drafting": "Rengiama"
    },
    "regenerate_confirmation": "Ar tikrai norite atkurti sąskaitą?",
    "regenerate": "Atkurti",
    "cancel_fee_only": "Anuliuoti",
    "cancel_fee_only_confirmation": "Ar tikrai norite anuliuoti šią tik mokesčių sąskaitą? Sąskaitos eilutės bus grąžintos į laukimo būseną, o tiek mokesčių, tiek atsiskaitymo sąskaitos bus ištrintos.",
    "cancel_mixed_types_disabled": "Negalima anuliuoti išlaidų ir tik mokesčių sąskaitų vienoje partijoje — pasirinkite tik vieną tipą.",
    "send_to_merit": "Siųsti į Merit",
    "send_to_merit_confirmation": "Ar tikrai norite išsiųsti šią sąskaitą į Merit?",
    "already_in_merit": "Sąskaita jau užregistruota Merit.",
    "error_downloading": "Klaida atsisiunčiant sąskaitą",
    "number": "Sąskaitos numeris",
    "status_label": "Būsena",
    "requested_date": "Prašoma data",
    "amount": "Suma"
  },
  "invoiceHistory": {
    "title": "Sąskaitų istorija",
    "noInvoices": "Ateityje čia rasite visas savo sąskaitas!",
    "notificationInfo": "Kai įvyks pardavimo sandoriai, mes pranešime jums el. paštu.",
    "export_xlsx": "Eksportuoti į Excel"
  },
  "setPriceTerms": {
    "modifyStrategyTitle": "Keisti pardavimo strategiją",
    "selectStrategyLabel": "Pasirinkite pardavimo strategiją",
    "automaticHighBid": "Automatinis pardavimas gavus aukščiausią pasiūlymą",
    "fresh_prod_above_min_price": "Nustatyti riboto laiko minimalią kainą",
    "minimumPriceDuration": "Minimali kaina pirmus {duration} mėnesius",
    "minimumPriceLabel": "Minimali kaina",
    "enterPrice": "Įveskite kainą",
    "saveChanges": "Išsaugoti pakeitimus",
    "readMore": "Skaityti daugiau",
    "duration": {
      "minimum_price_window": "Minimalios kainos langas",
      "default_hint": "Numatytoji reikšmė yra 6 mėnesiai nuo gamybos datos",
      "limit_active_for": "Apribojimas aktyvus {duration} mėnesius nuo išdavimo"
    },
    "warning": {
      "depreciation": "Įspėjimas: Vyresni nei 6 mėnesių sertifikatai linkę greitai pigti artėjant prie 12 mėnesių perdavimo termino.",
      "noSaleAt12": "Kritinis įspėjimas: Pasirinkus 10-12 mėnesių, jūsų kilmės garantijos gali nuvertėti iki nulio, nes sertifikatų negalima perduoti praėjus 12 mėnesių nuo išdavimo. Jau esant 10 mėnesių žymai, lieka mažai laiko, todėl šiuos sertifikatus sunku parduoti."
    },
    "phases": {
      "title": "Kaip ši strategija veikia",
      "phase_1_badge": "1 fazė",
      "phase_1_title": "Pirmieji {duration} mėnesiai nuo gamybos",
      "phase_1_description": "Sertifikatai laikomi, kol rinkos kaina atitiks arba viršys jūsų minimalią kainą €{price}/MWh. Jei kaina žemesnė už jūsų minimumą, sertifikatai neparduodami.",
      "phase_2_badge": "2 fazė",
      "phase_2_title": "Po {duration} mėnesių nuo gamybos",
      "phase_2_description": "Visi neparduoti sertifikatai automatiškai parduodami aukščiausia rinkos kaina. Tai užtikrina, kad jūsų sertifikatai visada bus parduoti prieš jiems baigiant galioti.",
      "readonly_summary": "Minimali kaina pirmus {duration} mėnesius, po to automatinis pardavimas rinkos kaina"
    },
    "howMinimumPriceWorks": "Kaip veikia „Soldera\" minimali kaina",
    "contentParagraph1": "Automatinis pardavimas už rinkos kainą yra saugus būdas parduoti kilmės garantijas, paskirstant riziką ir užtikrinant, kad jos būtų parduotos, kai jų „šviežumas\" labiausiai vertinamas.",
    "content_paragraph_2": "Suprantame, kad daugelis mūsų narių nori planuoti savo kilmės garantijų pardavimus. Tačiau visada yra rizika, kad sertifikatų kaina nepasieks norimo minimumo. Todėl pardavimas už rinkos kainą yra geresnė galimybė nei leisti sertifikatams pasibaigti jų taip ir nepardavus.",
    "content_paragraph_3": "Todėl siūlome galimybę nustatyti minimalios kainos strategiją. Pirmus {duration} mėnesių po jūsų sertifikatų išdavimo, mes juos parduosime tik tada, kai rinkos kaina atitiks arba viršys jūsų minimalią kainą. Pasibaigus šiam {duration} mėnesių laikotarpiui, mes automatiškai parduosime visus likusius sertifikatus esamomis rinkos kainomis, kad išvengtume jų vertės praradimo. Ši strategija suteikia jums galimybę pasinaudoti kainų augimu, tuo pačiu užtikrinant, kad jūsų sertifikatai visada bus parduoti prieš jiems pasibaigiant.",
    "howMarketPriceWorks": "Kaip veikia Soldera rinkos kaina",
    "marketPriceContentParagraph1": "Soldera suvienija kilmės garantijas iš daugelio narių į didesnius pardavimo sandorius, sujungdama mūsų kolektyvinį tūrį stipresnei rinkos pozicijai ir geresnei kainai pasiekti. Vykdome reguliarius pardavimus naudodami gudrias strategijas ir laiką, kuris maksimizuoja sandorių dažnią. Šiam procesui palengvinti, perkeliame jūsų kilmės garantijas į mūsų registro sąskaitą, kur mūsų programinė įranga visa tvarko automatiškai - jums niekada nereikia derėtis su pirkėjais ar valdyti perdavimų patiems.",
    "marketPriceContentParagraph2": "Prieš kiekvieną pardavimą, Soldera gauna kainų pasiūlymus iš mūsų plačaus tarptautinių pirkėjų tinklo, užtikrinant konkurencingai kainodarai per mūsų rinkos ryšius. Pasirenkame geriausią siūlomą kainą ir užbaigiame pardavimą visų dalyvaujančių narių vardu. Mūsų automatizuota sistema tvarko visą sudėtingumą, išlaikydama kainodarios proceso skaidrumą.",
    "marketPriceContentParagraph3": "Per 5 dienas po apmokėjimo gavimo iš pirkėjo, pranešime jums el. paštu apie sandorio detales, įskaitant jūsų dalį pelno po mūsų mokesčio ir sandorio išlaidų (dažniausiai registro eksporto mokestis) atėmimo. Tada galėsite vienu paspaudimu per Soldera platformą prašyti išmokėjimo - jei nenorite iškart išrašyti sąskaitos, galite tai padaryti vėliau bet kuriuo metu. Soldera perveda mokėjimą į jūsų sąskaitą per 7 dienas po jūsų sąskaitos gavimo."
  },
  "requestInvoice": {
    "indicative_payout_explainer": "Pagal ECB kursą {rate} ({date}). Orientacinė suma: išmoka konvertuojama pagal jos datos kursą.",
    "submit_invoice": "Pateikti sąskaitą",
    "money_pending": "Laukiami pinigai",
    "sales_revenue": "Pardavimų pajamos",
    "sales_vat": "Pardavimų PVM",
    "state_income_tax": "Valstybinis pajamų mokestis",
    "service_fees_vat": "Paslaugų mokesčiai (su PVM)",
    "detailed_overview": "Išsami apžvalga",
    "view_details": "Peržiūrėti detales",
    "invoice_items": "Sąskaitos elementai",
    "item": "Prekė",
    "quantity": "Kiekis",
    "unit_price": "Vieneto kaina",
    "total_excl_vat": "Iš viso (be PVM)",
    "vat": "PVM",
    "offset_service_fees": "Paslaugų mokesčių kompensavimas",
    "invoice_details": "Sąskaitos informacija",
    "invoice_number": "Sąskaitos numeris",
    "invoice_number_placeholder": "Sąskaitos numeris",
    "vat_number": "PVM numeris",
    "vat_number_placeholder": "PVM numeris",
    "bank_account_iban": "Banko sąskaita (IBAN)",
    "bank_account_placeholder": "IBAN",
    "contact_block_on_invoice": "Kontaktinė informacija sąskaitoje",
    "contact_block_placeholder": "Įmonės pavadinimas, \nAdresas, \nRegistracijos kodas",
    "reference": "Nuoroda (neprivaloma)",
    "reference_placeholder": "Nuorodos numeris",
    "monthly_rollup_label": "Praleisti pardavimo pranešimus — 1 dieną gauti vieną mėnesinį el. laišką su komisinio mokesčio sąskaita faktūra",
    "month_split_label": "Datuoti praėjusio mėnesio pardavimus (data: {date})",
    "month_split_tooltip": "Praėjusio mėnesio pardavimai ({month}) įtraukiami į atskirą išmokėjimo sąskaitą faktūrą, kurios data yra {date}, kaip ir komisinio mokesčio sąskaitos faktūros. Einamojo mėnesio pardavimai ({current_month}) įtraukiami į antrą sąskaitą faktūrą su šiandienos data.",
    "month_split_tooltip_pending": "Praėjusio mėnesio pardavimai ({month}) įtraukiami į išmokėjimo sąskaitą faktūrą, kurios data yra {date}, kaip ir komisinio mokesčio sąskaitos faktūros. Einamojo mėnesio pardavimai ({current_month}) lieka laukti vėlesnio išmokėjimo.",
    "month_split_previous_heading": "Pardavimai: {month} — sąskaitos faktūros data: {date}",
    "month_split_current_heading": "Pardavimai: {current_month} — sąskaitos faktūros data: šiandien",
    "month_split_pending_heading": "Pardavimai: {current_month} — lieka laukti vėlesnio išmokėjimo",
    "month_split_current_number": "Sąskaitos faktūros numeris — pardavimai: {current_month}",
    "month_split_number_must_differ": "Turi skirtis nuo aukščiau nurodyto sąskaitos faktūros numerio"
  },
  "certificateHistory": {
    "overview": "Sertifikatų apžvalga",
    "productionPeriod": "@:common.production_period",
    "certificateCount": "Sertifikatų skaičius",
    "expired": "Pasibaigęs galiojimo laikas",
    "sold": "Parduota",
    "awaitingSale": "Laukia pardavimo"
  },
  "chooseCompany": {
    "select_company": "Pasirinkite įmonę, kurią įgalioti",
    "choose_company": "Pasirinkite įmonę",
    "create_new_company": "Sukurti naują įmonę"
  },
  "invoiceItem": {
    "quantity": "Kiekis",
    "unit_price": "Vieneto kaina",
    "total_excl_vat": "Iš viso (be PVM)",
    "vat": "PVM"
  },
  "tradingCenter": {
    "tradingStrategy": "Prekybos strategija",
    "title": "Gamybos strategija",
    "tabs": {
      "overview": "Peržiūra",
      "strategyCustomisation": "Prekybos strategijos koregavimas",
      "issuance_reporting": {
        "title": "Išdavimo ataskaita"
      }
    },
    "customization": {
      "forwardSales": "Išankstiniai pardavimai",
      "spotSales": "Spot pardavimai",
      "ppaReserve": "PPA rezervas",
      "holdPortfolio": "Savarankiškas valdymas"
    },
    "overview": {
      "projectedProduction": {
        "title": "Prognozuojama produkcija",
        "noData": "Jūsų numatytosios metinės gamybos rezultatai bus matomi čia po to, kai mes gausime jūsų įrenginių informaciją iš registracijos."
      },
      "spot": {
        "title": "Spot pardavimai",
        "visualization": {
          "minimumPrice": {
            "title": "Bandymas parduoti už didesnę nei {kaina}€/MWh",
            "description": "Gamyba įtraukta į pasiūlymus, jei numatoma kaina yra vartotojo nustatyta minimali kaina",
            "firstMonths": "Pirmi {duration} mėnesiai"
          },
          "highestBid": {
            "title": "Parduoti pagal didžiausią pasiūlymą",
            "description": "Produkcija automatiškai parduodama didžiausią kainą pasiūliusiam pirkėjui",
            "lastMonths": "Paskutiniai {duration} mėnesiai"
          }
        }
      }
    }
  },
  "market_insights": {
    "title": "Rinkos įžvalgos",
    "description": "Rinkos informacija ir analizė atsinaujinančios energijos sektoriui",
    "sections": {
      "reports": "Rinkos ataskaitos",
      "charts": "Rinkos duomenys ir grafikai"
    },
    "forward_outlook": {
      "title": "Soldera Forward Outlook",
      "description": "Mėnesinė analizė apie GO rinkos tendencijas ir svarbias naujienas, turinčias įtakos rinkai"
    },
    "consulting_services": {
      "title": "2 srities (Scope 2) atitikties palaikymas",
      "description": "Soldera teikia atitikties paslaugas pagal poreikį. Susisiekite su mumis dėl išsamesnės informacijos.",
      "button_text": "Susisiekite su mumis"
    },
    "norway_reservoir": {
      "title": "Norvegijos rezervuarų lygiai",
      "description": "Savaitiniai rezervuarų lygiai su istoriniu palyginimu ir prognozėmis",
      "zone_label": "Prekybos zona",
      "y_axis_label": "% pajėgumo",
      "loading": "Įkeliami rezervuarų duomenys...",
      "error": "Nepavyko įkelti rezervuarų duomenų",
      "no_data": "Nėra duomenų pasirinktai zonai",
      "locked_zones_hint": "Atrakinkite visas rezervuarų zonas — susisiekite su mumis, kad įjungtumėte detalias regionines įžvalgas",
      "info_text": "Norvegija yra pagrindinė kilmės garantijų (KG) eksportuotoja kitoms AIB narėms dėl didelės hidroenergijos gamybos. Vietinė politika neskatina KG naudojimo vidaus rinkoje ir sudaro reikšmingą eksporto perteklių. Dėl to Norvegijos hidroenergijos pajėgumų ar vidaus vartojimo pokyčiai neproporcingai veikia platesnę Europos KG rinką.\n\nDuomenys atnaujinami kas savaitę. Faktiniai rezervuarų lygiai paprastai patvirtinami gerokai vėliau, todėl pateikiame savo įverčius, kad geriau prognozuotume rinkos dinamiką.",
      "zones": {
        "norway_total": "Norvegija iš viso"
      },
      "legend": {
        "historical_max": "Istorinis maks.",
        "historical_median": "Istorinė mediana",
        "historical_min": "Istorinis min.",
        "last_year": "Praėjusiais metais",
        "this_year": "Šiais metais",
        "predicted": "Prognozuojama"
      }
    },
    "cumulative_re": {
      "title": "Kaupiamoji atsinaujinančios energijos gamyba",
      "description": "Metų palyginimas atsinaujinančios energijos gamybos apimčių",
      "country_label": "Šalis",
      "eu_aggregate": "Europos Sąjunga (Apibendrinta)",
      "y_axis_label": "GWh",
      "loading": "Įkeliami grafiko duomenys...",
      "error": "Nepavyko įkelti grafiko duomenų",
      "info_text": "Metinė atsinaujinančios energijos gamyba yra stiprus kainų krypties rodiklis – jei gamyba reikšmingai auga, KG kainos dažniausiai mažėja, nes didėja KG pasiūla.\n\nDuomenys atnaujinami kas savaitę ir neapima šalių, kurios nėra AIB narės arba nepriklauso žemyninei Europai."
    }
  },
  "charts": {
    "xAxisLabel": "X ašis",
    "stackByLabel": "Stilizuoti pagal",
    "fields": {
      "portfolio_type": "Portfelio tipas",
      "production_month": "Gamybos mėnuo",
      "status": "Būsena",
      "technology_type": "Technologija",
      "company_name": "Įmonės pavadinimas",
      "portfolio_name": "Portfelio pavadinimas",
      "production_device_name": "Gamybos įrenginys",
      "production_support": "Gamybos parama",
      "ecolabel_tags": "Ecolabel",
      "transfer_deadline": "Perkėlimo terminas",
      "count": "Skaičius",
      "certificate_id": "Sertifikato ID",
      "registration_authority": "Registravimo institucija",
      "registry_region": "Dabartinis registras",
      "issuing_region": "Išdavimo registras",
      "cod_age": "COD amžius",
      "limit_price": "Minimali kaina",
      "sale_price": "Pardavimo kaina",
      "account_emails": "Paskyros",
      "registry_id": "Registro ID",
      "bundle_start": "Paketo pradžia",
      "bundle_end": "Paketo pabaiga"
    },
    "values": {
      "production_support": {
        "true": "Su parama",
        "false": "Be paramos",
        "null": "Nežinoma"
      },
      "portfolio_type": {
        "FORWARD": "Forwardpardavimai",
        "SPOT_MARKET_PRICE": "Spot pardavimai",
        "SPOT_MIN_PRICE": "Spot pardavimai su minimaliomis kainomis",
        "HOLD": "Pačių valdomas",
        "UNALLOCATED": "Laukiama veiksmo",
        "VIRTUAL": "Talpinamos paskyros",
        "PPA": "PPA rezervas",
        "OWN_USE": "Savoms reikmėms"
      },
      "certificate_status": {
        "ONGOING_SALE": "Vyksta pardavimas",
        "SOLD": "Parduota",
        "EXPIRED": "Pasibaigusi",
        "NON_TRANSFERRABLE": "Nepakeičiama",
        "RESERVED": "Rezervuota",
        "WAITING_FOR_SALE": "Laukiama pardavimo",
        "AVAILABLE": "Pardavimui prieinama",
        "CANCELLED": "Atšauktas",
        "PENDING": "@:common.pending",
        "TRANSFERRED": "Perkeltas",
        "REVOKED": "Registro atšauktas",
        "OWN_USE": "Savoms reikmėms"
      }
    },
    "noDataMessage": "Nėra ką rodyti. Prašome koreguoti filtrų pasirinkimus.",
    "panel": {
      "title": "Diagrama",
      "region_label": "Lentelėje esančių sertifikatų diagrama",
      "mwh": "{mwh} MWh",
      "summary_rows": "nė vienoje eilutėje · prieinama {available} MWh | {count} eilutėje · prieinama {available} MWh | eilučių: {count} · prieinama {available} MWh",
      "hide": "Slėpti diagramą",
      "show": "Rodyti diagramą",
      "break_down_by": "Išskaidyti pagal",
      "segment_label": "Filtruoti lentelę pagal {field} {value}, {mwh} MWh",
      "segment_inline": "{label} · {mwh} MWh",
      "segment_hint": "Spustelėkite segmentą, kad pagal jį filtruotumėte lentelę"
    }
  },
  "inventory": {
    "actions": {
      "title": "Atsargų valdymas",
      "send": {
        "success": "Siuntimo operacija sėkmingai baigta",
        "prompt": "Kur norėtumėte siųsti šias kilmės garantijas? Prašome nurodyti šalį, kiekius ir gavėjo registro numerį.",
        "simulated_response": "Supratau! Ruošiamasi siųsti jūsų kilmės garantijas."
      },
      "receive": {
        "success": "Gavomo operacija sėkmingai baigta",
        "prompt": "Iš ko tikitės gauti kilmės garantijas? Prašome nurodyti šalį, kiekius ir siuntėjo registro numerį.",
        "simulated_response": "Suprasta! Pranešime jums apie gavimą."
      },
      "buy": {
        "success": "Pirkimo operacija sėkmingai baigta",
        "prompt": "Kokias kilmės garantijas norite pirkti šiandien? Prašome nurodyti šalį, kiekius ir gavėjo registro numerį.",
        "simulated_response": "Puiku! Ieškoma galimų pirkti kilmės garantijų. Štai keletas pasiūlymų: 500 MWh iš Estijos, Vėjo energija, Gamybos data: 2024 sausis, Kaina: €2.50/MWh; 1,000 MWh iš Latvijos, Saulės energija, Gamybos data: 2024 vasaris, Kaina: €3.00/MWh; 750 MWh iš Lietuvos, Hidroenergija, Gamybos data: 2024 kovas, Kaina: €2.75/MWh"
      },
      "sell": {
        "success": "Pardavimo operacija sėkmingai baigta",
        "prompt": "Kurias kilmės garantijas norėtumėte parduoti? Prašome nurodyti šalį, kiekius.",
        "simulated_response": "Tobula! Jūsų kilmės garantijos įtraukiamos į pardavimą. Pranešime jums, kai bus rastas pirkėjas."
      }
    }
  },
  "errors": {
    "genericNetworkError": "Tinklo klaida. Prašome bandyti dar kartą.",
    "missingCompanyId": "Klaida: Trūksta įmonės konteksto.",
    "unsupportedFileType": "Nepalaikomas failo tipas. Prašome įkelti tinkamą failą.",
    "fileTooLarge": "Failas per didelis. Maksimalus dydis 25MB."
  },
  "go_cancel": {
    "beneficiary_suggestions": {
      "placeholder": "Pasirinkite arba įveskite naudos gavėją"
    },
    "statements_title": "Atšaukimo deklaracijos",
    "add_statement_button": "Pridėti atšaukimo deklaraciją",
    "no_statements_yet": "Atšaukimo deklaracijos dar nepridėtos. Spustelėkite „Pridėti atšaukimo deklaraciją\", kad pradėtumėte.",
    "more_statements": "daugiau deklaracijų",
    "statement_number": "Deklaracija #{number}",
    "remove_statement_button": "Pašalinti",
    "remove_statement_row_aria": "Pašalinti atšaukimo deklaracijos eilutę {index}",
    "statement_form_placeholder": "Visa atšaukimo deklaracijos forma bus čia.",
    "confirm_order_button": "Peržiūrėti atšaukimo užsakymą",
    "portfolio_items_title": "Pasirinkite portfelio vienetus atšaukimui",
    "portfolio_table_placeholder": "PortfolioItemsTable bus rodoma čia sertifikatų pasirinkimui.",
    "upload_description": "Įkelkite dokumentą, kad automatiškai išskirtumėte atšaukimo deklaracijas ir gavėjo informaciją",
    "analysis_success_with_statements": "Iš dokumento išskirtos {count} atšaukimo deklaracijos.",
    "analysis_success_no_statements": "Dokumente nerasta atšaukimo deklaracijų.",
    "analysis_complete_title": "Dokumento analizė baigta",
    "analysis_shared_fields_inconsistent_warning": "Bendri laukai tarp deklaracijų nesutampa. Prašome rankiniu būdu patvirtinti gavėjo tipą, laikotarpį ir atšaukimo tikslo šabloną.",
    "shared_defaults_title": "Bendri nustatymai visoms deklaracijoms",
    "shared_defaults_incomplete": "Užpildykite bendrus nustatymus prieš peržiūrint atšaukimo užsakymą.",
    "table_validation_hint": "Kai kurios eilutės yra neužpildytos arba neteisingos. Pataisykite pažymėtus laukus, kad tęstumėte.",
    "max_statements_reached": "Maksimalus {max} atšaukimo deklaracijų skaičius pasiektas. Jei reikia daugiau, padalykite į kelis užsakymus.",
    "analysis_truncated_warning": "Dokumente rasta {total} deklaracijų, bet įkeltos tik pirmos {max}. Pateikite jas kaip atskirą užsakymą, tada įkelkite likusias iš naujo.",
    "form": {
      "prior_year_cutoff_specific": "{year} m. atšaukimai nebegalimi — terminas buvo {cutoffDate}",
      "beneficiary_details_title": "Gavėjo informacija",
      "beneficiary_name": {
        "label": "Gavėjo pavadinimas",
        "placeholder": "Įveskite įmonės arba asmens vardą"
      },
      "beneficiary_type": {
        "label": "Gavėjo tipas",
        "CONSUMER": "Vartotojas",
        "ELECTRICITY_SELLER": "Elektros energijos pardavėjas",
        "CONVERSION_PLANT_OPERATOR": "Konversijos įrenginio operatorius"
      },
      "registry_code": {
        "label": "Registracijos kodas (įmonės arba asmens)",
        "short_label": "Registracijos kodas",
        "placeholder": "Įveskite įmonės registracijos kodą arba asmens kodą"
      },
      "address": {
        "label": "Adresas",
        "placeholder": "Įveskite pilną adresą",
        "required_help": "Adresas yra privalomas šiai šaliai"
      },
      "registry_country_region": {
        "label": "Registro šalis/regionas",
        "placeholder": "Pasirinkite registro šalį arba regioną",
        "mismatch_warning": "Pasirinktas registras skiriasi nuo sertifikato vietos"
      },
      "cancellation_details_title": "Atšaukimo informacija",
      "mwh_cancelled": {
        "label": "Atšaukiama MWh",
        "short_label": "Atšaukta MWh",
        "placeholder": "0"
      },
      "period_start": {
        "label": "Suvartojimo laikotarpio pradžia"
      },
      "period_end": {
        "label": "Suvartojimo laikotarpio pabaiga",
        "invalid_date_range": "Pabaigos data turi būti vėlesnė nei pradžios data",
        "cutoff_help": "{year} m. suvartojimo atšaukimai turi būti pateikti iki {nextYear} m. kovo 31 d."
      },
      "cancellation_purpose": {
        "label": "Atšaukimo tikslas",
        "DISCLOSURE": "Atskleidimas",
        "GRID_LOSSES": "Tinklo nuostoliai",
        "SELF_CONSUMPTION": "Savoji reikmė",
        "SUPPORT_SCHEME": "Paramos schema",
        "OTHER": "Kita"
      },
      "cancellation_purpose_text": {
        "label": "Atšaukimo tikslas",
        "placeholder": "Įveskite atšaukimo tikslą",
        "help": "Trumpai aprašykite, kodėl šie sertifikatai atšaukiami"
      },
      "global_operation_notes": {
        "label": "Bendros pastabos atšaukimo užsakymui (neprivaloma)",
        "placeholder": "Įveskite bendras pastabas visam atšaukimo užsakymui..."
      },
      "keep_private": {
        "label": "Laikyti atšaukimo deklaraciją privačia",
        "hint": "Registras nesukurs viešai prieinamos nuorodos į šios atšaukimo deklaracijos PDF failą.",
        "ppa_hint": "Taikoma tik Grexel platformos registruose (LV, LT, DK, HR, HU, BE-FED, SE, FR); kitur nepaisoma."
      }
    },
    "no_portfolio_items_available": "Šiuo metu nėra prieinamų portfelio vienetų atšaukimui.",
    "tooltip_beneficiary_name": "Juridinis asmuo arba fizinis asmuo, kuris bus nurodytas kaip atšaukimo pareiškimo gavėjas.",
    "tooltip_registry_country_region": "Registras, kuriame bus atliekamas atšaukimas.",
    "tooltip_registry_code": "Įmonės kodas arba asmens kodas — ne PVM mokėtojo kodas. Rodomas atšaukimo pareiškime.",
    "tooltip_address": "Gavėjo registruotas arba objekto adresas. Kai kuriems registrams privalomas.",
    "tooltip_mwh_cancelled": "Atšaukiamų sertifikatų kiekis megavatvalandėmis (MWh). 1 MWh = 1 sertifikatas.",
    "auto_select_certificates_checkbox": "Automatiškai parinkti sertifikatus",
    "order_submitted_successfully": "Atšaukimo užsakymas sėkmingai pateiktas!",
    "order_submission_failed": "Nepavyko pateikti atšaukimo užsakymo. Prašome bandyti dar kartą.",
    "buy_missing_request_sent": "Užklausa pirkti trūkstamas kilmės garantijas išsiųsta. Netrukus su jumis susisieksime.",
    "buy_missing_request_failed": "Nepavyko išsiųsti užklausos dėl trūkstamų kilmės garantijų. Prašome bandyti dar kartą arba susisiekti su palaikymu.",
    "insufficient_inventory_warning": "Įspėjimas: Nepakanka kilmės garantijų atsargose, kad padengtų visą deklaracijose nurodytą MWh. Jūs turite {availableMwh} MWh, bet reikia {neededMwh} MWh.",
    "buy_missing_gos_button": "Užsakyti trūkstamas kilmės garantijas",
    "autoselect_failed": "Nepavyko automatiškai parinkti sertifikatų. Prašome pasirinkti rankiniu būdu arba bandyti dar kartą.",
    "review_modal_statement_title": "Atšaukimas gavėjui: {beneficiaryName} registre",
    "region_mismatch_warning": {
      "title": "Registro neatitikimas",
      "message": "Kai kurie pasirinkti sertifikatai šiuo metu yra kitame registre nei atšaukimui pasirinktas paskirties registras. Prieš vykdydami atšaukimą, perkelsime šiuos sertifikatus į pasirinktą registrą."
    },
    "any_aib_option": "Any AIB",
    "any_aib_address_hint": "Pridėkite {'{'}address{'}'} prie atšaukimo tikslo kaip vietos rezervavimo ženklą naudojant Any AIB. Gavėjo vieta pareiškime bus nurodyta kaip \"Europe\".",
    "address_placeholder_missing_warning": "Atšaukimo tikslas naudoja vietos rezervavimo ženklą {'{'}address{'}'}, bet bent vienas gavėjas neturi adreso. Tose eilutėse tekstas {'{'}address{'}'} bus paliktas nepakeistas.",
    "beneficiary_type_conflict_switch": "Visos šio atšaukimo deklaracijos pateikiamos su gavėjo tipu {sharedType}, tačiau {names} anksčiau naudojo tipą {rememberedType}. Pakeiskite bendrą gavėjo tipą į {rememberedType} arba tęskite, jei ankstesnis tipas nebeaktualus.",
    "beneficiary_type_conflict_mixed": "Visos šio atšaukimo deklaracijos pateikiamos su gavėjo tipu {sharedType}, tačiau šie gavėjai anksčiau naudojo kitą tipą: {details}. Tęskite, jei ankstesni tipai nebeaktualūs.",
    "accelerator_title": "Pradėkite nuo dokumento",
    "summary_order_title": "Atšaukimo užsakymas",
    "summary_mwh_to_cancel": "MWh atšaukti",
    "summary_statements": "Deklaracijos",
    "summary_consumption_period": "Suvartojimo laikotarpis",
    "summary_certificates_selected": "Pasirinkti sertifikatai",
    "summary_mwh_value": "{mwh} MWh",
    "summary_ready": "Paruošta patvirtinti",
    "summary_status_incomplete": "Užpildykite atšaukimo duomenis",
    "summary_status_select": "Pasirinkite atšauktinus sertifikatus",
    "summary_status_match": "Pasirinkite sertifikatų iš viso {mwh} MWh",
    "summary_status_insufficient": "Nepakanka tinkamų atsargų",
    "no_data_short": "—",
    "summary_build_title": "Sudarykite užsakymą",
    "summary_step_beneficiary": "Pridėkite gavėją ir suvartojimą",
    "summary_step_certificates": "Pasirinkite atšauktinus sertifikatus",
    "summary_step_review": "Peržiūrėkite ir patvirtinkite užsakymą",
    "private_pill": "Privatu",
    "statement_options_button_aria": "Deklaracijos {index} parinktys",
    "statement_options_button_private_aria": "Deklaracijos {index} parinktys — laikoma privačia",
    "statement_private_tooltip": "Atšaukimo deklaracija laikoma privačia",
    "carried_selection_summary": "Iš jūsų peržiūros pasirinkimo neperkelta nė viena eilutė. | Iš jūsų peržiūros pasirinkimo perkelta {count} eilutė ({mwh} MWh). | Iš jūsų peržiūros pasirinkimo perkelta eilučių: {count} ({mwh} MWh).",
    "carried_selection_summary_partial": "Iš jūsų peržiūros pasirinkimo neperkelta nė viena eilutė. | Iš jūsų peržiūros pasirinkimo perkelta {count} eilutė ({mwh} MWh, {partial}). | Iš jūsų peržiūros pasirinkimo perkelta eilučių: {count} ({mwh} MWh, {partial}).",
    "carried_selection_partial": "nė viena nėra dalinė | {count} dalinė | dalinių: {count}",
    "carried_selection_paused": "Automatinis parinkimas pristabdytas, kad jų nepakeistų.",
    "carried_selection_use_amount": "Naudoti {mwh} MWh kaip kiekį",
    "carried_selection_clear": "Išvalyti ir parinkti automatiškai",
    "table_hint": "Rodomi tik sertifikatai, kuriuos galima atšaukti. Pažymėtos eilutės atšaukiamos visos; spustelėkite kiekį, kad atšauktumėte tik dalį eilutės.",
    "filter_shortfall": "Jūsų filtrus atitinka tik {available} iš {needed} MWh. Pašalinkite filtrą, kad matytumėte daugiau sertifikatų.",
    "filter_shortfall_unavailable": "Jūsų filtrų neatitinka nė vienas sertifikatas, reikia {needed} MWh. Pašalinkite raudonai pažymėtą filtrą, kad matytumėte savo sertifikatus.",
    "summary_status_filter_shortfall": "Jūsų filtrus atitinka nepakankamai sertifikatų"
  },
  "go_send": {
    "insufficient_inventory_warning": "Įspėjimas: Atsargose nepakanka GO sertifikatų, kad padengtų siuntimo užklausoje nurodytą MWh kiekį. Jūs turite {availableMwh} MWh, bet reikia {neededMwh} MWh.",
    "recipient_hosted_badge": "PRIIMANTIS",
    "recipient_hosted_helper": "Pristatoma į šios įmonės priimančiąją paskyrą Soldera platformoje",
    "recipient_hosted_region_note": "Regionas nustatomas siuntimo metu pagal kiekvieną sertifikatą",
    "recipient_search_placeholder": "Ieškoti pagal įmonės pavadinimą, registracijos kodą arba EECS…",
    "recipient_no_results": "Nerasta atitinkančių įmonių",
    "hosted_delivery_info": "Pristatymo informaciją tvarko Soldera ir ji bus automatiškai nustatyta kiekvienam sertifikatui siuntimo metu.",
    "mixed_registry_selection_error": "Skirtingų registrų sertifikatų negalima siųsti viename užsakyme. Prašome siųsti juos atskirais užsakymais.",
    "unit_price_pln_label": "Vieneto kaina (PLN/MWh)",
    "unit_price_pln_help": "Sutarties vieneto kaina PLN/MWh. Lenkijos registras (TGE) jos reikalauja ir įrašo ją į patį perdavimą."
  },
  "portfolio_instructions": {
    "description": "Aprašymas",
    "ppa_name": "PPA pavadinimas",
    "configuration": "Konfigūracija",
    "allocation_configuration": "Paskirstymo konfigūracija",
    "delivery_configuration": "Pristatymo konfigūracija",
    "allocation_mode": "Paskirstymo režimas",
    "allocate_all": "Visa gamyba",
    "allocate_percentage": "Procentas",
    "whole_production_info": "Visa pasirinktų įrenginių gamyba bus paskirstyta šiai PPA.",
    "allocate_fixed_amount": "Paskirstyti fiksuotą kiekį",
    "allocate_fixed_amounts": "Fiksuoti kiekiai",
    "total_mwh_label": "Iš viso MWh",
    "allocate_fixed_amounts_per_year": "Paskirstyti fiksuotus kiekius per metus",
    "granularity_yearly": "Metinis",
    "granularity_quarterly": "Ketvirtinis",
    "granularity_monthly": "Mėnesinis",
    "granularity": "Tikslumas",
    "leap_year_badge": "Keliamieji metai",
    "current_period_limit": "Paskirstyti fiksuotą kiekį ({amount} {unit}) laikotarpiu {periodLabel}",
    "apply_to_all_years": "Taikyti visiems metams",
    "apply_to_all_years_tooltip": "Nukopijuoti šias reikšmes į visus kitus metus (daliniai ketvirčiai praleidžiami)",
    "reset_year": "Atstatyti",
    "partial_quarter_badge": "Dalinis",
    "partial_period_badge": "Dalinis",
    "contract_range_required_for_granularity": "Nustatykite PPA pradžios ir pabaigos datas žemiau esančioje vykdymo konfigūracijoje, kad galėtumėte konfigūruoti mėnesinius/ketvirtinius apribojimus.",
    "start_date_required_for_granularity": "Mėnesiniams ir ketvirtiniams apribojimams reikalinga PPA pradžios data.",
    "end_date_must_follow_start": "Sutarties pabaigos data turi būti tą pačią dieną arba vėliau nei pradžios data.",
    "invalid_limit_durations_for_granularity": "Apribojimų trukmės neatitinka pasirinkto tikslumo. Pakeiskite apribojimus arba konvertuokite juos pasirinktam tikslumui.",
    "partial_period_hint_single": "Vienas laikotarpis yra dalinis: {firstRange}.",
    "partial_period_hint_multiple": "{count} laikotarpiai yra daliniai: {firstRange} → {lastRange}.",
    "confirm_granularity_switch_title": "Pakeisti paskirstymo tikslumą?",
    "confirm_granularity_switch_body": "Turite ne nulinių reikšmių. Pakeitus jos bus perskirstytos naujam tikslumui. Tęsti?",
    "granularity_switch_title": "Perskirstyti esamas reikšmes?",
    "granularity_switch_body": "Įvedėte reikšmes {from} lygmeniu. Perjungus į {to}, jos bus perskirstytos pagal naują tikslumą.",
    "granularity_switch_from": "Nuo",
    "granularity_switch_to": "Į",
    "granularity_buckets": "{count} laukeliai/metai",
    "granularity_switch_note": "Metų sumos išlieka.",
    "granularity_switch_confirm": "Perskirstyti",
    "matrix_year_total": "Metų iš viso: {total}",
    "year_issues_badge": "{count} klaidos",
    "matrix_grand_total": "Bendras kiekis: {total} MWh ({count} įrašai)",
    "percentage_to_allocate": "Paskirstyti procentas",
    "select_devices": "Pasirinkti įrenginius",
    "search_devices_placeholder": "Ieškoti {count} prieinamų įrenginių...",
    "search_more_devices_placeholder": "{selected} pasirinkta • Ieškoti {available} prieinamų įrenginių",
    "loading_devices": "Įkeliami įrenginiai...",
    "all_devices_selected": "Visi įrenginiai pasirinkti",
    "devices_blocked_by_other_ppas": "Likę įrenginiai naudojami kituose PPA portfeliuose",
    "no_devices_available": "Nėra prieinamų įrenginių",
    "selected_devices": "Pasirinkti įrenginiai",
    "selected_devices_summary": "{count} pasirinkta",
    "add_devices": "Pridėti įrenginius",
    "allocate_percentage_display": "Paskirstyti {percent}%",
    "devices_count_display": "{count} įrenginys(-iai) pasirinkti",
    "from_all": "Iš visų įrenginių",
    "no_instructions_set": "Nėra nustatytų instrukcijų.",
    "editing_title": "Redaguojama: {name}",
    "upload_ppa_document": "Įkelti PPA dokumentą",
    "ppa_document_formats": "Palaikomi PDF, DOC, DOCX failai",
    "ppa_document_upload_error": "Netinkamas PPA dokumento formatas",
    "fixed_amounts_per_year": "Fiksuoti kiekiai per metus",
    "period_limits": "Laikotarpio apribojimai",
    "add_period_limit": "Pridėti laikotarpio apribojimą",
    "remove_period_limit": "Pašalinti laikotarpio apribojimą",
    "select_year": "Pasirinkti metus",
    "mwh_placeholder": "Įveskite MWh limitą",
    "fixed_amount_must_be_gt_zero": "Kiekvienas fiksuotas paskirstymas turi būti didesnis nei 0 MWh",
    "update_success": "Portfelio instrukcijos sėkmingai atnaujintos.",
    "update_success_title": "Sėkmė",
    "remove_device": "Pašalinti įrenginį {deviceName}",
    "device_assigned_to_100_percent_ppa": "Įrenginys '{deviceId}' yra priskirtas 100% PPA ir turi būti išskirtinai priskirtas",
    "device_used_in_fixed_limit_ppa": "Įrenginys '{deviceId}' naudojamas PPA su fiksuotais laikotarpio apribojimais ir negali būti priskirtas jokiai kitai PPA",
    "device_exceeds_100_percent": "Įrenginys '{deviceId}' viršija 100% per visas PPA (iš viso: {totalPercentage}%)",
    "device_cannot_mix_with_exclusive_mode": "Įrenginys '{deviceId}' negali būti naudojamas {currentMode} režime, nes jis jau priskirtas kitoms PPA",
    "fixed_amounts_mode": "fiksuotų kiekių režimas",
    "all_mode": "visos gamybos režimas"
  },
  "hold_strategy": {
    "customize_strategy_title": "Tinkinti savarankiškai valdomų sertifikatų strategiją",
    "about_hold_strategy": "Apie savarankiškai valdomų sertifikatų strategiją",
    "no_hold_instructions": "Nėra sukonfigūruota savarankiškai valdomų sertifikatų strategija",
    "create_hold_portfolio": "Sukurti savarankiškai valdomų sertifikatų strategiją",
    "hold_portfolio": "Savarankiškai valdomi sertifikatai",
    "percentage_to_hold": "Procentas, kurį nukreipti į savarankišką valdymą",
    "scope_all_label": "Bendras sulaikymas (visi įrenginiai)",
    "scope_all_description": "Taikoma visiems nepaskirstytiems sertifikatams.",
    "scope_specific_label": "Tikslinis sulaikymas (konkretūs įrenginiai)",
    "scope_specific_description": "Taikoma tik pasirinktiems įrenginiams. Kiti keliauja į spotą.",
    "targeted_allocation_badge": "{percentage}% iš {deviceCount} įrenginių"
  },
  "ppa_strategy": {
    "customize_strategy_title": "Pritaikyti PPA rezervą",
    "creating_new_ppa_instructions": "Kuriamos naujos PPA rezervo instrukcijos",
    "about_ppa_strategy": "Apie PPA rezervą",
    "no_ppa_instructions": "Nėra sukonfigūruotų PPA rezervo instrukcijų",
    "ppa_agreement": "PPA Sutartis",
    "projected_total": "Prognozuojamas bendras kiekis",
    "delivered": "Pristatyta",
    "no_documents": "Dokumentų nepridėta",
    "fixed_yearly_allocation": "Fiksuotas metinis paskirstymas",
    "percentage_allocation": "{percentage}% gamybos",
    "next_delivery": "Kitas pristatymas"
  },
  "go_buy": {
    "volume_to_buy": "Perkamas kiekis",
    "procurement_fee": "Pirkimo mokestis",
    "purchase_summary": "Pirkimo santrauka",
    "price_breakdown_title": "Kainos išskaidymas",
    "price_breakdown_description": "Kainos seka rinkos trečiųjų šalių indeksus, kad gautumėte geriausią kainą rinkoje. Kiekiai gaunami iš daugiau nei 3000 elektrinių visoje Europoje. Automatizuotas pirkimas suteikia geriausią vertę.",
    "premiums": "Atributų priemokos",
    "upload_description": "Įkelkite dokumentą, aprašantį jūsų pirkimo poreikius",
    "ask_for_quote_button": "Prašyti kainos pasiūlymo",
    "send_purchase_request_button": "Siųsti pirkimo užklausą",
    "purchase_request_submitted": "Pirkimo užklausa pateikta",
    "purchase_request_submitted_detail": "{volume} MWh užklausa sėkmingai pateikta.",
    "agent_quote_prompt": "Pateikite pirkimo užklausą ir Soldera atliks kainų užklausą (RFQ) — indikatyvų pasiūlymą gausite paprastai per vieną darbo dieną",
    "modes": {
      "re100": "RE100",
      "cheapest": "Pigiausias",
      "advanced": "Išplėstinis",
      "re100_help": "RE100: vėjas + saulė, COD ≤ 15 metų, optimizuota kaina",
      "cheapest_help": "Pigiausias: optimizuotos mažiausios sąnaudos, tuo pačiu atitinkant reikalavimus",
      "advanced_help": "Išplėstinis: pritaikykite visus atributus"
    },
    "form": {
      "volume": {
        "label": "Perkamas kiekis (MWh)"
      },
      "operation_notes": {
        "label": "Papildomos pastabos (neprivaloma)",
        "placeholder": "Įveskite specialius reikalavimus ar pastabas šiam pirkimui..."
      }
    },
    "certificate_scheme": "Sertifikatų schema"
  },
  "issuance_reporting": {
    "upload_file": "Įkelti failą",
    "export": "Eksportuoti",
    "add_new": "@:common.add",
    "filters": {
      "period_start": "Nuo mėnesio",
      "period_end": "Iki mėnesio",
      "all_devices": "Visi įrenginiai",
      "all_statuses": "Visi statusai"
    },
    "status": {
      "pending": "@:common.pending",
      "accepted": "Priimta",
      "rejected": "Atmesta",
      "completed": "Užbaigta"
    },
    "table": {
      "device": "Įrenginys",
      "device_code": "Įrenginio kodas",
      "total_production": "Visa gamyba",
      "date": "Data",
      "actions": "Veiksmai"
    },
    "file_upload": {
      "import_summary": "Importuota įrašų: {imported}. Atmesta įrašų: {rejected}.",
      "rejected_records": "Atmesti įrašai",
      "rejected_record": "Įrašas {index} · {device}",
      "country_label": "Šalis",
      "select_country": "Pasirinkite šalį",
      "title": "Įkelti gamybos duomenų ataskaitą",
      "description": "Prašome įkelti gamybos duomenis Excel arba CSV formatu",
      "upload_prompt": "Vilkite failą čia arba spustelėkite norėdami pasirinkti",
      "upload_another": "Įkelti kitą failą",
      "supported_formats": "Palaikomi formatai: .xlsx, .xls, .csv. Dideliuose „Excel“ failuose gali reikėti pašalinti nenaudojamus lapus ir formatavimą arba padalyti juos į mažesnius failus.",
      "analyzing": "Analizuojamas failas...",
      "countries": {
        "ES": {
          "label": "Ispanija"
        },
        "PL": {
          "label": "Lenkija"
        }
      }
    },
    "no_data_for_period": "Nėra duomenų periodui",
    "delete_record": "Ištrinti įrašą",
    "confirm_delete_record": "Ar tikrai norite ištrinti šį įrašą? Šio veiksmo nebus galima atšaukti.",
    "delete_success": "Įrašas sėkmingai ištrintas",
    "update_success": "Gamybos duomenys sėkmingai atnaujinti",
    "create_success": "Gamybos duomenų įrašas sėkmingai sukurtas",
    "export_success": "Duomenys sėkmingai eksportuoti",
    "file_upload_success": "Failas sėkmingai įkeltas. Sukurta {created} įrašų iš {total}.",
    "no_data": "Nėra gamybos duomenų",
    "no_data_description": "Įkelkite gamybos duomenis, kad pradėtumėte.",
    "pl_status": {
      "title": "Pateikimo proceso būsena",
      "production_data_received": "Gamybos duomenys gauti",
      "waiting_for_quarterly_application_submission": "Ketvirčio paraiška laukia pateikimo",
      "application_submitted_to_tge_registry": "Paraiška pateikta",
      "tge_registry_overdue_submission_deadline": "Ketvirčio paraiškos pateikimas vėluoja",
      "goos_issued_successfully": "Kilmės garantijos sėkmingai išduotos"
    },
    "pl_status_flags": {
      "application_fee_paid": "Paraiškos mokestis sumokėtas",
      "application_fee_not_paid": "Paraiškos mokestis nesumokėtas",
      "communication_with_tge_initiated": "Pradėtas susisiekimas",
      "automatic_written_notice": "Automatinis rašytinis pranešimas",
      "telephone_call": "Telefono skambutis"
    },
    "import_not_trusted": "Failus galėsite importuoti aktyvavus paskyrą. Dėl pagalbos kreipkitės į support@soldera.org.",
    "company_required": "Pasirinkite įmonę, kad peržiūrėtumėte išdavimo ataskaitas."
  },
  "links": {
    "trading_procedure": "https://www.soldera.org/lt/atitiktis/prekybos-procedura",
    "trading_procedure_text": "Soldera prekybos procedūra"
  },
  "company_orders": {
    "rfq_timeline": {
      "submitted": "Kainų užklausa (RFQ) pateikta",
      "quote_expected": "Indikatyvus pasiūlymas numatomas iki {date}",
      "approval_gate": "Niekas neperkama be jūsų patvirtinimo"
    },
    "title": "Operacijos",
    "order_type": "Užsakymo tipas",
    "portfolio": "Portfelis",
    "total_selected_mwh": "Kiekis",
    "order_starter": "Užsakymo iniciatorius",
    "initiated_by": "Iniciatorius",
    "order_date": "Užsakymo data",
    "date": "Data",
    "export_csv": "Eksportuoti užsakymus CSV",
    "created": "Sukurta",
    "updated": "Atnaujinta",
    "confirm_order": "Patvirtinti užsakymą",
    "edit_order": "Redaguoti užsakymą",
    "edit_order_title": "Redaguoti įmonės užsakymą",
    "edit_order_success": "Užsakymas sėkmingai atnaujintas.",
    "edit_order_error": "Nepavyko atnaujinti užsakymo.",
    "edit_order_load_error": "Nepavyko įkelti užsakymo informacijos redagavimui.",
    "mwh_mismatch_warning": "Bendras MWh kiekis atšaukimo pareiškimuose ({statementsMwh}) nesutampa su pasirinktais portfelio elementais ({portfolioMwh}). Pakoreguokite MWh vertes arba portfelio pasirinkimą, kad jie sutaptų.",
    "order_details": "Užsakymo detalės",
    "order_information": "Užsakymo informacija",
    "portfolio_items_summary": "Portfelio elementų suvestinė",
    "total_mwh": "Iš viso MWh",
    "support_status": "Paramos statusas",
    "associated_portfolio_items": "Susiję portfelio elementai",
    "no_portfolio_items": "Su šiuo užsakymu nesusieta jokių portfelio elementų.",
    "processing_result": "Apdorojimo rezultatas",
    "order_type_details": "{type} užsakymo informacija",
    "order_types": {
      "SEND": "@:common.actions.send",
      "RECEIVE": "Gauti",
      "BUY": "Pirkti",
      "SELL": "Parduoti",
      "CANCEL": "Atšaukti",
      "BUY_AND_CANCEL": "Pirkti ir atšaukti"
    },
    "loading_portfolio_items": "Įkeliami portfelio elementai...",
    "view": "Peržiūrėti",
    "confirm": "Patvirtinti",
    "reject": "Atmesti",
    "confirm_all": "Patvirtinti visus",
    "confirm_all_message": "Ar tikrai norite patvirtinti visus {count} laukiančius užsakymus? Apdorojimas prasidės automatiškai.",
    "confirm_order_message": "Ar tikrai norite patvirtinti šį užsakymą? Apdorojimas prasidės automatiškai.",
    "reject_all": "Atmesti visus",
    "batch_confirm_success": "Sėkmingai patvirtinta {count} užsakymų",
    "batch_confirm_partial": "Patvirtinta {success} užsakymų, nepavyko {failed}",
    "batch_reject_success": "Sėkmingai atmesta {count} užsakymų",
    "batch_reject_partial": "Atmesta {success} užsakymų, nepavyko {failed}",
    "status": {
      "waiting_confirmation": "Laukia patvirtinimo",
      "pending": "Laukia",
      "pending_agent": "Rankinis apdorojimas",
      "processing": "Apdorojama",
      "completed": "Užbaigta",
      "failed": "Nepavyko",
      "cancelled": "Atšaukta"
    },
    "send": {
      "recipient_information": "Gavėjo informacija",
      "company_name": "Įmonės pavadinimas",
      "registry_country": "Registro šalis",
      "eecs_account_id": "EECS paskyros ID",
      "internal_account_id": "Registro vidinės sąskaitos numeris",
      "unit_price_pln": "Vieneto kaina (PLN/MWh)",
      "operation_notes": "Operacijos pastabos",
      "portfolio_items_title": "Pasirinkite portfelio vienetus siuntimui"
    },
    "cancel": {
      "total_statements": "Iš viso pareiškimų",
      "total_mwh_cancelled": "Iš viso panaikinta MWh",
      "statement": "Pareiškimas",
      "address": "@:common.address",
      "period": "@:cancellation.table.period",
      "purpose": "Tikslas"
    },
    "sell": {
      "sale_summary": "Pardavimo paruošimas",
      "hold_to_spot_description": "Šis užsakymas perkelia pasirinktus Kilmės garantijų sertifikatus iš savarankiškai valdomo portfelio į „@:{'charts.values.portfolio_type.SPOT_MARKET_PRICE'}“ portfelį pardavimui rinkoje.",
      "hold_to_min_price_description": "Šis užsakymas perkelia pasirinktus Kilmės garantijų sertifikatus iš savarankiškai valdomo portfelio į „@:{'charts.values.portfolio_type.SPOT_MIN_PRICE'}“ portfelį (minimali kaina €{minimumPrice}/MWh).",
      "process_information": "Proceso informacija",
      "source_portfolio": "Šaltinio portfelis",
      "destination_portfolio": "Paskirties portfelis",
      "operation_type": "Operacijos tipas",
      "internal_portfolio_transfer": "Vidinis portfelio perkėlimas"
    },
    "buy": {
      "purchase_summary": "Pirkimo suvestinė",
      "volume": "Kiekis",
      "total_price": "Bendra kaina",
      "go_specifications": "EAC specifikacijos",
      "eac_source": "EAC šaltinis",
      "technology": "Technologija",
      "ecolabel": "Ekoženklas",
      "vintage": "Gamybos metai",
      "support": "Parama",
      "operation_notes": "Operacijos pastabos",
      "purchase_mode": "Pirkimo režimas",
      "cod_requirement": "COD reikalavimas",
      "matching": "Suderinimas",
      "order_summary": "Užsakymo santrauka",
      "total_price_per_mwh": "Bendra kaina už MWh",
      "uploaded_contract": "Įkeltas sutartis",
      "contract": "Sutartis"
    },
    "generic": {
      "no_additional_details": "Papildomos informacijos nėra."
    },
    "transactions": {
      "no_portfolio_items": "Šio sandorio kilmės garantijoms portfelio elementų įrašų nėra.",
      "transaction_type": "Sandorio tipas",
      "awaiting_confirmation": "{count} užsakymas laukia patvirtinimo | {count} užsakymai laukia patvirtinimo",
      "in_progress": "{count} vykdoma",
      "no_transactions": "Operacijų nėra",
      "load_more": "Įkelti daugiau",
      "more_transactions": "dar {count} operacijos",
      "registry_transaction": "Registro operacija",
      "registry_transactions": "Registro operacijos",
      "not_yet_in_registry": "Registre dar nematoma",
      "occurred": "Įvyko",
      "connection": "Registro jungtis",
      "volume": "Kiekis",
      "certificates": "Sertifikatai",
      "volume_in_registry": "Kiekis registre",
      "certificates_in_registry": "Sertifikatai registre",
      "counterparty": "Sandorio šalis",
      "counterparty_account": "Sandorio šalies sąskaita",
      "counterparty_eecs": "Sandorio šalies EECS",
      "event_group": "Registro operacijų grupė",
      "events": "Registro operacijos",
      "event_count": "Operacijos",
      "from": "Nuo",
      "to": "Iki",
      "total": "Iš viso",
      "showing": "{shown} iš {total}",
      "technology": "Technologija",
      "production_month": "Gamybos mėnuo",
      "production_device": "Gamybos įrenginys",
      "production_device_count": "Įrenginiai: {count}",
      "event_group_label": "{label} · {count}",
      "event_types": {
        "ISSUANCE": "Išdavimas",
        "INCOMING_TRANSFER": "Gaunamas pervedimas",
        "OUTGOING_TRANSFER": "Siunčiamas pervedimas",
        "CANCEL": "Panaikinimas",
        "EXPIRY": "Galiojimo pabaiga",
        "REVOCATION": "Atšaukimas"
      },
      "event_row_types": {
        "ISSUANCE": "Registro išdavimas",
        "INCOMING_TRANSFER": "Registro gaunamas pervedimas",
        "OUTGOING_TRANSFER": "Registro siunčiamas pervedimas",
        "CANCEL": "Registro panaikinimas",
        "EXPIRY": "Registro galiojimo pabaiga",
        "REVOCATION": "Registro atšaukimas",
        "ALLOCATION": "Portfelio paskirstymas",
        "RETURN": "Portfelio grąžinimas"
      },
      "event_group_types": {
        "ISSUANCE": "Registro išdavimai",
        "INCOMING_TRANSFER": "Registro gaunami pervedimai",
        "OUTGOING_TRANSFER": "Registro siunčiami pervedimai",
        "CANCEL": "Registro panaikinimai",
        "EXPIRY": "Registro galiojimo pabaigos",
        "REVOCATION": "Registro atšaukimai",
        "ALLOCATION": "Portfelio paskirstymai",
        "RETURN": "Portfelio grąžinimai"
      }
    }
  },
  "hosted_accounts": {
    "receive_new_gos_title": "Gauti naujų kilmės garantijų",
    "receive_new_gos_description": "Nustatykite ketinimą gauti kilmės garantijų į Soldera talpinamą registro sąskaitą. Tai naudojame įeinantiems pervedimams suderinti.",
    "select_country": "Pasirinkite šalį, kurioje norite gauti kilmės garantijų",
    "select_country_placeholder": "Pasirinkite šalį...",
    "select_country_first": "Norėdami tęsti, pasirinkite šalį",
    "hosted_account": "Talpinama sąskaita",
    "account_details_heading": "Pasidalykite šiais duomenimis su siuntėju",
    "transfer_identification_heading": "Nustatykite gaunamą perkėlimą",
    "description": "Pateikite šiuos Soldera registro duomenis kilmės garantijas siunčiančiai šaliai, kad perkėlimas pasiektų tinkamą sąskaitą.",
    "company_name": "Įmonės pavadinimas",
    "eecs_account": "EECS sąskaita",
    "amount_mwh": "Kiekis (MWh)",
    "sender_company_name": "Siuntėjo įmonės pavadinimas",
    "sender_eecs_account": "Siuntėjo EECS sąskaita",
    "counterparty_email": "Siuntėjo el. paštas",
    "optional_notes_on_email": "Pastabos pranešimo el. laiške",
    "operation_notes_placeholder": "Pridėkite specialias instrukcijas ar pastabas...",
    "create_receive_order": "Sukurti gavimo užsakymą",
    "create_order": "Sukurti gavimo užsakymą",
    "advanced_options": "Išplėstinės parinktys",
    "company_name_copied": "Įmonės pavadinimas nukopijuotas!",
    "eecs_account_copied": "EECS sąskaita nukopijuota!",
    "copy_fallback": "Nukopijuota (atsarginis metodas)",
    "copy_failed": "Kopijuoti nepavyko. Nukopijuokite rankiniu būdu.",
    "no_regions_unlocked": "Jūsų organizacijai dar nesukonfigūruotos talpinamos sąskaitos.",
    "contact_us_cta": "Susisiekite su mumis",
    "contact_us_title": "Reikia gauti kitoje šalyje?",
    "contact_us_title_no_accounts": "Pasiruošę gauti kilmės garantijas?",
    "contact_us_description": "Susisiekite su mumis, norėdami įsigyti daugiau talpinamų sąskaitų.",
    "contact_us_description_no_accounts": "Susisiekite su mumis, kad nustatytumėte pirmąją talpinamą sąskaitą.",
    "contact_us_button": "Susisiekite su mumis",
    "no_accounts_configured": "Talpinamos sąskaitos nesukonfigūruotos. Norėdami pradėti, susisiekite su mumis.",
    "company_id_missing": "Įmonės ID trūksta"
  },
  "receive_order": {
    "repeating_label": "Pasikartojimo grafikas",
    "repeating_options": {
      "none": "Vienkartinis",
      "monthly": "Kas mėnesį",
      "quarterly": "Kas ketvirtį",
      "half_yearly": "Kas pusmetį",
      "yearly": "Kasmet"
    },
    "at_least_one_required": "Užpildykite bent vieną iš šių laukų, kad padėtumėte mums atpažinti perkėlimą"
  },
  "portfolios": {
    "title": "Portfeliai",
    "description": "Peržiūrėkite ir valdykite visus savo portfelių paskirstymus. Pervadinkite, atskirkite, sujunkite arba perkelkite įrašus tarp portfelių.",
    "show_items": "Nėra įrašų | Rodyti {count} įrašą | Rodyti {count} įrašų",
    "merge": "Sujungti",
    "split": "Atskirti",
    "merge_modal_title": "Sujungti portfelius",
    "source_portfolio": "Šaltinio portfelis",
    "target_portfolio": "Tikslinis portfelis",
    "select_target_placeholder": "Pasirinkite tikslinį portfelį...",
    "merge_confirm_warning": "Visi įrašai iš {source} bus perkelti į {target}. Šaltinio portfelis bus visam laikui ištrintas.",
    "merge_info": "Pasirinkite tikslinį portfelį, kad pamatytumėte sujungimo detales. Šaltinio portfelis bus ištrintas po sujungimo.",
    "volume_and_items": "{volume} MWh • {count} įrašų",
    "split_modal_title": "Atskirti portfelį",
    "split_select_items": "Pasirinkite sertifikatus perkėlimui",
    "split_new_name_label": "Naujo portfelio pavadinimas",
    "split_new_name_placeholder": "pvz., Partija B",
    "split_default_name": "Atskirta nuo {name} {date}",
    "items_selected": "Nepasirinktas joks įrašas | {count} įrašas pasirinktas | {count} įrašų pasirinkta",
    "confirm_merge": "Patvirtinti sujungimą",
    "confirm_split": "Patvirtinti atskyrimą",
    "section_inventory": "Atsargos",
    "section_inventory_desc": "KG prieinami veiksmams, tokiems kaip siuntimas, atšaukimas ir kt.",
    "section_spot": "Spot pardavimai",
    "section_spot_desc": "KG eilėje pardavimui spot rinkoje.",
    "section_ppa": "PPA",
    "section_ppa_desc": "Rezervuota būsimiems įsipareigojimams.",
    "section_forwards": "Išankstiniai sandoriai",
    "section_forwards_desc": "Rezervuota išankstiniams pardavimams.",
    "volume_label_inventory": "Prieinama",
    "volume_label_spot": "Eilėje pardavimui",
    "volume_label_ppa": "Rezervuota",
    "volume_label_forwards": "Rezervuota",
    "badge_own_registry": "Prijungta",
    "badge_soldera_account": "Talpinama",
    "badge_spot_market": "Rinkos kaina",
    "badge_spot_min": "Min {price} EUR",
    "badge_spot_min_default": "Minimali kaina",
    "badge_stx": "STX",
    "badge_ppa": "PPA",
    "badge_forward": "Išankstinis sandoris",
    "badge_default": "Numatytasis",
    "tooltip_own_registry": "Kilmės garantijos įmonės prijungtoje EECS registro sąskaitoje",
    "tooltip_soldera_account": "Kilmės garantijos Soldera talpinamoje sąskaitoje įmonės vardu",
    "tooltip_spot_market": "Parduota dabartine rinkos kaina",
    "tooltip_spot_min": "Parduota tik kai rinkos kaina atitinka minimalų slenkstį",
    "tooltip_default": "Numatytasis paskirstymo portfelis. Negalima sujungti.",
    "view_ppa_config": "Konfigūruoti",
    "view_forwards": "Peržiūrėti išankstinius sandorius",
    "move_items": "Perkelti",
    "move_modal_title": "Perkelti įrašus",
    "move_modal_desc": "Pasirinkite tikslinį portfelį ir pažymėkite įrašus, kuriuos norite perkelti.",
    "move_target": "Tikslinis portfelis",
    "select_move_target": "Pasirinkite tikslą...",
    "confirm_move": "Patvirtinti perkėlimą",
    "no_portfolios": "Šiame skyriuje portfelių nerasta.",
    "empty_inventory": "Šiuo metu atsargose nėra KG. KG atsiras čia po gavimo arba pirkimo.",
    "empty_portfolio": "Šiame portfelyje nėra įrašų.",
    "show_empty": "Rodyti {count} tuščių portfelių",
    "hide_empty": "Slėpti tuščius portfelius",
    "badge_own_use": "Neprekiaujama",
    "tooltip_own_use": "Kilmės garantijos, registre pažymėtos kaip skirtos savoms reikmėms. Jų negalima parduoti, perleisti ar anuliuoti."
  },
  "production_strategy": {
    "title": "Gamybos strategija",
    "overview": "Apžvalga",
    "ppa_settings": "PPA nustatymai",
    "self_managed_settings": "Savarankiško valdymo nustatymai",
    "spot_settings": "Spot pardavimų nustatymai",
    "issuance_report": "Išdavimo ataskaita",
    "forward_commitments": "Išankstiniai įsipareigojimai",
    "whole_year": "Visi metai",
    "from_this_month_onward": "Nuo šio mėnesio",
    "bulk_issuance_report": "TSO deklaracija Excel",
    "generating_report": "Generuojama...",
    "generating_report_progress": "Generuojama... {current}/{total}",
    "report_duration_hint": "Kiekvienos įmonės duomenys iš registro gaunami paeiliui, todėl tai gali užtrukti. Galite palikti šį puslapį ir grįžti vėliau.",
    "download_report": "Atsisiųsti ataskaitą",
    "generate_new_report": "Generuoti naują",
    "report_generated_at": "Sugeneruota {time}",
    "report_failed": "Nepavyko - Bandykite dar kartą",
    "bulk_issuance": {
      "button_text": "Išduoti visas kilmės garantijas",
      "title": "Išduoti visas kilmės garantijas",
      "description": "Pasirinkite gamybos laikotarpį ir įmones išdavimui:",
      "production_period": "Gamybos laikotarpis",
      "period_error": "Pradžios mėnuo turi būti mažesnis arba lygus pabaigos mėnesiui",
      "companies_label": "@:common.companies",
      "no_companies": "Šiai paskyrai nerasta HKNR įmonių.",
      "confirm_all": "Patvirtinti visas deklaracijas",
      "confirm_title": "Patvirtinti masinį išdavimą",
      "confirm_message": "Išduodamos kilmės garantijos {count} įmonei(-ėms). Jei įmonė neturi įrenginių, ji bus praleista.\n\n\"Proof of origin/Herkunftsnachweis\" tekstas formoje bus paliktas tuščias.\n\"Subsidy for electricity generation/Förderung der Stromerzeugung\" formoje bus paliktas toks, koks yra.\n\nAr tikrai norite tęsti?",
      "cancel_title": "Atšaukti masinį išdavimą",
      "cancel_message": "Ar tikrai norite atšaukti? Jau išduotų sertifikatų atšaukti negalima.",
      "already_processed": "Jau apdorotos įmonės:",
      "in_progress": "Vykdoma",
      "status": {
        "pending": "@:common.pending",
        "in_progress": "Apdorojama...",
        "completed": "{count} įrenginys(-iai) pateikta",
        "skipped": "Praleista (nėra ką išduoti)",
        "error": "Klaida"
      }
    },
    "yearly_allocations": "Metiniai paskirstymai",
    "production_allocations": "Gamybos paskirstymai",
    "company_production": "Įmonės gamyba",
    "show_all_companies": "Rodyti visas įmones",
    "not_available_consolidated": "Konsoliduotame vaizde nepasiekiama",
    "next_year": "Kiti metai",
    "ppa": "PPA",
    "agreements": "sutartys",
    "ppa_agreements": "PPA sutartys",
    "documents": "@:common.documents",
    "display_name": "Rodomas pavadinimas",
    "no_display_name": "Nėra rodomo pavadinimo",
    "display_name_help": "Automatiškai sugeneruota pagal sandorio detales",
    "action_instructions": "Veiksmo instrukcijos",
    "execution_configuration": "Vykdymo konfigūracija",
    "delivery_method": "Pristatymo būdas",
    "automatic": "Vykdyti automatiškai",
    "manual": "Prašyti patvirtinimo",
    "automatic_explainer": "sistema automatiškai įvykdo sandorį numatytą dieną — rankinio patvirtinimo nereikia.",
    "manual_explainer": "numatytu vykdymo metu sistema sukuria įmonės užsakymą, kurį prieš įvykdymą reikia patvirtinti rankiniu būdu.",
    "execution_method": "Vykdymo būdas",
    "execution_method_aria": "Vykdymo būdas",
    "delivery_method_aria": "Pristatymo būdas",
    "delivery_timing": "Pristatymo dažnis",
    "execution_timing": "Vykdymo dažnis",
    "yearly": "Kartą per metus",
    "half_year": "Kas pusmetį",
    "quarterly": "Kas ketvirtį",
    "monthly": "Kas mėnesį",
    "fixed_dates": "Fiksuotos datos",
    "fixed_dates_count": "{count} fiksuotos datos",
    "fixed_delivery_dates": "Fiksuotos pristatymo datos",
    "add_date": "Pridėti datą",
    "end_date": "Pabaigos data",
    "ppa_contract_end_date": "PPA sutarties pabaigos data",
    "end_date_help": "Kada baigiasi PPA sutartis",
    "ppa_contract_start_date": "PPA sutarties pradžios data",
    "start_date_help": "Kada prasideda PPA sutartis (reikalinga mėnesiniam/ketvirtiniam apribojimams)",
    "transaction_type": "Sandorio tipas",
    "send": "Siųsti",
    "cancel": "@:common.cancel",
    "send_help": "Perduoti KG gavėjui",
    "cancel_help": "Nurašyti KG gavėjo naudai",
    "send_details": "Siuntimo detalės",
    "counterparty_details": "Sandorio šalies duomenys",
    "transaction_type_aria": "Sandorio tipas",
    "q4_production_execution_date": "Q4 vykdymo data:",
    "q1_production_execution_date": "Q1 vykdymo data:",
    "q2_production_execution_date": "Q2 vykdymo data:",
    "q3_production_execution_date": "Q3 vykdymo data:",
    "h1_production_delivery_date": "H1 gamybos pristatymo data:",
    "h2_production_delivery_date": "H2 gamybos pristatymo data:",
    "h3_production_delivery_date": "H3 gamybos pristatymo data:",
    "h4_production_delivery_date": "H4 gamybos pristatymo data:",
    "allocation_mode_aria": "Paskirstymo būdas",
    "remove_recurring_date": "Pašalinti pasikartojančią datą",
    "cancel_details": "Atšaukimo detalės",
    "recipient_company": "Gavėjo įmonė",
    "recipient_country": "Gavėjo šalis",
    "recipient_eecs_account": "Gavėjo EECS sąskaita",
    "recipient_internal_account_number": "Registro vidinės sąskaitos numeris",
    "recipient_internal_account_help": "Pasirinktinai. Reikalinga tik registrams, kurie naudoja sub-sąskaitas.",
    "recipient_internal_account_placeholder": "Pasirinktinio sub-sąskaitos ID",
    "notes": "Pastabos",
    "notes_placeholder": "Papildomos pastabos šiam PPA (neprivaloma)",
    "analyze_files": "Analizuoti failus",
    "yearly_delivery_day": "Data 1 (Metinis pristatymas)",
    "half_year_delivery_days": "Pusmečio pristatymo datos",
    "quarterly_delivery_days": "Ketvirčio pristatymo datos",
    "monthly_delivery_day": "Mėnesio pristatymo diena",
    "last_day_of_month": "Paskutinė diena",
    "recurring_delivery_dates": "Pasikartojančios pristatymo datos",
    "recurring_execution_dates": "Pasikartojančios vykdymo datos",
    "recurring_dates_description": "Pasirinkite dienos+mėnesio kombinacijas, kurios kartosis kasmet iki PPA pabaigos datos",
    "recurring_dates_description_monthly": "Pasirinkite mėnesio dieną, kada vyks vykdymas.",
    "recurring_dates_description_quarterly": "Nurodykite vykdymo datas kiekvienam ketvirčiui (parodyta darbo tvarka).",
    "recurring_dates_description_half_year": "Pasirinkite vykdymo datas pirmajam ir antrajam pusmečiui.",
    "recurring_dates_description_yearly": "Pasirinkite vieną metinę vykdymo datą.",
    "recurring_dates_description_fixed_dates": "Pridėkite vykdymo datas, kurios kartosis sutartyje iš eilės.",
    "add_recurring_date": "Pridėti pasikartojančią datą",
    "first_half": "Data 1 - Pirmas pusmetis",
    "second_half": "Data 2 - Antras pusmetis",
    "date_1_q1": "Data 1 - Q1",
    "date_2_q2": "Data 2 - Q2",
    "date_3_q3": "Data 3 - Q3",
    "date_4_q4": "Data 4 - Q4",
    "quarter_range_q1": "(Sau-Kov)",
    "quarter_range_q2": "(Bal-Bir)",
    "quarter_range_q3": "(Lie-Rgs)",
    "quarter_range_q4": "(Spa-Gru)",
    "thinking": "Mąstau ...",
    "forward_sales": "Išankstiniai pardavimai",
    "forward_sales_overview": {
      "title": "Išankstinių pardavimų apžvalga"
    },
    "forward_pools_list": {
      "title": "Jūsų aktyvūs telkiniai",
      "empty": "Jūsų įmonės nepriklauso jokiam aktyviam telkiniui.",
      "load_failed": "Telkinių nepavyko įkelti."
    },
    "forward_materials": {
      "description": "\"Soldera\" išankstinių pardavimų paslauga skirta padėti jums užsitikrinti numatomą pajamų srautą ir sumažinti kainų svyravimo riziką, nereikalaujant kasdieninio išankstinių pardavimų valdymo.",
      "outlook_info_1": "Sužinokite apie pagrindines rinkos tendencijas ir pamatykite, kaip keitėsi kainos istoriškai.",
      "outlook_info_2": "Supraskite, kaip \"Soldera\" išankstinių pardavimų paslauga gali padėti jums užsitikrinti pajamas.",
      "strategy_title": "\"Soldera\" išankstinių pardavimų prekybos strategija",
      "strategy_info": "Gaukite išsamią informaciją apie tai, kaip mes vykdome išankstinius pardavimus jūsų vardu.",
      "framework_title": "Išankstinių pardavimų sistema",
      "framework_info": "Peržiūrėkite visų per \"Soldera\" atliekamų išankstinių pardavimų teisines sąlygas."
    },
    "of_projected_production_per_quarter": "prognozuojamos gamybos per ketvirtį",
    "hedged": "Apsidrausta",
    "already_committed": "Jau įsipareigota",
    "for_upcoming_sales": "Būsimiems pardavimams",
    "self_managed_certificates": "Savarankiškai valdomi sertifikatai",
    "self_manage": "Savarankiškas valdymas",
    "allocation": "Paskirstymas",
    "allocated": "Paskirstyta",
    "spot_sale": "Spot pardavimas",
    "sell_at_highest_bid": "Parduoti už didžiausią pasiūlymą",
    "reserved_for_ppas": "Rezervuota PPA",
    "hedged_for_forward_sales": "Apsidrausta išankstiniams pardavimams",
    "committed_forward": "Įsipareigota forward",
    "forward_estimate": "įvertis",
    "forward_estimate_note": "Apytikslė dalis iš bendro fondo",
    "to_be_sold": "Bus parduota",
    "to_be_sold_description": "Išankstiniam pardavimui pasiūlytas, dar neparduotas kiekis, paskirstytas mėnesiams, kuriais po esamų įsipareigojimų dar lieka gamybos.",
    "sell_all_remaining_spot": "Parduoti visą likutį spot rinkoje",
    "ppa_allocation_card": "PPA paskirstymo kortelė",
    "forward_allocation_card": "Išankstinių pardavimų paskirstymo kortelė",
    "self_managed_allocation_card": "Savarankiškai valdomų sertifikatų paskirstymo kortelė",
    "spot_allocation_card": "Spot pardavimų paskirstymo kortelė",
    "wizard_step_action": "Veiksmas",
    "wizard_step_allocation": "@:production_strategy.allocation",
    "wizard_step_execution": "Vykdymas ir peržiūra",
    "wizard_step_1_hint": "Numeskite sutartį automatiniam užpildymui arba tęskite rankiniu būdu",
    "show_all_as_one_form": "Rodyti viską kaip vieną formą",
    "new_ppa_portfolio": "Naujas PPA portfelis",
    "edit_ppa_portfolio": "Redaguoti PPA portfelį",
    "ppa_modal_crumb": "Gamybos strategija · PPA",
    "step_x_of_y": "Žingsnis {current} iš {total}",
    "save_ppa": "Išsaugoti PPA",
    "prefill_from_document": "Užpildyti iš dokumento",
    "portfolio_name_title": "Portfelio pavadinimas",
    "portfolio_name_desc": "Kaip šis PPA rodomas jūsų skydeliuose.",
    "contract_dates_title": "Sutarties datos",
    "contract_dates_desc": "Kada PPA sutartis prasideda ir baigiasi.",
    "action_title": "Veiksmas",
    "action_desc": "Kas turėtų įvykti su šio PPA GO.",
    "allocation_title": "@:production_strategy.allocation",
    "allocation_desc": "Kiek gamybos yra apimta.",
    "devices_title": "Įrenginiai",
    "devices_desc": "Kurie įrenginiai teikia energiją.",
    "execution_title": "Vykdymas",
    "execution_desc": "Kada ir kaip vykdomos operacijos.",
    "review_title": "Peržiūra",
    "review_desc": "Kas įvyks išsaugojus.",
    "notes_title": "Pastabos",
    "notes_desc": "Pridėkite vidinį kontekstą šiam PPA.",
    "upload_ppa_to_auto_fill": "Įkelti PPA dokumentą automatiniam užpildymui",
    "upload_ppa_auto_fill_subtitle": "Numeskite PDF, DOC arba DOCX — ištrauksime, ką galime. Vėliau galėsite viską redaguoti.",
    "or_skip_and_continue": "arba praleisti ir tęsti žemiau",
    "what_is_this_ppa_for": "Kam skirtas šis PPA?",
    "send_certificates": "Siųsti sertifikatus",
    "cancel_on_behalf": "Atšaukti kieno nors vardu",
    "send_label": "@:common.actions.send",
    "send_explainer": "perveda sertifikatus į priešingos šalies registro sąskaitą — jie juos gauna ir gali naudoti arba panaikinti patys.",
    "cancel_on_behalf_label": "Atšaukti kieno nors vardu",
    "cancel_on_behalf_explainer": "panaikina sertifikatus priešingos šalies vardu — nieko neperkelia, sertifikatai sunaudojami jų vardu.",
    "not_set": "Nenustatyta",
    "no_devices_selected": "Nepasirinkti įrenginiai",
    "review_cancel_for": "Atšaukta {name}",
    "review_cancel_generic": "Atšaukti kieno nors vardu",
    "review_n_periods": "{count} laikotarpių",
    "review_devices_summary": "{count} pasirinkta · {mw} MW",
    "review_counterparty_label": "Priešinga šalis",
    "review_allocation_label": "@:production_strategy.allocation",
    "review_devices_label": "Įrenginiai",
    "review_execution_label": "Vykdymas",
    "automatic_short": "Automatinis",
    "manual_short": "Rankinis"
  },
  "ecolabels": {
    "documents_modal": {
      "title": "Dokumentai — {name}",
      "open_hint": "Peržiūrėti ir atsisiųsti iš pradžių įkeltus dokumentus",
      "empty": "Šiam įrenginiui nėra jums matomų dokumentų.",
      "download": "Atsisiųsti"
    },
    "fuzzy_search_placeholder": "Ieškoti įrenginių pagal pavadinimą, registracijos ID ar adresą…",
    "renewable_types": {
      "solar": "Saulė",
      "wind": "Vėjas",
      "hydro": "Hidro",
      "geothermal": "Geoterminė",
      "bioenergy": "Bioenergija",
      "marine": "Jūros energija",
      "other": "Kita"
    },
    "statuses": {
      "pending_review": "Laukia peržiūros",
      "pre_approved": "Iš anksto patvirtintas",
      "rejected": "Atmestas",
      "approved": "Patvirtintas",
      "not_approved": "Nepatvirtintas"
    },
    "upload": {
      "add_manually": "Pridėti įrenginį rankiniu būdu",
      "pending_hint": "Dideli failai gali užtrukti kelias minutes — tuo metu galite toliau redaguoti eilutes.",
      "wait_for_ai": "Prieš pateikdami palaukite, kol asistentas baigs",
      "duplicate_of_row_named": "Eilutė {row} („{name}“) šiame įkėlime",
      "open_in_catalog": "Atidaryti kataloge",
      "back_to_catalog": "Grįžti į įrenginių katalogą",
      "title": "Pateikti įrenginius išankstiniam patvirtinimui",
      "subtitle": "Įkelkite įrenginių sąrašą (lentelę, registro išrašą, el. laišką ar PDF) ir peržiūrėkite eilutes prieš pateikdami.",
      "seller_company": "Pardavėjo įmonė",
      "no_seller_company": "Prie jūsų paskyros nepriskirta jokia įgaliota pardavėjo įmonė. Dėl prieigos kreipkitės į EKOenergy.",
      "chat_title": "Įkelkite įrenginių sąrašą",
      "review_title": "Peržiūrėkite išgautus įrenginius",
      "review_counts": "{total} eilučių, {selected} pasirinkta",
      "select_all": "Pasirinkti visus",
      "select_all_without_duplicates": "Pasirinkti visus be dublikatų",
      "check_and_next": "Pažymėti ir toliau",
      "irec_relaxed_hint": "Identifikuotas kaip I-REC įrenginys pagal Evident nuorodą / įrenginio kodą. Technologija ir vieta čia neprivalomos — peržiūrėtojai jas patikrina Evident sistemoje.",
      "irec_lookup_loading": "Ieškome įrenginio Evident įrenginių registre…",
      "irec_lookup_found": "Įrenginio duomenys užpildyti iš Evident įrenginių registro — patikrinkite ir, jei reikia, pataisykite. Technologija ir vieta čia neprivalomos; peržiūrėtojai jas patikrina Evident sistemoje.",
      "irec_lookup_not_found": "Šis kodas Evident įrenginių registre nerastas. Įveskite įrenginio pavadinimą ir šalį patys; technologija ir vieta lieka neprivalomos.",
      "irec_lookup_unavailable": "Nepavyko pasiekti Evident įrenginių registro. Įveskite įrenginio pavadinimą ir šalį patys; technologija ir vieta lieka neprivalomos.",
      "deselect_all": "Atšaukti pasirinkimą",
      "empty_state": "Iš įkelto failo išgauti įrenginiai atsiras čia peržiūrai.",
      "flags": "Patikros",
      "flag_ok": "OK",
      "flag_incomplete": "Trūksta laukų",
      "all_fields": "Visi laukai",
      "flag_duplicate": "{count} dublikatas?",
      "flag_duplicate_hint": "Rasta galimų dublikatų — spustelėkite, kad pamatytumėte atitikmenis",
      "flag_reg_id": "ID: {quality}",
      "flag_reg_id_hint": "Registracijos ID nepavyko patvirtinti pagal žinomus registrų formatus",
      "blocked_row_hint": "Užpildykite trūkstamus privalomus laukus, kad eilutė būtų įjungta",
      "blocked_rows_note": "{count} eilutė(s) užblokuotos dėl trūkstamų privalomų laukų",
      "field_address_or_coordinates": "Adresas arba koordinatės",
      "missing_fields": "Trūksta: {fields}",
      "duplicate_details": "Galimi dublikatai",
      "duplicate_what_to_do": "Jei tai tikrai skirtingos jėgainės, tiesiog pateikite — peržiūrėtojai mato tas pačias žymas. Jei eilutė tikrai dublikatas, ištrinkite vieną iš jų (✕).",
      "show_row": "Rodyti eilutę",
      "duplicate_of_catalog": "Esamas įrenginys “{name}” ({status})",
      "duplicate_of_row": "Eilutė {row} šiame įkėlime",
      "submit_selected": "Pateikti {count} įrenginį(-ius) peržiūrai",
      "submitted_title": "{count} įrenginys(-iai) pateikti peržiūrai",
      "submitted_flagged": "{count} galimos dublikatų poros pažymėtos peržiūrėtojams.",
      "view_submissions": "Peržiūrėti pateikimus",
      "upload_more": "Įkelti daugiau"
    },
    "submissions": {
      "collapse_all": "Sutraukti viską",
      "title": "Pateikimai",
      "subtitle_admin": "Peržiūrėkite pateiktus įrenginius: patikrinkite žymas, tada patvirtinkite arba atmeskite.",
      "subtitle_seller": "Jūsų pateiktos įrenginių partijos ir jų peržiūros būsena.",
      "submit_devices": "Pateikti įrenginius",
      "empty": "Įrenginių pateikimų dar nėra.",
      "submitted_on": "Pateikta",
      "seller": "Pardavėjas",
      "devices": "Įrenginiai",
      "status": "Būsena",
      "pending_badge": "{count} laukia",
      "approved_badge": "{count} patvirtinti",
      "rejected_badge": "{count} atmesti",
      "flagged_badge": "{count} pažymėti",
      "duplicates_column": "Dublikatai",
      "details": "Detalės",
      "duplicates_badge": "{count} galimi",
      "duplicates_hint": "Galimi dublikatai — spustelėkite, kad peržiūrėtumėte ir išspręstumėte",
      "actions": "Veiksmai",
      "approve": "Patvirtinti",
      "reject": "Atmesti",
      "rejection_reason_placeholder": "Atmetimo priežastis (matoma pardavėjui)…",
      "no_duplicates": "Šis įrenginys neturi neišspręstų dublikatų kandidatų.",
      "approved_toast": "{name} patvirtintas",
      "override_confirm": "Šis įrenginys turi neišspręstų didelio patikimumo dublikatų. Vis tiek patvirtinti?",
      "approve_anyway": "Vis tiek patvirtinti",
      "filter_pending": "Laukia peržiūros",
      "filter_all": "Visi",
      "no_pending": "Nėra peržiūros laukiančių pateikimų.",
      "show_all": "Rodyti visus pateikimus",
      "merged_badge": "{count} sujungti",
      "internal_notes": "Vidinės pastabos",
      "internal_notes_hint": "Matomos tik EKOenergy komandai — pardavėjai jų nemato.",
      "note_placeholder": "Pridėti pastabą komandai…",
      "add_note": "Pridėti pastabą",
      "save_changes": "Išsaugoti pakeitimus",
      "device_saved": "Įrenginys atnaujintas",
      "invalid_number_fields": "Platuma, ilguma arba galia nėra tinkamas skaičius. Nieko nebuvo išsaugota."
    },
    "duplicates": {
      "title": "Dublikatai",
      "subtitle": "{pending} kandidatų porų laukia peržiūros. Sprendimai galutiniai.",
      "filter_pending": "Laukia",
      "scan": "Ieškoti dublikatų",
      "scan_started": "Dublikatų paieška pradėta — naujos poros netrukus atsiras.",
      "empty": "Šiame rodinyje dublikatų kandidatų nėra. Švarus darbas!",
      "load_more": "Rodyti daugiau ({shown} iš {total})",
      "device_a": "Įrenginys A",
      "device_b": "Įrenginys B",
      "this_submission": "Šis pateikimas",
      "existing_device": "Esamas katalogo įrenginys",
      "newer_entry": "Naujesnis įrašas",
      "older_entry": "Senesnis įrašas",
      "coordinates": "Koordinatės",
      "not_duplicate": "Ne dublikatas",
      "keep_a": "Sujungti, palikti A",
      "keep_b": "Sujungti, palikti B",
      "merge_confirm": "Sujungti šią porą ir palikti “{name}”? Kitas įrašas archyvuojamas, o jo dokumentai perkeliami.",
      "confirm_merge": "Patvirtinti sujungimą",
      "resolved_toast": "Pora išspręsta",
      "ask_ai": "Klausti AI",
      "ai": {
        "duplicate": "AI: dublikatas",
        "not_duplicate": "AI: ne dublikatas",
        "unsure": "AI: neaišku"
      },
      "statuses": {
        "not_duplicate": "Ne dublikatas",
        "merged": "Sujungta"
      },
      "reasons": {
        "registration_id_exact": "Tas pats registracijos ID",
        "registration_id_overlap": "Registracijos ID sutampa",
        "registration_id_suspect_overlap": "ID sutampa (mažas patikimumas)",
        "name_exact": "Tas pats pavadinimas",
        "name_exact_distinct_ids": "Tas pats pavadinimas, skirtingi registro ID",
        "name_fuzzy": "Panašus pavadinimas {detail}",
        "coords_within_250m": "250 m spinduliu"
      }
    },
    "title": "Ekoženklai",
    "description": "Tvarkykite ekoženklu sertifikuotus atsinaujinančios energijos įrenginius",
    "add_device": "Pridėti įrenginį",
    "edit_device": "Redaguoti įrenginį",
    "ai_upload": "AI įkėlimas",
    "devices_selected": "įrenginių pasirinkta",
    "bulk_delete": "Ištrinti pasirinktus",
    "export_csv": "Eksportuoti CSV",
    "no_access_title": "Nėra prieigos prie EKOenergy registro",
    "no_access_contact": "Dėl prieigos kreipkitės adresu {0}.",
    "no_devices": "Ekoženklo įrenginių nerasta. Norėdami pradėti, pridėkite pirmąjį įrenginį.",
    "showing_count": "Rodoma: {filtered} iš {total}",
    "total_count": "Iš viso įrenginių: {total}",
    "devices_heading": "Ekoženklo įrenginiai",
    "device_saved": "Įrenginys sėkmingai išsaugotas",
    "device_deleted": "Įrenginys sėkmingai ištrintas",
    "devices_created": "Įrenginiai sėkmingai sukurti",
    "confirm_delete": "Ar tikrai norite ištrinti {name}?",
    "confirm_bulk_delete": "Ar tikrai norite ištrinti {count} įrenginius?",
    "bulk_deleted": "{count} įrenginių sėkmingai ištrinta",
    "columns_selected": "{count} stulpeliai",
    "select_columns": "Stulpeliai",
    "add_devices": "Pridėti įrenginius",
    "add_devices_description": "Įkelkite dokumentą AI automatiniam užpildymui arba rankiniu būdu pridėkite įrenginius žemiau.",
    "save_devices": "Išsaugoti visus įrenginius",
    "add_row": "Pridėti eilutę",
    "no_rows": "Dar nepridėta jokių įrenginių. Įkelkite dokumentą arba pridėkite eilutes rankiniu būdu.",
    "devices_saved": "{count} įrenginių sėkmingai išsaugota",
    "filters": {
      "standard": "Standartas",
      "status": "Būsena",
      "country": "Šalis",
      "search": "Ieškoti",
      "search_placeholder": "Ieškoti pagal pavadinimą...",
      "capacity_placeholder": "pvz. 50",
      "cod_placeholder": "pvz. 2020"
    },
    "table": {
      "name": "@:common.name",
      "plant_ecolabel_id": "Registracijos ID",
      "standard": "Standartas",
      "status": "Būsena",
      "country": "Šalis",
      "address": "@:common.address",
      "type": "Tipas",
      "renewable_type": "Technologija",
      "latitude": "Platuma",
      "longitude": "Ilguma",
      "capacity": "Galia",
      "cod": "COD",
      "date_reviewed": "Peržiūros data",
      "valid_from": "Patvirtinta nuo",
      "valid_through": "Patvirtinimas galioja iki",
      "registration_authority": "Registras",
      "technology_code": "Tech. kodas",
      "public_notes": "Pastabos",
      "relevant_link": "Nuoroda",
      "link": "Nuoroda",
      "documents": "@:common.documents",
      "actions": "@:common.actions.title"
    },
    "form": {
      "standard": "Ekoženklo standartas",
      "status": "Būsena",
      "name": "Įrenginio pavadinimas",
      "plant_id": "Elektrinės ekoženklo ID",
      "country": "Šalies kodas",
      "address": "@:common.address",
      "latitude": "@:ecolabels.table.latitude",
      "longitude": "@:ecolabels.table.longitude",
      "renewable_type": "Atsinaujinančios energijos tipas",
      "marine": "Jūrinė energija",
      "nuclear": "Branduolinė energija",
      "technology_code": "Technologijos kodas",
      "technology_code_placeholder": "pvz., T010000",
      "registration_authority": "Registravimo institucija",
      "relevant_link": "Susijusi nuoroda",
      "capacity": "Galia",
      "capacity_units": "Vienetai",
      "cod": "Komercinės eksploatacijos pradžios data",
      "public_notes": "Viešos pastabos",
      "rejection_reason": "Atmetimo priežastis",
      "location_hint": "Privalomas adresas arba koordinatės.",
      "errors": {
        "name_required": "Pavadinimas yra privalomas.",
        "country_required": "Šalis yra privaloma.",
        "renewable_type_required": "Atsinaujinančios energijos tipas yra privalomas.",
        "latitude_range": "Platuma turi būti skaičius nuo -90 iki 90.",
        "longitude_range": "Ilguma turi būti skaičius nuo -180 iki 180.",
        "capacity_invalid": "Galia turi būti skaičius.",
        "location_required": "Nurodykite adresą arba koordinates (platumą ir ilgumą).",
        "registration_authority_required": "Registravimo institucija privaloma, kai nurodytas registracijos ID.",
        "rejection_reason_required": "Atmetimo priežastis privaloma, kai būsena yra Atmesta."
      },
      "registry_device_id": "Registro įrenginio ID",
      "date_reviewed": "Peržiūros data",
      "valid_from": "Patvirtinta nuo",
      "valid_through": "Patvirtinimas galioja iki"
    },
    "ai_autofill": "AI automatinis užpildymas iš dokumento",
    "autofill_btn": "Automatiškai užpildyti",
    "autofill_confidence": "Patikimumas: {value}%",
    "upload_wizard": {
      "title": "Įkelti anuliavimo pareiškimą",
      "ekoenergy_logo_alt": "EKOenergy logotipas",
      "no_authorized_seller_title": "Tapkite įgaliotu EKOenergy pardavėju",
      "no_authorized_seller_description": "Norint įkelti anuliavimo pareiškimus, reikia bent vienos įgaliotos pardavėjo įmonės.",
      "no_authorized_seller_cta": "Aplankyti EKOenergy",
      "step1_label": "Įkėlimas",
      "step2_label": "Anuliavimo detalės",
      "step1_title": "Įkelti anuliavimo dokumentą",
      "step1_description": "Įkelkite anuliavimo pareiškimą. Mūsų AI jį išanalizuos ir susies su registruotais ekoženklo įrenginiais.",
      "cancellation_source": "Anuliavimo šaltinis",
      "upload_new_statement": "Įkelti naują anuliavimo pareiškimą",
      "using_existing_cancellation": "Naudojamas esamas anuliavimas. Failo įkėlimas ir pareiškimo detalių laukai paslėpti.",
      "step2_title": "Peržiūrėti ir priskirti įrenginius",
      "step2_description": "Peržiūrėkite AI rastus įrenginius, rankiniu būdu pridėkite arba pašalinkite įrenginius ir pakoreguokite MWh paskirstymą.",
      "drop_file": "Nuvilkite failą čia arba spustelėkite, kad pasirinktumėte",
      "seller_company": "Pardavėjo įmonė",
      "new_company_placeholder": "Naujos įmonės pavadinimas",
      "new_company_email_placeholder": "Savininko el. paštas",
      "company_created": "Įgaliota pardavėjo įmonė sukurta",
      "ai_matching_failed_warning": "Šiam įkėlimui AI susiejimas nepavyko. Pareiškimas buvo išsaugotas, tačiau laukai / įrenginiai nebuvo užpildyti automatiškai.",
      "upload_and_match": "Įkelti ir susieti įrenginius",
      "analyze": "Analizuoti dokumentą",
      "analyzing": "Dokumentas analizuojamas naudojant AI...",
      "ai_applied": "AI analizė pritaikyta. Peržiūrėkite ir pakoreguokite iš anksto užpildytus laukus žemiau.",
      "ai_found_matches": "AI jūsų pareiškime rado {count} atitinkantį(-čius) įrenginį(-ius).",
      "matching_devices": "Ieškoma atitinkančių ekoženklo įrenginių...",
      "no_matches": "Atitinkančių įrenginių automatiškai nerasta. Galite rankiniu būdu priskirti įrenginius žemiau.",
      "assigned_devices": "Priskirti įrenginiai",
      "add_device_manually": "Pridėti įrenginį",
      "no_devices_assigned": "Kol kas nepriskirta jokių įrenginių. Pridėkite įrenginius rankiniu būdu arba įkelkite pareiškimą iš naujo.",
      "select_device": "Pasirinkti įrenginį",
      "search_devices": "Ieškoti pagal pavadinimą arba šalį...",
      "no_devices_found": "Atitinkančių įrenginių nerasta.",
      "save_and_submit": "Išsaugoti ir pateikti",
      "beneficiary_name": "Naudos gavėjo pavadinimas",
      "registry_code": "Registro kodas",
      "country_region": "Šalis / regionas",
      "period_start": "Laikotarpio pradžia",
      "period_end": "Laikotarpio pabaiga",
      "mwh_cancelled": "Anuliuota MWh",
      "purpose": "Anuliavimo paskirtis",
      "notes": "Pastabos",
      "confirm_proceed": "Patvirtinti ir susieti įrenginius",
      "mwh": "@:common.mwh",
      "confidence": "Patikimumas",
      "total_mwh": "Bendra MWh dokumente",
      "selected_mwh": "Pasirinkta MWh",
      "generate_certificates": "Generuoti sertifikatus",
      "success": "Anuliavimo pareiškimas sėkmingai įkeltas ir įrenginiai priskirti"
    },
    "certificates": {
      "heading": "EKOenergy sertifikatai",
      "upload_statement": "Įkelti anuliavimo pareiškimą",
      "no_statements": "Anuliavimo pareiškimų dar nėra. Norėdami pradėti, įkelkite pirmąjį pareiškimą.",
      "file_name": "Pareiškimas",
      "uploaded": "Įkelta",
      "period_col": "@:cancellation.table.period",
      "total_mwh_col": "Iš viso MWh",
      "devices_col": "Įrenginiai",
      "status_col": "Būsena",
      "actions_col": "@:common.actions.title",
      "download_statement": "Atsisiųsti pareiškimą",
      "edit_statement": "Redaguoti pareiškimą",
      "manage_devices": "Tvarkyti susietus įrenginius",
      "approve": "Patvirtinti",
      "reject": "Atmesti",
      "generate": "Generuoti sertifikatą",
      "download_certificate": "Atsisiųsti sertifikatą",
      "approved_success": "Pareiškimas sėkmingai patvirtintas",
      "rejected_success": "Pareiškimas atmestas",
      "confirm_reject": "Ar tikrai norite atmesti šį pareiškimą?",
      "certificate_generated": "Sertifikatas sugeneruotas ir atsisiųstas",
      "statement_uploaded": "Anuliavimo pareiškimas sėkmingai įkeltas"
    },
    "manage_devices": {
      "title": "Redaguoti anuliavimo pareiškimą",
      "statement_details": "Pareiškimo detalės",
      "documents_section": "@:common.documents",
      "statement_document": "Anuliavimo pareiškimas",
      "certificate_document": "Sertifikato PDF",
      "no_certificate_document": "Sertifikato failo nėra",
      "add_document": "@:common.add",
      "statement_document_updated": "Pareiškimo dokumentas atnaujintas",
      "certificate_document_updated": "Sertifikato dokumentas atnaujintas",
      "statement_document_deleted": "Pareiškimo dokumentas pašalintas",
      "certificate_document_deleted": "Sertifikato dokumentas pašalintas",
      "linked_devices": "Susieti įrenginiai",
      "add_device": "Pridėti įrenginį",
      "no_devices": "Prie šio pareiškimo nepriskirta jokių įrenginių.",
      "select_device": "Pasirinkti įrenginį",
      "saved": "Įrenginių priskyrimai sėkmingai atnaujinti"
    },
    "ekoenergy": {
      "title": "EKOenergy ecolabel",
      "description": "Įrenginiai, kuriuos įgalioti pardavėjai gali naudoti EKOenergy"
    }
  },
  "documents_table": {
    "no_documents": "Nėra dokumentų, kuriuos būtų galima rodyti",
    "columns": {
      "id": "@:common.id",
      "name": "@:common.name",
      "type": "Tipas",
      "category": "Kategorija",
      "company": "@:common.company",
      "status": "Būsena",
      "created": "Sukurta",
      "actions": "@:common.actions.title"
    },
    "filters": {
      "search_name": "Ieškoti pagal pavadinimą",
      "search_company": "Ieškoti pagal įmonę"
    },
    "type": {
      "custom_upload": "Įkėlimas",
      "dokobit_document": "Pasirašytas dokumentas"
    },
    "category": {
      "sending_gos_file_upload": "KG siuntimas",
      "buy_contract_analysis": "Pirkimo sutartis",
      "cancel_contract_analysis": "Atšaukimo sutartis",
      "ppa_contract_analysis": "PPA sutartis",
      "bulk_buy_analysis": "Masinis pirkimas",
      "ppa_instructions": "PPA instrukcijos",
      "ppa_creation": "PPA kūrimas",
      "cancellation_statement": "Atšaukimo pareiškimas",
      "issuance_data_import": "Išdavimo duomenys",
      "arbitrary_file_upload": "Failų įkėlimas",
      "portfolio_documentation": "Portfelio dokumentacija",
      "other": "Kita",
      "unknown": "Nežinoma"
    },
    "status": {
      "uploaded": "Įkeltas",
      "completed": "Pasirašytas",
      "awaiting_signature": "Laukiama parašo",
      "canceled": "Atšauktas"
    },
    "actions": {
      "archive": "Archyvuoti",
      "sign": "Pasirašyti",
      "view_details": "Išsamiau"
    },
    "details_modal": {
      "title": "Dokumento informacija",
      "contract_details": "Sutarties informacija",
      "source": "Šaltinis"
    },
    "confirm_archive": "Ar tikrai norite archyvuoti šį dokumentą? Jis bus pašalintas iš sąrašo.",
    "archive_success_title": "Dokumentas archyvuotas",
    "archive_success_message": "Dokumentas sėkmingai archyvuotas.",
    "linked_cancellations": "Susiję atšaukimai",
    "cancellation_id": "Atšaukimas #{id}"
  },
  "ppa_summary": {
    "heading": "Būsimi vykdymai",
    "loading": "Skaičiuojame prognozuojamus kiekius...",
    "no_data": "Prognozių duomenų kol kas nėra.",
    "no_data_short": "—",
    "mwh_value": "{amount} MWh",
    "next_delivery": "Kitas pristatymas",
    "following_delivery": "Tolesnis pristatymas",
    "contract_ends": "Sutartis baigiasi",
    "send": "Planuojame pristatyti {date} (prognozė {amount} MWh).",
    "cancel": "Planuojame atšaukti laikotarpį {start} -> {end} {date} (prognozė {amount} MWh)."
  },
  "ai_chat": {
    "certificate_criteria_conflict": "{context} yra prieštaringų sertifikatų reikalavimų ({criterion}). Įkelkite juos atskirai.",
    "conflict_contexts": {
      "excel_rows": "Excel eilutėse",
      "uploaded_documents": "Įkeltuose dokumentuose",
      "draft_and_document": "Dabartiniame juodraštyje ir įkeltame dokumente"
    },
    "shared_setting_conflict": {
      "intro": "Nieko nebuvo importuota. Atšaukimo užsakyme gali būti tik vienas gavėjo tipas, suvartojimo laikotarpis ir atšaukimo tikslas, tačiau šios deklaracijos skiriasi:",
      "other_statements": "Kitos deklaracijos ({count})",
      "more_statements": "…ir dar {count}",
      "outro": {
        "uploaded_documents": "Pataisykite šias deklaracijas dokumente ir įkelkite jį dar kartą, įkelkite jas atskiruose failuose arba prie įkėlimo pridėkite pastabą su reikšme, taikoma visoms deklaracijoms.",
        "draft": "Juodraštis nebuvo pakeistas. Nurodykite, kuri reikšmė taikoma visoms deklaracijoms, arba užbaikite šį užsakymą ir pradėkite naują pokalbį kitoms deklaracijoms."
      }
    },
    "document_irrelevant": "Panašu, kad šis dokumentas netinka tam, ką čia rengiame, todėl nieko nebuvo importuota. Įkelkite kitą dokumentą arba paklauskite manęs, kodėl jis netiko.",
    "title": "DI asistentas",
    "input_placeholder": "Rašykite žinutę…",
    "send": "Siųsti",
    "attach": "Pridėti dokumentą",
    "drop_files": "Paleiskite failus, kad juos pridėtumėte",
    "drop_files_hint": "PDF, Word, Excel, CSV ar TXT · iki {maxMb} MB",
    "drop_busy": "Pridėkite failus, kai bus gautas atsakymas",
    "new_chat": "Pradėti naują pokalbį",
    "thinking": "Dirbu su tuo…",
    "error_reply": "Atsiprašome, apdorojant įvyko klaida. Bandykite dar kartą.",
    "greetings": {
      "cancel": "Sveiki! Įkelkite anuliavimo dokumentą (PDF, Word, Excel ar CSV) ir parengsiu pareiškimų juodraščius. Jei trūks svarbios informacijos, paklausiu jos čia. Taip pat galite tiesiog aprašyti, ko jums reikia, žinutėje.",
      "buy": "Sveiki! Įkelkite pirkimo dokumentą arba aprašykite, ką norite pirkti (kiekis, technologija, metai…), ir užpildysiu pirkimo nustatymus.",
      "send": "Sveiki! Įkelkite perdavimo dokumentą arba nurodykite, kas turi gauti kilmės garantijas (gavėjas, EECS sąskaita, MWh kiekis), ir parengsiu perdavimą.",
      "bulk_buy": "Sveiki! Įkelkite suvartojimo ataskaitas ar objektų sąrašus ir išgausiu įmones, kiekius bei pirkimo nustatymus. Jei trūks svarbios informacijos, paklausiu jos čia.",
      "ppa": "Sveiki! Įkelkite PPA sutartį arba aprašykite tiekimo grafiką, ir užpildysiu tiekimo nurodymus. Jei trūks svarbios informacijos, paklausiu jos čia.",
      "ecolabels": "Sveiki! Įkelkite savo panaikinimo pažymą (PDF, Word, Excel ar CSV) arba ją aprašykite, ir parengsiu pažymos duomenų juodraštį bei susiesiu įrenginius už jus. Jei trūks svarbios informacijos, paklausiu jos čia.",
      "ecolabel_devices": "Sveiki! Įkelkite savo įrenginių sąrašą (lentelę, registro išrašą, el. laišką ar PDF), ir aš išgausiu kiekvieną įrenginį su jo duomenimis, patikrinsiu trūkstamus laukus ir pažymėsiu galimus dublikatus. Įrenginius ar pataisymus taip pat galite aprašyti žinute."
    }
  },
  "branding": {
    "powered_by": "Teikia",
    "registry_infrastructure": "Registro infrastruktūra",
    "powered_by_soldera": "Veikia „Soldera“ registro infrastruktūroje"
  },
  "cnmc": {
    "workflow_intro": "Pateikite mėnesio gamybą, parenkite CNMC išdavimo failus ir stebėkite PPA pervedimus bei eksportą.",
    "filing_details": "Paraiškos duomenys",
    "prepare_issuance": "Rengti išdavimą",
    "recipient_name": "Gavėjo juridinis pavadinimas",
    "destination_registry": "Paskirties registras",
    "choose_registry": "Pasirinkite registrą",
    "domestic_transfer": "Ispanija · vietinis pervedimas",
    "recipient_r2": "CNMC tiekėjo identifikatorius (R2)",
    "eecs_account": "EECS sąskaita",
    "market_destination": "Rinkos kiekių eksporto paskirtis",
    "change_destination": "Keisti paskirties vietą",
    "confirm_representation": "Turiu teisę teikti paraiškas šio gamintojo vardu ir patvirtinau atstovavimo reikalavimų įvykdymą.",
    "accept_declarations": "Patvirtinu, kad šiuos rodmenis galima naudoti išdavimui, jiems nėra kitų atvirų prašymų ir gamintojas sutinka su CNMC paraiškos deklaracijomis bei duomenų tvarkymo sąlygomis.",
    "fields": {
      "producer_name": "Gamintojo juridinis pavadinimas",
      "street": "Gatvė",
      "street_number": "Namo numeris",
      "staircase": "Laiptinė (neprivaloma)",
      "postal_code": "Pašto kodas",
      "municipality": "Savivaldybė",
      "province": "Provincija",
      "country": "Šalis",
      "phone": "Telefonas",
      "email": "El. paštas",
      "place": "Pasirašymo vieta",
      "representative_name": "Atstovo vardas ir pavardė (jei taikoma)"
    },
    "production": "Gamyba",
    "allocation": "Paskirstymas",
    "review": "Peržiūra",
    "monthly_breakdown": "Kiekvieną įrenginį ir mėnesį įveskite atskirai. Išduodant kilmės garantijas trupmeninės dalys neįtraukiamos; skirtingų mėnesių kiekiai nesumuojami.",
    "device": "Gamybos įrenginys",
    "month": "Gamybos mėnuo",
    "production_mwh": "Gamyba (MWh)",
    "whole_go_total": "{count} sveikųjų kilmės garantijų prieš atskaitant esamus įsipareigojimus",
    "allocation_explanation": "Paskirstymą nustato PPA instrukcijos. Norėdami pakeisti paskirstymą, atnaujinkite PPA instrukcijas ir šį juodraštį.",
    "route": "Pristatymo būdas",
    "market": "Rinka",
    "routes": {
      "DOMESTIC": "Vietinis",
      "EXPORT": "AIB eksportas"
    },
    "issuance_split": "{domestic} vietinių kilmės garantijų · {exported} kilmės garantijų AIB eksportui",
    "saved_draft_explanation": "Juodraštis išsaugotas. Patvirtinkite partiją, kad rezervuotumėte kiekius ir sukurtumėte išdavimo failus.",
    "open_batch": "Atidaryti partiją",
    "batch_number": "CNMC partija Nr. {id}",
    "needs_attention_explanation": "Soldera turi peržiūrėti šią paraišką. Pateiktos paraiškos toliau stebimos; paveikti kiekiai lieka rezervuoti.",
    "edit_draft": "Redaguoti juodraštį",
    "delete_draft": "Ištrinti juodraštį",
    "delete_draft_confirmation": "Ištrinti CNMC partiją Nr. {id}? Juodraštis, jo paskirstymas ir gamybos rodmenys bus visam laikui ištrinti. Šio veiksmo negalima atšaukti.",
    "confirm_and_generate": "Patvirtinti paskirstymą ir sukurti failus",
    "stacking_instructions": "Įkelkite kiekvieną išdavimo ZIP failą į CNMC ir toliau įrašykite jo registracijos numerį. Pervedimo ir eksporto failus galite rengti pateikę išdavimo paraišką, dar laukdami patvirtinimo. Kiekvieną pristatymo ZIP failą įkelkite atskirai ir įrašykite jo registracijos numerį.",
    "prepare_ppa_delivery": "Rengti {name} pristatymą",
    "ppa_delivery_issuance_required": "Pateikite šio PPA išdavimo failą CNMC, tada aukščiau įveskite jo Número de Registro ir užregistruokite pateikimą.",
    "market_export_issuance_required": "Pateikite AIB eksporto išdavimo failą CNMC, tada aukščiau įveskite jo Número de Registro ir užregistruokite pateikimą.",
    "prepare_market_export": "Rengti eksportą rinkai",
    "kinds": {
      "DOMESTIC_ISSUANCE": "Vietinis išdavimas",
      "EXPORT_ISSUANCE": "Išdavimas AIB eksportui",
      "TRANSFER": "Vietinis pervedimas",
      "EXPORT": "Eksportas"
    },
    "statuses": {
      "DRAFT": "Juodraštis",
      "CONFIRMED": "Patvirtinta",
      "PREPARED": "Parengta",
      "SUBMITTED": "Pateikta · nepatikrinta",
      "PENDING": "Laukiama",
      "APPROVED": "Patvirtinta · laukiama įrodymų",
      "COMPLETED": "Užbaigta",
      "COMPLETE": "Baigta",
      "IN_PROGRESS": "Vykdoma",
      "NEEDS_ATTENTION": "Reikia dėmesio",
      "ABANDONED": "Atsisakyta",
      "SUPERSEDED": "Pakeista"
    },
    "source_receipts": "Pradinis išdavimas · Nº Registro Origen",
    "outdated_file": "Šiame faile naudojamas senesnis šablonas. Prieš įkeldami pakeiskite dar nepateiktą failą; pateiktus failus išsaugokite savo įrašams.",
    "lookup_retry": "CNMC patikra laikinai nepasiekiama. Suplanuotas pakartotinis bandymas; paskutinė žinoma būsena išsaugoma.",
    "filing_deadline": "Paraiškos terminas",
    "go_expiry": "Kilmės garantijos galiojimo pabaiga",
    "last_checked": "Paskutinį kartą tikrinta",
    "not_checked": "Dar netikrinta",
    "company_order": "Įmonės užsakymas",
    "download_zip": "Atsisiųsti ZIP",
    "check_status": "Tikrinti būseną",
    "record_submission": "Užregistruoti pateikimą",
    "correction_reason": "Pataisymo arba atšaukimo priežastis",
    "abandon_batch": "Atsisakyti partijos",
    "abandonment_reason": "Šios partijos atsisakymo priežastis",
    "abandon_explanation": "Gamybą galima atlaisvinti tik nepateikto arba patikrinto atmesto/atšaukto išdavimo atveju. Nepavykęs pristatymas neatlaisvina išduotų kiekių.",
    "connection": "CNMC jungtis",
    "preparation_disabled": "Šiai jungčiai naujų paraiškų rengimas neįjungtas. Esamų paraiškų istorija lieka pasiekiama.",
    "profile_required": "Prieš rengdami išdavimą patvirtinkite paraiškos duomenis.",
    "template_updated": "CNMC atnaujino šią formą. Prieš kuriant naują failą turime atnaujinti palaikymą. Įvesti duomenys išsaugoti.",
    "checking_templates": "Tikrinamos CNMC formos. Failus bus galima kurti po patikros.",
    "no_batches": "Išdavimo partijų dar nėra.",
    "batch": "Partija",
    "progress": "Eiga",
    "filing_order": "Šis užsakymas valdomas CNMC paraiškų formomis. Atidarykite išdavimo partiją, kad atsisiųstumėte failus, įrašytumėte registracijos numerius ir patikrintumėte eigą.",
    "pending_ppa": "Rezervuota CNMC PPA pristatymui",
    "cnmc_transferred": "Patvirtintas PPA pristatymas",
    "ppa_progress": "{reserved_go_count} KG rezervuota · {ready_go_count} parengta pateikti · {transferred_go_count} pervesta",
    "linked_filings": "CNMC paraiškos",
    "order_instructions": "Įkelkite failus į CNMC ir susietoje partijoje įrašykite kiekvieną registracijos numerį. Registro patikros patvirtina užbaigimą.",
    "awaiting_delivery_form": "Išdavimas rezervuotas. Įrašę išdavimo registracijos numerį, išdavimo ataskaitoje parenkite pervedimo arba eksporto failą.",
    "inventory_accepted": "Garantijos gautos ir paskirstytos",
    "arrival_review": "Ispanijos eksporto gavimai",
    "arrival_review_help": "Patikrinkite tikslią gavėjo sąskaitą, visus įrenginių kiekius ir gamybos mėnesius. Padalytiems gavimams ir įrenginių pavadinimų atitikmenims būtinas pagrindimas. Priėmimas vienu metu priskiria nuosavybę ir portfelius.",
    "export_verified": "Eksportas patikrintas",
    "awaiting_verification": "Laukiama CNMC patikros",
    "receiving_account": "Gavėjo sąskaita",
    "imported_at": "Importuota",
    "production_months": "Gamybos mėnesiai",
    "reviewed_name": "Peržiūrėtas įrenginio pavadinimas",
    "use_registry_name": "Naudoti registro pavadinimą",
    "accept_inventory": "Priimti garantijas",
    "replace_file": "Pakeisti failą",
    "replace_file_help": "Sukurkite susietą pakaitalą naudodami dabartinį palaikomą šabloną. Pirmiausia turi būti patikrinta, kad pateiktos paraiškos atmestos arba atšauktos. Istoriniai failai lieka pasiekiami.",
    "awaiting_issuance_receipt": "Laukiama išdavimo paraiškos numerio",
    "next_action": "Kitas žingsnis",
    "actions": {
      "REVIEW": "Peržiūrėti ir patvirtinti paskirstymą",
      "SUBMIT_ISSUANCE": "Įkelti išdavimo failus ir įvesti kiekvieną Número de Registro | Įkelti išdavimo failą ir įvesti jo Número de Registro | Įkelti išdavimo failus ir įvesti kiekvieną Número de Registro",
      "SUBMIT_DELIVERY": "Įkelti pristatymo failus ir įvesti kiekvieną Número de Registro",
      "PREPARE_DELIVERY": "Rengti pristatymo failus",
      "WAIT_CNMC": "Laukiama CNMC patvirtinimo",
      "WAIT_INVENTORY": "Laukiama garantijų gavimo gavėjo sąskaitoje",
      "CONTACT_SOLDERA": "Būtina Soldera peržiūra",
      "COMPLETE": "Užbaigta",
      "ABANDONED": "Atsisakyta"
    },
    "staff_review": "Soldera peržiūra",
    "staff_review_help": "Išsprendę atvejį įrašykite pakeitimus ir patikrinkite naujus CNMC įrodymus. Esami failai, rezervacijos ir pristatymo įrašai lieka audito istorijoje.",
    "resume_verification": "Tęsti patikrą",
    "load_more": "Įkelti daugiau",
    "replacement_draft": "Sukurti pakaitinį juodraštį",
    "replacement_draft_help": "Pakaitinis juodraštis išlaiko pradinius gamybos įsipareigojimus. Prieš patvirtindami persidengiančią gamybą išspręskite ir atlaisvinkite senas paraiškas.",
    "template_check_failed": "CNMC formos patikra nepavyko. Suplanuotas pakartotinis bandymas; jūsų duomenys išsaugoti.",
    "next_check": "Kita patikra",
    "registry_evidence": "CNMC įrodymai",
    "net_production": "Faktinė grynoji gamyba",
    "domestic_volume": "Vidaus",
    "export_volume": "AIB eksportas",
    "unallocated_fraction": "Nepaskirstyta dalis",
    "application_number": "Paraiška Nr. {id}",
    "requested": "Prašoma",
    "approved": "Patvirtinta",
    "delivered": "Pristatyta",
    "zip_package": "Originali darbaknygė ZIP faile",
    "issuance_receipt": "Número de Registro · Expedición",
    "receipt_format": "20 skaitmenų be tarpų: pateikimo metai + 03 + 14 skaitmenų. Naudokite pateikimo, o ne gamybos metus.",
    "receipt_example": "pvz., 20260300000045887410",
    "transfer_receipt": "Número de Registro · Transferencia",
    "export_receipt": "Número de Registro · Exportación",
    "issuance_receipt_help": "Pateikę šį išdavimo ZIP failą, nukopijuokite CNMC suteiktą Número de Registro. Jį rasite skiltyje Consultas por Solicitante arba proceso informacijos viršuje, lauke Nº registro.",
    "delivery_receipt_help": "Pateikę šį pervedimo ar eksporto ZIP failą, nukopijuokite naują Nº registro iš CNMC proceso informacijos viršaus. Nenaudokite Nº Registro Origen (pradinio išdavimo) ar eksporto Message ID.",
    "correct_receipt": "Taisyti registracijos numerį",
    "delivery_due": "Pristatymo parengtis",
    "issuance_stage": "1 etapas · Išdavimo formos",
    "delivery_stage": "2 etapas · Pervedimo ir eksporto formos",
    "download_notice": "Paketo atsisiuntimas nėra jo pateikimas. Užregistruokite kiekvieną CNMC paraiškos numerį partijoje, kad būtų galima rengti susijusias formas ir stebėti eigą.",
    "enter_manually": "Įvesti rankiniu būdu",
    "upload_with_ai": "Įkelti naudojant DI",
    "upload_readings_help": "DI nuskaito įrenginių CIL kodus, gamybos mėnesius ir MWh iš „Excel“ arba CSV failų (iki 25 MB). Peržiūrėkite ir pataisykite toliau pateiktas eilutes. Dideliuose „Excel“ failuose gali reikėti pašalinti nenaudojamus lapus ir formatavimą arba padalyti juos į mažesnius failus.",
    "readings_uploaded": "Failo {filename} rodmenys pateikti toliau. Prieš tęsdami juos peržiūrėkite.",
    "upload_readings_conflict": "Šio failo įrenginio ir mėnesio rodmuo skiriasi nuo jau esančio lentelėje. Prieš įkeldami dar kartą pašalinkite tą eilutę.",
    "invalid_readings_file": "Pasirinkite iki 25 MB dydžio „Excel“ (.xlsx, .xls) arba CSV failą.",
    "add_production_help": "Įveskite mėnesio rodmenį rankiniu būdu arba įkelkite failą naudodami DI.",
    "ppa_reserves": "Išdavimo rezervacijos",
    "no_ppa_reserves": "PPA rezervacijų nėra. Turimos sveikosios KG skiriamos eksportui parduoti rinkoje.",
    "filing_snapshot_help": "Bendrieji numatytieji CNMC paraiškų duomenys. Kiekvienoje partijoje išsaugomi jos rengimo metu naudoti pateikimo duomenys.",
    "producer": "Gamintojas",
    "contact_address": "Kontaktai ir adresas",
    "representation": "Atstovavimas",
    "declarations": "Patvirtinimai",
    "connection_identity": "Iš pasirinkto CNMC ryšio",
    "saved_for_connection": "Išsaugoma būsimoms šio ryšio partijoms",
    "eecs_recipient": "EECS registro sąskaita",
    "domestic_recipient": "Ispanijos tiekėjas · CNMC",
    "recipient_type": "Gavėjo tipas",
    "domestic_delivery_help": "Vidaus pristatymas per CNMC. Soldera rezervuoja šią dalį išdavimo metu ir parengia pervedimo formą. Failus CNMC pateikiate jūs.",
    "export_delivery_help": "Eksportas per CNMC į gavėjo EECS registro sąskaitą. Soldera rezervuoja šią dalį išdavimo metu ir parengia eksporto formą. Failus CNMC pateikiate jūs.",
    "ppa_execution_desc": "Paskirstymas ir pristatymas per CNMC.",
    "ppa_execution_help": "PPA dalis ir gavėjas nustatomi patvirtinus išdavimą. Įrašykite išdavimo registracijos numerį, kad išdavimo ataskaitoje galėtumėte parengti pervedimo arba eksporto failą. Įkelkite kiekvieną failą į CNMC ir įrašykite jo registracijos numerį. Soldera stebi patvirtinimą ir pristatymą.",
    "ppa_execution_summary": "Per CNMC išdavimą",
    "r2_help": "Gavėjo registracija CNMC kaip reikalavimus atitinkančio tiekėjo.",
    "ready_for_filing": "Parengta pateikti",
    "template_verification_pending": "CNMC formos laukia patikros. Failų generavimas bus prieinamas patikrinus naujausias formas.",
    "validation": {
      "r2": "Įveskite CNMC tiekėjo registracijos numerį, prasidedantį R2-.",
      "eecs_region": "EECS sąskaita turi priklausyti pasirinktam registrui.",
      "month": "Įveskite galiojantį gamybos mėnesį.",
      "production_precision": "Įveskite MWh su ne daugiau kaip 3 skaitmenimis po kablelio."
    },
    "connection_required": "Norėdami rengti CNMC paraiškas, prijunkite Ispanijos gamintojo paskyrą. Dėl pagalbos kreipkitės į support@soldera.org."
  },
  "forwards": {
    "common": {
      "mwh": "MWh",
      "mwh_value": "{value} MWh",
      "committed": "Įsipareigota",
      "escrowed": "Deponuota",
      "available": "Laisva",
      "planned": "Suplanuota",
      "delivered": "Pristatyta",
      "shortfall": "Nepadengta",
      "fill_of_total": "{filled} iš {total} MWh",
      "no_window_end": "pristatymo termino nėra",
      "not_priced": "Kaina dar nenustatyta",
      "price_per_mwh": "{price} €/MWh",
      "price_range_per_mwh": "{min} – {max} €/MWh",
      "retry": "Bandyti dar kartą",
      "unknown": "Nežinoma",
      "yes": "Taip",
      "no": "Ne",
      "none": "Nėra",
      "actions": "Veiksmai",
      "status": {
        "draft": "Juodraštis",
        "confirmed": "Patvirtinta",
        "completed": "Baigta",
        "cancelled": "Atšaukta",
        "archived": "Archyvuota",
        "escrow_remaining": "Likęs depozitas",
        "pay_as_produced": "Pagal pagamintą kiekį"
      },
      "super_admin_only_create": "Sandorius gali kurti tik superadministratorius.",
      "support": {
        "mixed": "Mišrus: su parama arba nežinoma",
        "unsupported": "Be paramos"
      },
      "period_width": {
        "month": "Mėnesiai",
        "quarter": "Ketvirčiai",
        "half_year": "Pusmečiai",
        "year": "Metai"
      },
      "device_count": "{count} įrenginių | {count} įrenginys | {count} įrenginiai",
      "deal_badges": {
        "under_committed": "{mwh} MWh nepadengta",
        "volume_over": "{mwh} MWh virš sandorio apimties",
        "volume_under": "{mwh} MWh žemiau sandorio apimties"
      },
      "deal_text": {
        "description_help": "Spausdinamas gamintojų sąskaitose faktūrose ir rodomas gamintojams jų pardavimų sąraše.",
        "internal_notes": "Vidinės pastabos",
        "internal_notes_help": "Tik darbuotojams: niekada nerodomos gamintojams ar pirkėjams ir niekada nespausdinamos."
      }
    },
    "overview": {
      "title": "Išankstiniai pardavimai",
      "description": "Dėmesio reikalaujantys punktai, pagal gamybos metus parduotas išankstinis kiekis, artėjantys pristatymai ir jūsų valdomi sandoriai.",
      "year_totals": {
        "title": "Išankstiniai pardavimai pagal gamybos metus",
        "description": "Kiekvienų gamybos metų parduotas išankstinis kiekis ir vidutinė jo pirkėjo kaina.",
        "loading": "Įkeliamos metinės sumos",
        "empty": "Išankstinių pardavimų dar nėra.",
        "load_failed": "Nepavyko įkelti metinių išankstinių pardavimų sumų.",
        "volume": "{mwh} MWh",
        "average": "vid. {price} €/MWh",
        "no_average": "dar nėra kiekio su kaina",
        "unpriced": "{mwh} MWh be kainos",
        "contents": {
          "intro": "Kiekis apima patvirtintus ir užbaigtus sandorius bei tai, ką atšaukti sandoriai jau buvo išsiuntę, bet ne juodraščius. Pagal sandorio tipą:",
          "fixed_volume": "Fiksuoto kiekio sandoriai: jų pristatymų planas, kiekvienas laikotarpis priskiriamas metams, kuriais jis prasideda, nesvarbu, ar jis išsiųstas.",
          "pay_as_produced": "Sutartys pagal pagamintą kiekį: kiekvieno mėnesio išsiųstas kiekis arba, kol neišsiųsta, jo nominuotas kiekis."
        }
      },
      "attention": {
        "title": "Reikia dėmesio",
        "description": "Šios paskyros telkinių ir sandorių punktai. Jie dingsta patys, kai problema išsprendžiama.",
        "loading": "Kraunami dėmesio reikalaujantys punktai",
        "empty": "Niekas nereikalauja jūsų dėmesio.",
        "load_failed": "Nepavyko įkelti dėmesio reikalaujančių punktų.",
        "status": {
          "stale_draft": "Užsistovėjęs juodraštis",
          "open_slices": "Nepadengta",
          "escrow_shortfall": "Trūkumas",
          "swap_terms_missing": "Trūksta sąlygų",
          "delivery_unpriced": "Trūksta kainos",
          "free_escrow": "Grąžintinas depozitas",
          "infeasible": "Perparduota",
          "pool_escrow_missing": "Trūksta",
          "other": "Kita",
          "coarse_issuance": "Išdavimas",
          "allocation_not_ready": "Nepaskirstoma",
          "contango_discouraged": "Contango 20 %"
        },
        "reason": {
          "stale_draft": "Sandorio juodraštis, nepatvirtintas {days} d. Jo įsipareigojimai vis dar rezervuoja atsargas, bet dar nieko nepaskirstoma.",
          "open_slices": "{mwh} MWh šio sandorio nepadengta jokio telkinio.",
          "escrow_shortfall": "{mwh} MWh iš įsipareigoto kiekio dar nėra depozite.",
          "swap_terms_missing": "Apsikeitimo sandorio pristatymas iki {date}: {missing}.",
          "delivery_unpriced": "Visiems pristatymams nustatyta pirkėjo kaina. | {count} pristatymui ({mwh} MWh) nenustatyta pirkėjo kaina, todėl metinės išankstinių pardavimų sumos jo neįtraukia. | Pristatymų be pirkėjo kainos: {count} ({mwh} MWh), todėl metinės išankstinių pardavimų sumos jų neįtraukia.",
          "free_escrow": "{mwh} MWh yra depozite, bet nė vienam pristatymui jų nebereikia. Grąžinkite juos savininkėms įmonėms.",
          "infeasible": "Numatoma gamyba laikotarpiu {period} {mwh} MWh atsilieka nuo telkinio įsipareigojimų.",
          "pool_escrow_missing": "Laikotarpiui {period} įsipareigotų {mwh} MWh trūksta deponavimo sąskaitoje; registras turėjo juos jau išduoti.",
          "coarse_issuance": "Sertifikatai išduodami {issued}, bet telkinys siūlo {listed}: šie įrenginiai negali pristatyti jo siūlomų kiekių. Siūlykite {widest} ar ilgiau.",
          "allocation_not_ready": "Naktinis paskirstymas praleidžia {companies} (neparengti paskirstymui), todėl jų gamyba niekada nepatenka į depozitą šio telkinio sandoriams.",
          "contango_discouraged": "Šis telkinys parduoda tik ne mažiau kaip 20 % virš spot kainos, o taip būna retai, todėl jo kiekis parduodamas retai. Apsvarstykite galimybę rinktis „Parduoti tik esant contango“."
        },
        "swap_terms": {
          "producer_price": "gamintojo eilutė neturi gamintojo kainos, todėl sąskaita išrašoma pardavimo kaina",
          "trade_owner": "sandorio tarpininkas nenurodytas, todėl komisinis mokestis nuo maržos nemokamas"
        },
        "issued_in_region": "{width} ({region})",
        "width_adverb": {
          "month": "kas mėnesį",
          "quarter": "kas ketvirtį",
          "half_year": "kas pusmetį",
          "year": "kas metus"
        }
      },
      "deliveries": {
        "title": "Artėjantys pristatymai",
        "description": "Jūsų valdomų sandorių suplanuoti pristatymai, pradedant artimiausiu terminu. Trūkstamas kiekis yra tai, ko pristatymo depozitui dar trūksta, sugrupuota pagal jį padengusių telkinių įrenginių šalis. Mėnuo pagal pagamintą kiekį rodomas lyginant su nominuotu siekiamu kiekiu, kuris yra stebimas, bet nėra įsipareigojimas.",
        "loading": "Kraunami pristatymai",
        "empty": "Šiuos filtrus atitinkančių pristatymų nėra.",
        "load_failed": "Nepavyko įkelti artėjančių pristatymų.",
        "download_xlsx": "Atsisiųsti xlsx",
        "transaction": "Sandoris",
        "window": "Pristatymo langas",
        "deal": "Sandoris",
        "escrowed_of_planned": "Deponuota / suplanuota · trūksta pagal šalis",
        "open_transaction": "Atidaryti pardavimo operaciją",
        "open_deal": "Atidaryti sandorį",
        "escrowed_of_target": "{escrowed} iš siekiamų {target} MWh",
        "on_or_before": "iki {date}",
        "short": "trūksta",
        "due_today": "terminas šiandien",
        "due_tomorrow": "terminas rytoj",
        "due_in_days": "po {days} d.",
        "overdue_one_day": "vėluoja 1 dieną",
        "overdue_days": "vėluoja {days} d.",
        "transaction_status": {
          "draft": "Juodraštis",
          "pending_buyer_details": "Laukiama pirkėjo duomenų",
          "pending_contracts": "Laukiama sutarčių",
          "ready_to_transfer": "Paruošta perduoti",
          "delivered": "Pristatyta",
          "completed": "Baigta"
        },
        "delivered_awaiting_completion": "pristatyta, laukiama apmokėjimo",
        "filters": {
          "status": "Sandorio būsena",
          "window_end": "Pristatymo lango pabaiga",
          "window_end_any": "Bet kuri data",
          "deal_name": "Sandorio pavadinimas"
        }
      },
      "deals": {
        "title": "Jūsų valdomi sandoriai",
        "description": "Visa informacija (pristatymo planas, įsipareigojimai, depozito priskyrimas) yra sandorio puslapyje.",
        "loading": "Kraunami sandoriai",
        "empty": "Šiuos filtrus atitinkančių sandorių nėra.",
        "load_failed": "Nepavyko įkelti sandorių.",
        "new_deal": "Naujas išankstinio sandorio juodraštis",
        "new_pap_deal": "Naujas sandoris pagal pagamintą kiekį",
        "no_buyer": "Nenurodytas",
        "no_price": "Nenurodyta",
        "price_range": "{min} - {max}",
        "deliveries_of": "{done} iš {total}",
        "stale": "{days} d. senumo",
        "infeasible": "Neįvykdoma",
        "filters": {
          "status": "Būsena",
          "status_all": "Visos būsenos",
          "name": "Sandorio pavadinimas",
          "name_placeholder": "Bet koks pavadinimas",
          "pool": "Turi telkinį",
          "pool_placeholder": "Telkinio pavadinimas",
          "company": "Turi įmonę",
          "company_placeholder": "Įmonės pavadinimas"
        },
        "columns": {
          "deal": "Sandoris",
          "buyer": "Pirkėjas",
          "quarters": "Gamyba",
          "volume": "Sandorio kiekis (MWh)",
          "price": "Kaina (€/MWh)",
          "deliveries": "Pristatymų atlikta",
          "status": "Būsena"
        }
      }
    },
    "pools": {
      "intro": {
        "title": "Parduokite būsimą gamybą iš anksto",
        "body": "Išankstiniais pardavimais parduodate kilmės garantijas už gamybą, kuriai garantijos dar neišduotos, šiandien sutarta kaina. „Soldera“ išankstinių pardavimų paslauga padeda užsitikrinti numatomas pajamas ir sumažinti kainų svyravimo riziką, nereikalaujant kasdien valdyti išankstinių pardavimų. Norėdami pradėti, sukurkite telkinį: pasirinkite, kurios jūsų įmonės jame dalyvauja ir kiek jos siūlo kiekvienu laikotarpiu. „Soldera“ parduoda šį kiekį savo tinklo pirkėjams, o garantijos pristatomos, kai registras jas išduoda.",
        "cta": "Sukurti pirmąjį telkinį"
      },
      "guide": {
        "title": "Apie išankstinius pardavimus",
        "pool_definition": "Telkinys – tai jūsų įmonių grupė, kurios gamyba kartu siūloma išankstiniam pardavimui.",
        "pool_balancing": "Jei viena įmonė pagamina mažiau, nei tikėtasi, kitos telkinio įmonės gali padengti trūkumą savo papildoma gamyba.",
        "setup_title": "Telkinių kūrimas",
        "setup_intro": "Sugrupuokite įrenginius, kuriuos priimtų tie patys pirkėjai, kad joks atskiras įrenginys neužkirstų telkiniui kelio į sandorį:",
        "setup_unsupported": "Neremiami hidro, saulės ir vėjo įrenginiai iš vienos šalies – viename telkinyje. Daugelis pirkėjų juos priima.",
        "setup_biomass": "Biomasė ir biodujos – atskirame telkinyje, nes daugelis pirkėjų jas atmeta.",
        "setup_issuance": "Įrenginiai registruose, kuriuose kilmės garantijos išduodamos ne kas mėnesį, – atskirame telkinyje, kurio laikotarpio ilgis atitinka, kaip dažnai registras jas išduoda.",
        "setup_devices": "Įmonė gali priklausyti keliems telkiniams. Norėdami padalyti jos įrenginius tarp jų, naudokite įrenginių pasirinkimą telkinio redagavimo lange."
      },
      "loading": "Kraunami telkiniai",
      "empty": "Šiuos filtrus atitinkančių telkinių nėra.",
      "load_failed": "Nepavyko įkelti telkinių laiko juostos.",
      "attention": {
        "description": "Ką pakeisti jūsų telkiniuose. Įrašai išnyksta, kai tik jie išsprendžiami."
      },
      "restricted_access": "Jūsų įmonė priklauso šiam telkiniui. Norint peržiūrėti išsamią informaciją, reikia prieigos prie visų įmonių narių.",
      "status_filter": "Būsena",
      "status_filter_all": "Visos būsenos",
      "company_filter": "Įmonės",
      "company_filter_all": "Visos įmonės",
      "name_filter": "Telkinio pavadinimas",
      "name_filter_placeholder": "Ieškoti pagal pavadinimą",
      "name_filter_no_matches": "Nė vienas telkinys neatitinka šio pavadinimo.",
      "status": {
        "active": "Aktyvus",
        "archived_open": "Archyvuotas, įsipareigojimai neįvykdyti",
        "archived_settled": "Archyvuotas ir įvykdytas"
      },
      "year_previous": "Ankstesni metai",
      "year_next": "Kiti metai",
      "band_title": "Visi telkiniai",
      "band_column": "{quarter}: pasiūlyta {listed} MWh, įsipareigota {committed} MWh, deponuota {escrowed} MWh, laisva {available} MWh",
      "band_available": "{quarter}: laisva {value} MWh iš pasiūlytų {listed} MWh",
      "band_committed": "{quarter}: įsipareigota, dar nedeponuota {value} MWh (iš viso įsipareigota {committed} MWh)",
      "band_escrowed": "{quarter}: deponuota {value} MWh",
      "infeasible_periods": "Šis telkinys pardavė daugiau, nei jo įrenginiai turėtų pagaminti laikotarpiu {periods}.",
      "row_subtitle": "{companies} · {devices} · {shape}",
      "row_companies": "{count} įmonių | {count} įmonė | {count} įmonės",
      "pap_window": "Sutarties laikotarpis · deponuota {escrowed} MWh · pristatyta {delivered} MWh",
      "cell_figure": "{committed} iš {listed}",
      "cell_escrowed_figure": "{value} deponuota",
      "cell_available": "{pool}, {quarter}: dar laisva {value} MWh",
      "available_help": "Kiekvienam laikotarpiui – didžiausias kiekis, kurį vienas naujas sandoris dar galėtų paimti. Platesnių laikotarpių įsipareigojimai dalijami keliems laikotarpiams, todėl šių skaičių sudėti negalima.",
      "cell_committed": "{pool}, {quarter}: įsipareigota {value} MWh, iš jų deponuota {escrowed} MWh",
      "cell_stranded": "{pool}, {quarter}: deponuota {value} MWh be galiojančio įsipareigojimo",
      "cell_empty": "{pool}, {quarter}: nieko nepasiūlyta",
      "cell_deal_tooltip": "{deal} · {value} MWh, deponuota {escrowed} MWh · {status} · pristatymas iki {window}",
      "entry_width": {
        "quarter": "Ketvirtinis",
        "month": "Mėnesinis",
        "half_year": "Pusmetinis",
        "half_year_recommended": "Pusmetinis (rekomenduojamas)",
        "year": "Metinis"
      },
      "listing_kind": {
        "one_off": "Vienkartinis",
        "recurring": "Pasikartojantis",
        "pay_as_produced": "Pagal pagamintą kiekį"
      },
      "options": {
        "title": "Nustatymai",
        "minimum_price": "Minimali kaina",
        "minimum_price_placeholder": "Ribos nėra",
        "minimum_price_hint": "Sandoris negali įkainoti šio telkinio kiekio pigiau.",
        "minimum_price_negative": "Minimali kaina negali būti neigiama.",
        "minimum_price_too_precise": "Minimali kaina gali turėti ne daugiau kaip {decimals} skaitmenis po kablelio.",
        "contango": {
          "label": "Contango",
          "help": "Contango reiškia, kad išankstinė kaina yra didesnė už spot kainą pardavimo dieną.",
          "none": "Parduoti nepriklausomai nuo spot kainos",
          "any": "Parduoti tik esant contango",
          "at_least_20_percent": "Parduoti tik esant contango, ne mažiau kaip 20 % virš spot kainos (nerekomenduojama)",
          "discouraged": "20 % premija virš spot kainos pasitaiko retai, todėl šio telkinio kiekis parduodamas retai. Apsvarstykite galimybę rinktis „Parduoti tik esant contango“."
        },
        "archive_on_delivery": "Archyvuoti telkinį, kai paskutinis įsipareigojimas bus pristatytas",
        "archive_on_delivery_hint": "Tinka telkiniui, sukurtam vienai sutarčiai."
      },
      "advanced_listing": {
        "label": "Rodyti išplėstines pasiūlymo parinktis",
        "hint": "Visi, kurie redaguoja šį telkinį, mato visus pasiūlymo būdus: vienkartinį, kitus laikotarpio ilgius ir pagal pagamintą kiekį. Be to redaktorius siūlo tik pasikartojančio pasiūlymo ketvirčius.",
        "locked": "Lieka įjungta, kol pasiūlymas nėra pasikartojantis ir ketvirtinis arba kol telkinys parduoda į priekį."
      },
      "volumes": {
        "title": "Pasiūlytas kiekis",
        "intro": "Įveskite, kokį kiekį šis telkinys siūlo išankstiniam pardavimui kiekvienu laikotarpiu. Kiekis taikomas visam telkiniui, o ne kiekvienai įmonei atskirai. Pasiūlytas kiekis nėra privalomas ir jį galite bet kada pakeisti. Jis tampa privalomas, kai įsipareigojama jį skirti sandoriui, o įsipareigotą kiekį reikia pristatyti, net jei vėliau pasiūlytą kiekį sumažinsite. Galite įvesti MWh arba % nuo prognozuojamos gamybos. % išsaugomas kaip MWh.",
        "previewing": "Atnaujinama",
        "mode": "Kaip nurodomi kiekiai",
        "entry_width": "Laikotarpio ilgis",
        "entry_width_hint": "Kiekvieno siūlomo laikotarpio ilgis. Jūsų kiekis gali būti parduotas kartu su kitais jūsų laikotarpiais kaip ilgesnis laikotarpis, bet niekada nepadalytas į trumpesnius.",
        "month_note": "Galima naudoti tik registruose, kuriuose kilmės garantijos išduodamos kas mėnesį.",
        "month_warning": "Tai išplėstinė funkcija. Mėnesio pasiūlymai nepalaiko balansavimo: vieno mėnesio gamybos perteklius negali padengti kito mėnesio gamybos trūkumo.",
        "half_year_note": "Pusmetinis telkinys pristatymuose gali padengti tik pusmečio ir visų metų gamybos laikotarpius.",
        "year_note": "Metinis telkinys pristatymuose gali padengti tik visų metų gamybos laikotarpius.",
        "pay_as_produced_note": "Telkinys pagal pagamintą kiekį parduoda visą savo įrenginių produkciją, todėl kiekių nesiūlo, o jo įrenginiai negali priklausyti jokiam kitam telkiniui.",
        "period": "Laikotarpis",
        "share_of_estimate": "% nuo prognozės",
        "feedback": "Įsipareigota · laisva · prognozė",
        "mwh_for": "Laikotarpiui {period} pasiūlyta MWh",
        "share_for": "Dalis nuo prognozės laikotarpiui {period}",
        "remove_period": "Pašalinti {period}",
        "no_rows": "Kol kas nepasiūlytas nė vienas laikotarpis.",
        "add_period": "Pridėti laikotarpį",
        "whole_year": "Visi metai",
        "no_estimate": "Prognozės nėra",
        "feedback_line": "įsipareigota {committed} · laisva {free} · prognozė {estimated}",
        "free_hint": "Laisva – tai, ką dar galima parduoti šiandien: nieko, kai laikotarpio gamyba baigėsi, nieko, ko pardavimo strategija dar neišleido, ir ne daugiau, nei liko jį apimančiam ketvirčiui, pusmečiui ir metams.",
        "over_committed": "Įsipareigota daugiau nei pasiūlyta",
        "over_committed_note": "Šiais laikotarpiais įsipareigota daugiau nei pasiūlyta. Įsipareigojimai vykdomi bet kuriuo atveju; iš šių laikotarpių nieko naujo parduoti negalima.",
        "over_committed_period": "{period}: įsipareigota {committed} MWh, pasiūlyta {listed} MWh",
        "over_estimate": "{percent}% prognozės",
        "errors": {
          "period_duplicate": "Šis laikotarpis jau nurodytas kitoje eilutėje."
        },
        "how_it_works": "Kaip veikia pasiūla"
      },
      "production_range": {
        "limited": "Apriboti pasiūlymą nustatytu gamybos laikotarpiu",
        "first_month": "Pirmasis gamybos mėnuo",
        "last_month": "Paskutinis gamybos mėnuo",
        "hint": "Nauji sandoriai gali apimti tik šių mėnesių gamybą. Pasikartojantis pasiūlymas už jų ribų nieko nesiūlo; sutartis pagal pagamintą kiekį turi tilpti jų ribose. Palikite mėnesį tuščią, jei toje pusėje ribos nėra.",
        "no_limit": "Be apribojimo",
        "last_before_first": "Paskutinis mėnuo negali būti ankstesnis nei pirmasis."
      },
      "members": {
        "title": "Įmonės",
        "description": "Kieno produkciją parduoda šis telkinys.",
        "search": "Ieškoti įmonių",
        "not_enabled": "Išankstiniai pardavimai neįjungti. Kreipkitės į klientų aptarnavimą.",
        "not_allocation_ready": "Naktinis paskirstymas nesukonfigūruotas, todėl nieko nebus deponuota.",
        "no_candidates": "Tinkamų įmonių nėra.",
        "at_least_one": "Telkinyje turi būti bent viena įmonė."
      },
      "devices": {
        "title": "Įrenginiai",
        "description": "Visi aukščiau nurodytų įmonių registruoti įrenginiai. Prognozėse PPA dalis jau atimta.",
        "use_allowlist": "Parduoti tik iš pasirinktų įrenginių",
        "empty": "Įrenginių nėra.",
        "loading": "Įkeliami įmonių įrenginiai…",
        "include": "Įtraukti {device}",
        "device": "Įrenginys",
        "company": "Įmonė",
        "obligations": "Įsipareigojimai",
        "pool_count": "{n} telkinių | {n} telkinys | {n} telkiniai",
        "ppa_count": "{n} PPA sutarčių | {n} PPA sutartis | {n} PPA sutartys",
        "obligations_note": "Viskas, kas jau pretenduoja į šį įrenginį: telkiniai, kuriems jis priklauso (persidengimas leidžiamas, konkuruoja pasiūlyti kiekiai), ir PPA sutartys, kurios jį apima. PPA aptarnaujama pirmiau nei išankstiniai sandoriai, todėl jos kiekis niekada nepasiekia įsipareigojimo. Pagal pagamintą kiekį veikiančio telkinio įrenginys priklauso tik jam ir čia nepridedamas.",
        "country": "Šalis",
        "technology": "Technologija",
        "cod": "Eksploatacijos pradžia",
        "support": "Parama",
        "ecolabel": "Atitinka ekoženklą",
        "estimate": "Prognozė (MWh)",
        "estimate_note": "Prognozė apima telkinio pasiūlytus laikotarpius ir jau neįskaito kiekvieno įrenginio PPA dalies.",
        "unnamed": "Įrenginys {id}",
        "stale_deleted_by_registry": "Registras jį ištrynė. Nuimkite žymę, kad pašalintumėte jį iš telkinio.",
        "stale_not_registered": "Nebėra įregistruotas. Nuimkite žymę, kad pašalintumėte jį iš telkinio.",
        "include_all": "Įtraukti visus įrenginius"
      },
      "eligibility": {
        "title": "Tinkamumas sandoriui",
        "description": "Ką čia rastų sandoris, ribojantis kiekvieną dimensiją. Kiekvieną reikšmę lemia prasčiausias įrenginys.",
        "country_tier": "Šalys",
        "tier": {
          "standard_aib_gc": "Standartinis AIB GC",
          "aib_outside_standard": "AIB, už standartinio rinkinio ribų",
          "pl_be": "Lenkija / Belgija",
          "non_aib": "Ne AIB",
          "unknown": "Nenustatyta"
        },
        "technology_mix": "Technologijos",
        "oldest_cod": "Seniausia eksploatacijos pradžios data",
        "cod_claim_year": "Ataskaitiniams metams {year} pageidaujama eksploatacijos pradžios data yra {cutoff} arba vėlesnė. Tikrinamas tik amžius.",
        "cod_preferred": "Visi įrenginiai atitinka šį amžiaus kriterijų.",
        "cod_not_preferred": "Telkinys neatitinka šio amžiaus kriterijaus arba trūksta eksploatacijos pradžios datų.",
        "supported": "Gamybos parama",
        "ecolabels": "Ekoženklai",
        "through_year": "iki {year} m.",
        "failing_device_count": "neatitinka {count} iš {total} įrenginių",
        "failing_device_count_named": "neatitinka {count} iš {total} įrenginių: {devices}",
        "blocker_device_count": "{count} iš {total} įrenginių",
        "blocker_device_count_named": "{count} iš {total} įrenginių: {devices}",
        "no_issues": "Šiam kriterijui problemų nenustatyta. Vis tiek taikomi konkretaus sandorio apribojimai.",
        "no_devices": "Šiame telkinyje nėra įrenginių.",
        "all_qualify": "Visi įrenginiai atitinka reikalavimus"
      },
      "commitments": {
        "title": "Šio telkinio įsipareigojimai",
        "description": "Kas iš jo parduota.",
        "loading": "Kraunami įsipareigojimai",
        "empty": "Iš šio telkinio nieko neparduota.",
        "all_completed": "Visi šio telkinio įsipareigojimai užbaigti.",
        "show_completed": "Rodyti užbaigtus ({count})",
        "period": "Gamybos laikotarpis",
        "escrowed": "Deponuota",
        "window": "Pristatymo langas",
        "status": "Būsena",
        "deal": "Sandoris",
        "open_deal": "Atidaryti sandorį",
        "committed_on": "Įsipareigota",
        "on_or_before": "ne vėliau kaip {date}"
      },
      "escrow_remaining": {
        "description": "Jūsų įmonės nebepriklauso šiam telkiniui, tačiau toliau nurodyti sertifikatai lieka depozite, kol jais paremti pristatymai bus išsiųsti arba grąžinti. Daugiau nieko apie telkinį nerodoma.",
        "empty": "Šiame telkinyje jums nieko neliko.",
        "period": "Laikotarpis",
        "escrowed": "Depozite",
        "status": "Sandorio būsena",
        "window_end": "Pristatyti iki"
      },
      "editor": {
        "loading": "Kraunamas telkinys",
        "not_found_title": "Šis telkinys nepasiekiamas",
        "not_found_body": "Jo nėra arba jis priklauso įmonėms, prie kurių neturite prieigos.",
        "title": "Telkinys",
        "new_title": "Naujas telkinys",
        "description": "Telkinys nurodo, kokį kiekį jo įmonės siūlo išankstiniam pardavimui ir iš kurių įrenginių.",
        "name": "Pavadinimas",
        "name_hint": "Matomas visiems, kurie mato šį telkinį, įskaitant įmonės narės savininkus, kurie negali jo atidaryti, ir „Soldera“, kai ji sudaro sandorius. Nurodykite grupę ir tai, ką ji parduoda, pvz., „Acme vėjas 2027“. Nenurodykite pirkėjų pavadinimų ir kainų.",
        "pool_description": "Aprašymas",
        "pool_description_hint": "Pastabos įmonėms narėms, pvz., apie grupės susitarimą, kontaktinį asmenį ar kitką, į ką reikia atsižvelgti parduodant šį telkinį. Aprašymą gali skaityti visi, kurie gali atidaryti telkinį. Jis skirtas tik informacijai: ką galima parduoti, nustato pasiūlyti kiekiai ir nustatymai.",
        "delete": "Ištrinti",
        "confirm_delete": "Ištrinti šį telkinį? Jo atžvilgiu niekada nebuvo įsipareigota, todėl nieko neprarandama.",
        "archive": "Archyvuoti",
        "unarchive": "Grąžinti iš archyvo",
        "discard": "Atsisakyti pakeitimų",
        "save": "Išsaugoti",
        "save_anyway": "Vis tiek išsaugoti",
        "save_failed": "Telkinio išsaugoti nepavyko. Patikrinkite formą ir bandykite dar kartą.",
        "unsaved_changes": "Turite neišsaugotų pakeitimų.",
        "close_confirm": "Uždaryti telkinį ir atmesti neišsaugotus pakeitimus?",
        "read_only": "Šį telkinį galite peržiūrėti, bet ne keisti.",
        "details_title": "Pavadinimas ir aprašymas",
        "name_required": "Įveskite telkinio pavadinimą."
      },
      "wizard": {
        "step_members": "Įmonės ir įrenginiai",
        "step_listing": "Pasiūla",
        "step_confirm": "Patvirtinimas",
        "create": "Sukurti telkinį"
      },
      "summary": {
        "title": "Santrauka",
        "companies": "Įmonės",
        "devices": "Įrenginiai",
        "devices_all": "Visi įrenginiai ({count})",
        "devices_allowlisted": "Nepasirinkta jokių įrenginių | {count} pasirinktas įrenginys | Pasirinkta įrenginių: {count}",
        "listing": "Pasiūla",
        "obligation_note": "Tai tikslūs kiekiai, o ne gamybos įverčiai. Jų siūlymas nėra įpareigojantis, tačiau kai sandoris paima kiekį iš šio telkinio, jo įmonės teisiškai įpareigotos pristatyti būtent sandorio paimtą kiekį, nepaisant to, kiek pagamina jų įrenginiai.",
        "obligation_note_pay_as_produced": "Kai sandoris paima kiekį iš šio telkinio, jo įmonės teisiškai įpareigotos pristatyti tai, ką jų įrenginiai pagamina per sandorio laikotarpį."
      },
      "cell_sellable_now": "Parduodama dabar: {value} MWh"
    },
    "sales_strategy": {
      "title": "Pardavimo strategija",
      "help": "Kaip šio telkinio pasiūlytas kiekis laikui bėgant išleidžiamas parduoti. Parduodant gamybos metus dalimis, skirtingu laiku, paskirstoma jų kainos rizika.",
      "split": {
        "asap": "Kuo greičiau",
        "half_yearly": "Parduoti du kartus per metus",
        "quarterly": "Parduoti keturis kartus per metus"
      },
      "split_help": {
        "asap": "išleidžia viską iš karto",
        "half_yearly": "išleidžia kiekį dviem lygiomis dalimis",
        "quarterly": "išleidžia kiekį keturiomis lygiomis dalimis (rekomenduojama)"
      },
      "sell_ahead": {
        "label": "Parduoti į priekį",
        "help": "Kokia kiekvienų gamybos metų dalis parduodama likus dvejiems metams iki gamybos. Likusi dalis parduodama metais prieš gamybą.",
        "next_year_only": "Tik kiti metai",
        "preset": "{percent}%",
        "lead_next_year": "Kiekvieni gamybos metai parduodami metais prieš juos.",
        "lead_ahead": "Kiekvieni gamybos metai parduodami per dvejus metus: {early}% likus dvejiems metams iki gamybos, o likę {rest}% – metais prieš gamybą.",
        "cadence": {
          "asap": "Viskas išleidžiama parduoti sausio 1 d.",
          "half_yearly": "Kiekis išleidžiamas dviem lygiomis dalimis – sausio 1 d. ir liepos 1 d.",
          "quarterly": "Kiekis išleidžiamas keturiomis lygiomis dalimis – sausio 1 d., balandžio 1 d., liepos 1 d. ir spalio 1 d."
        },
        "cadence_ahead": {
          "asap": "Kiekviena dalis išleidžiama iš karto, sausio 1 d.",
          "half_yearly": "Kiekviena dalis išleidžiama dviem lygiomis dalimis – sausio 1 d. ir liepos 1 d.",
          "quarterly": "Kiekviena dalis išleidžiama keturiomis lygiomis dalimis – sausio 1 d., balandžio 1 d., liepos 1 d. ir spalio 1 d."
        },
        "bar_caption": "{year} m. gamyba",
        "bar_segment": "Parduodama {year} m. · {percent}%",
        "release_more": "Išsaugojus iš karto bus išleista parduoti dar {mwh} MWh {year} m. gamybos, nes ankstesni jos pardavimo langai jau atsidarė.",
        "release_less": "Išsaugojus bus sulaikyta {mwh} MWh {year} m. gamybos, kuri šiandien išleista parduoti."
      },
      "summary": "{split}, {horizon}",
      "summary_split": {
        "asap": "kuo greičiau",
        "half_yearly": "du kartus per metus",
        "quarterly": "keturis kartus per metus"
      },
      "summary_next_year": "kitų metų gamyba",
      "summary_ahead": "{percent}% dvejiems metams į priekį",
      "future_only": "Pakeitimas taikomas tik būsimiems pardavimams. Jau įsipareigotas kiekis lieka galioti.",
      "schedule_title": "Pardavimų grafikas",
      "schedule_open": "Rodyti pardavimų grafiką",
      "schedule_pending": "Pardavimų grafikas atsiras čia, kai bus galima peržiūrėti telkinį.",
      "schedule_empty": "Ateinantiems gamybos metams dar nieko nepasiūlyta.",
      "schedule_timeline": "{year} m. pardavimų grafikas",
      "schedule_production": "Gamyba",
      "schedule_auction": "Q{quarter} aukcionas",
      "schedule_total": "Iš viso",
      "schedule_opens_on": "Atsidaro {date}",
      "schedule_group_early": "{year} m. gamyba · ankstyvoji dalis {percent}%",
      "schedule_group_early_note": "(likę {percent}% {year} m.)",
      "schedule_group_rest": "{year} m. gamyba · likę {percent}%",
      "schedule_group_rest_note": "({percent}% išleista {year} m.)",
      "commitments_stand_inline": "Kai kurie įsipareigojimai viršija tai, ką ši strategija išleidžia šiandien. Jie lieka galioti; strategija taikoma naujiems pardavimams.",
      "held_back": "Pardavimo strategija ({strategy}) sulaiko {mwh} MWh.",
      "held_back_next_release": "Pardavimo strategija ({strategy}) sulaiko {mwh} MWh; dar {next} MWh bus išleista {date}.",
      "held_back_reason": "sulaiko pardavimo strategija",
      "held_back_reason_until": "sulaiko pardavimo strategija iki {date}",
      "override": {
        "label": "Ignoruoti visas pardavimo strategijas (PAVOJINGA)",
        "banner_title": "Parduodama viršijant gamintojo pardavimo strategiją",
        "subject": "{pool}: {period}",
        "beyond_line": "{subject} — {mwh} MWh viršija pardavimo strategiją ({strategy}).",
        "beyond_line_next_release": "{subject} — {mwh} MWh viršija pardavimo strategiją ({strategy}); kitas išleidimas {date}.",
        "ignored_nothing_beyond": "Pardavimo strategija ignoruojama — joks paimtas kiekis jos dar neviršija",
        "ignored_figures_unknown": "Pardavimo strategija ignoruojama — jos duomenų nepavyko nuskaityti; išsaugojus bus nurodytas ją viršijantis kiekis"
      }
    },
    "picker": {
      "mode": {
        "existing_inventory": "Esamos atsargos",
        "future_inventory": "Būsima gamyba"
      },
      "new_pap_deal": "Naujas sandoris pagal pagamintą kiekį →",
      "deal": {
        "title": "Sandoris",
        "description": "Pirkėjas, kainos ir pristatymų planas nustatomi sandorio puslapyje, kai šis juodraštis sukurtas."
      },
      "filters": {
        "title": "Gamybos laikotarpis ir greitieji filtrai"
      },
      "pools": {
        "title": "Pasirinkite telkinius"
      },
      "cancel": "Atšaukti",
      "confirm": "Sukurti sandorio juodraštį",
      "confirming": "Kuriama…",
      "footer_note": "Sukūrus sandorį įrašomas juodraštis su vienu įsipareigojimu kiekvienam telkiniui ir pristatymų metmenimis. Pirkėjo duomenys, kainos ir pristatymų planas nustatomi sandorio puslapyje.",
      "criteria": {
        "description": "Ką pirkėjas įsipareigoja pirkti. Šie kriterijai sandoriui galioja visą jo gyvavimo laiką.",
        "name": "Sandorio pavadinimas",
        "name_placeholder": "pvz., Nordic buyer 2026",
        "description_label": "Aprašymas",
        "description_placeholder": "Neprivalomas tekstas sąskaitos eilutei",
        "countries": "Šalys",
        "countries_all": "Bet kuri šalis",
        "countries_hint": "Iš anksto užpildyta standartinėmis AIB GC šalimis. Išvalykite lauką, kad būtų leidžiamos visos šalys.",
        "technologies": "Technologijos",
        "technologies_all": "Bet kuri technologija",
        "technologies_advanced": "Išplėstinė",
        "cod_from": "Eksploatuojama nuo",
        "cod_until": "Eksploatuojama iki",
        "cod_hint": "Apriboja sandorį įrenginiais, kurių eksploatacijos pradžios data patenka į šį intervalą.",
        "support": "Gamybos parama",
        "support_any": "Bet kuris",
        "support_no": "Tik be paramos",
        "ecolabels": "Ekologiniai ženklai",
        "ecolabels_all": "Ekologinio ženklo reikalavimo nėra",
        "ecolabels_hint": "OK-power new baigiasi kartu su įrenginio amžiumi, todėl telkinys gali atitikti ankstesnius gamybos metus ir neatitikti vėlesnių.",
        "min_price_filter": "Slėpti telkinius, brangesnius nei",
        "min_price_filter_hint": "Tik rodinio filtras. Su sandoriu jis neišsaugomas.",
        "quick_filters": "Greitieji filtrai",
        "quick_aib_gc": "Standartinės AIB GC",
        "quick_hsw": "HSW",
        "quick_biomass": "@:common.technology.biomass",
        "quick_nuclear": "Branduolinė",
        "name_required": "Įveskite sandorio pavadinimą."
      },
      "ecolabel": {
        "ekoenergy": "EKOenergy iš anksto patvirtinta",
        "okpower": "Suderinama su OK-power",
        "okpower_new": "Suderinama su OK-power new"
      },
      "period": {
        "title": "Gamybos laikotarpiai",
        "from": "Nuo",
        "until": "Iki",
        "invalid_range": "Intervalas baigiasi anksčiau, nei prasideda.",
        "selected": "{count} laikotarpiai: {periods}",
        "month_warning": "Mėnesio laikotarpius galima padengti tik ten, kur registras išduoda mėnesines pažymas. Telkiniai, kurių įrenginiai išduoda platesniais laikotarpiais, lentelėje pažymėti.",
        "half_year_warning": "Kiekvienas telkinys pristato ketvirčiais, kai tai leidžia jo pasiūlymai ir registras, kitaip pusmečiais: kiekviena dalis pristatoma po ketvirčio, kuriuo ji baigiasi.",
        "year_warning": "Kiekvienas telkinys pristato ketvirčiais, kai tai leidžia jo pasiūlymai ir registras, kitaip pusmečiais ar metais: kiekviena dalis pristatoma po ketvirčio, kuriuo ji baigiasi."
      },
      "take": {
        "filter_pool": "Telkinys ar įmonė",
        "auto_distribute": "Paskirstyti automatiškai",
        "spread": "Paskirstyti po telkinius",
        "target": "MWh",
        "target_label": "Siekiamas kiekis",
        "clear": "Išvalyti",
        "pool": "Telkinys",
        "technology": "Technologija",
        "country": "Šalis",
        "cod": "Seniausia eksploatacija",
        "ecolabels": "Ekologiniai ženklai",
        "support": "Parama",
        "conditions": "Sąlygos",
        "take": "Imti (MWh)",
        "no_floor": "Žemiausios ribos nėra",
        "floor_value": "{value} €/MWh",
        "contango": {
          "any": "parduoda tik esant contango",
          "at_least_20_percent": "parduoda tik ≥ 20 % virš spot kainos"
        },
        "contango_filter": {
          "none": "Be contango sąlygos",
          "any": "Bet koks contango",
          "at_least_20_percent": "Contango ≥ 20 %"
        },
        "cadence": "Šie įrenginiai išduoda sertifikatus platesniais laikotarpiais nei pasirinktas intervalas.",
        "allocation_not_ready": "Paskirstymas išjungtas: {companies}. Jų vardu nieko nebus deponuota.",
        "capacity_cap": "Pasirinktame intervale ne daugiau kaip {value} MWh.",
        "capacity_period": "{period}: {value}",
        "row_subtitle": "{companies} · {devices}",
        "empty": "Nė vienas telkinys negali padengti šio produkto šiame intervale.",
        "loading": "Ieškoma telkinių",
        "refreshing": "Atnaujinama",
        "refresh_pending": "Prieš kurdami sandorį palaukite, kol atsinaujins telkinių lentelė.",
        "load_failed": "Telkinių lentelės nepavyko įkelti.",
        "hint_floor": "Šio pasirinkimo pristatymo kaina negali būti mažesnė nei {value} €/MWh.",
        "warnings_title": "Verta patikrinti",
        "ineligible_title": "Neįtraukti ({count})",
        "ineligible_hint": "Telkiniai, kuriuos galėtumėte naudoti, bet kuriuos šis produktas ar intervalas atmeta."
      },
      "summary": {
        "all": "Visi telkiniai",
        "taken": "Paimta",
        "pools_count": "{count} telkiniai",
        "by_period": "Pagal gamybos laikotarpį",
        "by_period_estimate": "Apytikslis paskirstymas. Tikslus nustatomas kuriant sandorį.",
        "by_country": "Pagal šalį",
        "by_price": "Pagal kainos sąlygą",
        "by_technology": "Pagal technologiją",
        "by_cod": "Eksploatacijos pradžios data",
        "re100": "RE100 tinkamumas",
        "by_ecolabel": "Ekologinio ženklo statusas",
        "by_support": "Paramos statusas",
        "cod_young": "COD ≤5 metai",
        "cod_middle": "COD 6–15 metų",
        "cod_old": "COD >15 metų",
        "pool_qualifications": "Savybės apibūdina visus telkinius, o ne paskirstytus sertifikatus. COD remiasi seniausiu įrenginiu; RE100 ir ekologiniams ženklams visi įrenginiai turi atitikti reikalavimus per visą laikotarpį.",
        "judged_at": "vertinta {date} dienai",
        "nothing_taken": "Kol kas nieko nepaimta."
      },
      "errors": {
        "no_takes": "Paimkite kiekį bent iš vieno telkinio.",
        "create_failed": "Sandorio sukurti nepavyko.",
        "over_capacity": "Kuris nors paimtas kiekis viršija tai, ką telkinys gali parduoti. Pirmiausia sumažinkite jį iki telkinio ribos."
      }
    },
    "pap": {
      "title": "Naujas sandoris pagal pagamintą kiekį",
      "description": "Sandoris pagal pagamintą kiekį perka visą vieno telkinio produkciją mėnuo po mėnesio pagal sutartą grafiką.",
      "pool": "Telkinys pagal pagamintą kiekį",
      "pool_hint": "Šį sandorį gali padengti tik telkiniai pagal pagamintą kiekį; jų įrenginiai nepriklauso jokiam kitam telkiniui.",
      "pool_empty": "Telkinio pagal pagamintą kiekį dar nėra. Pirmiausia sukurkite jį gamintojo darblapyje.",
      "pool_devices": "{devices} įrenginiai · {companies} įmonės",
      "pool_blocked_choose_another": "Norėdami sukurti sandorį, pasirinkite kitą telkinį.",
      "name": "Sandorio pavadinimas",
      "name_placeholder": "pvz., Hidro produkcija 2027",
      "description_label": "Aprašymas",
      "description_placeholder": "Neprivalomas tekstas sąskaitos eilutei",
      "unit_price": "Vieneto kaina",
      "unit_price_hint": "Kiekvienas sutarties mėnuo sąskaitoje apmokestinamas šia kaina.",
      "window": "Sutarties laikotarpis",
      "window_start": "Pirmas mėnuo",
      "window_end": "Paskutinis mėnuo",
      "window_invalid": "Laikotarpis baigiasi anksčiau, nei prasideda.",
      "window_missing": "Pasirinkite laikotarpio pirmą ir paskutinį mėnesį.",
      "window_too_long": "Sutarties laikotarpis apima ne daugiau kaip {count} mėnesių.",
      "schedule": "Sutartas grafikas",
      "schedule_hint": "Po vieną tikslą kiekvienam laikotarpio mėnesiui. Produkcija su juo lyginama mėnuo po mėnesio.",
      "schedule_total": "{value} MWh per {count} mėnesių",
      "tolerance": "Kiekio nuokrypis",
      "tolerance_hint": "Kiek mėnuo gali nukrypti nuo tikslo, kol nėra pažymimas.",
      "context_failed": "Nepavyko įkelti savininko parinkčių.",
      "create": "Sukurti sandorį",
      "creating": "Kuriama…",
      "cancel": "Atšaukti",
      "create_failed": "Sandorio sukurti nepavyko.",
      "load_failed": "Telkinių nepavyko įkelti.",
      "loading": "Įkeliami telkiniai",
      "production_range_from_until": "Šis telkinys parduoda tik gamybą nuo {from} iki {until}.",
      "production_range_from": "Šis telkinys parduoda tik gamybą nuo {from}.",
      "production_range_until": "Šis telkinys parduoda tik gamybą iki {until}.",
      "window_outside_range": "Sutarties laikotarpis turi tilpti į šio telkinio parduodamos gamybos ribas."
    },
    "transaction_header": {
      "title": "Išankstinis pristatymas",
      "deal": "Sandoris",
      "window_open": "Pristatyti ne vėliau kaip {date}",
      "window_range": "Pristatyti nuo {start} iki {end}",
      "escrowed_of_planned": "{escrowed} iš {planned} MWh deponuota",
      "managed_note": "Pozicijos, kiekiai, pirkėjo duomenys ir kainos ateina iš sandorio ir keičiami ten.",
      "open_deal": "Atidaryti sandorį",
      "deal_notes": "Sandorio vidinės pastabos",
      "delivery_notes": "Pristatymo vidinės pastabos"
    },
    "deals": {
      "loading": "Įkeliamas sandoris…",
      "not_found_title": "Sandoris nerastas",
      "not_found_body": "Tokio sandorio nėra arba jis jums neprieinamas.",
      "load_failed_title": "Sandorio įkelti nepavyko",
      "load_failed_body": "Mūsų pusėje kažkas nepavyko. Pabandykite dar kartą po akimirkos.",
      "draft_warning": "Sandorio juodraštis: jo pristatymai nerodomi skiltyje „Artėjantys pristatymai“, o sertifikatai neskiriami, kol sandoris nepatvirtintas.",
      "common": {
        "cancel": "Atšaukti",
        "close": "Uždaryti",
        "commitment_gone": "Šio įsipareigojimo sandoryje nebėra."
      },
      "header": {
        "back": "← Ateities sandoriai",
        "buyer": "Pirkėjas: {buyer}",
        "buyer_missing": "Pirkėjas dar neįvestas",
        "signed_at": "pasirašyta {date}"
      },
      "badges": {
        "escrow_shortfall": "depozite trūksta {mwh} MWh",
        "infeasible": "{pool} nepadengia laikotarpio {period} — trūksta {mwh} MWh",
        "stale_draft": "Senas juodraštis",
        "drift_report": "{count} įrenginių nebeatitinka | {count} įrenginys nebeatitinka | {count} įrenginiai nebeatitinka",
        "drift_report_line": "{device}: {reasons}",
        "device_number": "Įrenginys {id}",
        "free_escrow": "{mwh} MWh depozito laukia grąžinimo"
      },
      "metadata": {
        "title": "Pirkėjas ir sutartis",
        "edit": "Redaguoti",
        "edit_title": "Pirkėjo ir sutarties duomenys",
        "save": "Išsaugoti",
        "name": "Sandorio pavadinimas",
        "description": "Aprašymas",
        "buyer": "Pirkėjas",
        "emails": "Pirkėjo el. pašto adresai",
        "registration_authority": "Registro tvarkytojas",
        "billing_country": "Atsiskaitymo šalis",
        "deal_volume": "Sandorio apimtis",
        "signed_at": "Pasirašyta",
        "created_at": "Sukurta",
        "confirmed_at": "Patvirtinta",
        "links": "Nuorodos",
        "contract_links": "Sutartis",
        "transaction_link": "Sandoris",
        "offering_sheets": "Pasiūlymo lapai",
        "offering_sheets_help": "Kableliais atskirtos nuorodos, seniausia pirma. Sugeneruotas lapas pridedamas čia; kai sąrašas pilnas, senas pašalinkite čia.",
        "transaction_link_invalid": "Įveskite vieną nuorodą, prasidedančią http:// arba https://.",
        "shipped_keep_details": "Šiam sandoriui išsiųsta pristatymų: {count}. Jų sandoriai ir sąskaitos išlaiko pirkėjo ir sutarties duomenis, su kuriais jie išsiųsti; pakeitimas čia taikomas tik dar neišsiųstiems pristatymams. | Šiam sandoriui išsiųstas {count} pristatymas. Jo sandoris ir sąskaitos išlaiko pirkėjo ir sutarties duomenis, su kuriais jis išsiųstas; pakeitimas čia taikomas tik dar neišsiųstiems pristatymams. | Šiam sandoriui išsiųsta pristatymų: {count}. Jų sandoriai ir sąskaitos išlaiko pirkėjo ir sutarties duomenis, su kuriais jie išsiųsti; pakeitimas čia taikomas tik dar neišsiųstiems pristatymams.",
        "not_set": "Nenurodyta"
      },
      "criteria": {
        "title": "Tinkamumo kriterijai",
        "edit": "Redaguoti",
        "save": "Išsaugoti kriterijus",
        "locked": "Užrakinta",
        "countries": "Šalys",
        "technologies": "Technologijos",
        "cod": "Eksploatacijos pradžios data",
        "cod_from": "Eksploatuojama nuo",
        "cod_until": "Eksploatuojama iki",
        "cod_range": "{from} — {until}",
        "any": "bet kokia",
        "support": "Gamybos parama",
        "support_any": "Bet kuri",
        "support_unsupported_only": "Tik be paramos",
        "ecolabels": "Ekologiniai ženklai",
        "unrestricted": "Be apribojimų",
        "conflicts_help": "Išsaugant pakeitimas pirmiausia patikrinamas. Pakeitimas, prieštaraujantis dengimui ar depozitui, kurį sandoris dar pristato, atmetamas; dėl jo niekas neatlaisvinama ir negrąžinama.",
        "conflicts_blocking": "Šis pakeitimas prieštarauja tam, ką sandoris dar pristato. Pirmiausia tai išspręskite ir išsaugokite dar kartą:",
        "conflicts_warning": "Jau pristatyta pagal dabartinius kriterijus. Išsaugojus tai lieka nepakeista:",
        "save_anyway": "Vis tiek išsaugoti",
        "ecolabel": {
          "ekoenergy": "EKOenergy iš anksto patvirtinta",
          "okpower": "OK-power suderinama",
          "okpower_new": "OK-power new suderinama"
        }
      },
      "plan": {
        "title": "Pristatymo planas",
        "generate_offering_sheet": "Sukurti pasiūlymo lapą",
        "offering_sheet_link": "Atverti naujausią pasiūlymo lapą",
        "edit_plan": "Redaguoti planą",
        "empty": "Šis sandoris dar neturi pristatymų.",
        "delivery": "Pristatymas",
        "period": "Gamybos laikotarpis",
        "escrowed_of": "Deponuota / suplanuota",
        "backed_by": "Užtikrina",
        "backed_by_commitment": "Dengia įsipareigojimas {id}. Žr. Įsipareigojimų lentelę.",
        "open_volume": "Nepadengta",
        "no_slices": "Šiame pristatyme dar nieko nesuplanuota.",
        "n_short": "trūksta {mwh}",
        "n_open": "nepadengta {mwh}",
        "remove": "Pašalinti",
        "actions": {
          "menu": "Veiksmai: {period}",
          "resize": "Keisti kiekį",
          "resize_tooltip": "Pakeisti šio gamybos laikotarpio įsipareigotą kiekį. Jo negalima sumažinti žemiau jau deponuoto kiekio.",
          "split_move": "Padalyti ir perkelti",
          "split_move_tooltip": "Perkelti visą šį įsipareigotą kiekį arba jo dalį į kitą pristatymą; depozitas perkeliamas kartu.",
          "narrow": "Susiaurinti",
          "narrow_tooltip": "Padalyti įsipareigotą gamybos laikotarpį į trumpesnius laikotarpius, pavyzdžiui, metus į ketvirčius, nekeičiant bendro kiekio.",
          "remove_backing": "Pašalinti dengimą",
          "remove_backing_tooltip": "Pašalinti telkinio dengimą nuo šio kiekio ir palikti jį atvirą kitam telkiniui.",
          "remove_backing_escrowed_tooltip": "Už šią apimtį deponuota {mwh} MWh. Grąžinkite juos savininkui prieš šalindami dengimą.",
          "pull_to_escrow": "Įtraukti į depozitą…",
          "pull_to_escrow_tooltip": "Pasirinkti šiame telkinyje prieinamus sertifikatus ir perkelti juos į šio įsipareigojimo depozitą.",
          "back": "Padengti…",
          "back_tooltip": "Padenkite šį atvirą kiekį įsipareigojimu iš tinkamo telkinio."
        },
        "window_on_or_before": "Ne vėliau kaip {end}",
        "window_range": "{start} — {end}",
        "unit_price": "{price} €/MWh",
        "no_price": "Kaina nenurodyta",
        "delivery_shortfall": "trūksta {mwh} MWh",
        "deliver": "Pristatyti →",
        "deliver_anyway": "Vis tiek pristatyti",
        "transaction_link": "Sandoris #{id}",
        "outside_window_title": "Už pristatymo lango ribų",
        "outside_window_body": "Šiandienos data yra už šio pristatymo lango ({window}). Vis tiek pristatyti?",
        "summary_open": "{mwh} MWh nepadengta",
        "summary_fully_committed": "Visa suplanuota apimtis įsipareigota",
        "summary_totals": "{planned} suplanuota · {committed} įsipareigota · {escrowed} depozite",
        "summary_deal_volume": "sandorio apimtis {mwh} MWh",
        "summary_no_deal_volume": "sandorio apimtis neišsaugota",
        "confirm": "Patvirtinti sandorį",
        "cancel_deal": "Atšaukti sandorį",
        "cancel_title": "Atšaukti šį sandorį?",
        "cancel_body": "Atšaukus atlaisvinami visi įsipareigojimai ir anuliuojami visi nepristatyti juodraščiai. Jau depozite esanti apimtis lieka, kol bus grąžinta savininkams.",
        "cancel_body_pap": "Atšaukus anuliuojami visi dar nepristatyti mėnesiai. Tiems mėnesiams jau depozite esantys sertifikatai lauks grąžinimo: grąžinkite juos savininkams kortelėje „Depozitas laukia grąžinimo“. Jau pristatyti mėnesiai lieka nepakeisti.",
        "unconfirm": "Grąžinti į juodraštį",
        "unconfirm_title": "Grąžinti šį sandorį į juodraštį?",
        "unconfirm_body": "Sandoris pašalinamas iš paskirstymo eilės, todėl jam nebeperkeliami sertifikatai į depozitą, o jo kriterijus vėl galima redaguoti. Įsipareigojimai lieka, todėl apimtis lieka rezervuota. Be pasirašymo datos pristatymai netenka kainos datos. Patvirtinus iš naujo, sandoris atsiduria eilės gale."
      },
      "editor": {
        "title": "Plano redagavimas",
        "discard": "Atsisakyti",
        "save": "Išsaugoti planą",
        "window_start": "Lango pradžia · nebūtina",
        "window_end": "Lango pabaiga",
        "unit_price": "Vieneto kaina",
        "remove_delivery": "Pašalinti pristatymą",
        "add_period": "Pridėti laikotarpį",
        "add_delivery": "Pridėti pristatymą",
        "period_placeholder": "2026-Q1, 2026-04 arba 2026",
        "planned_for": "Suplanuota apimtis laikotarpiu {period}",
        "backed_caption": "{mwh} MWh padengta",
        "below_backed": "Čia padengta {mwh} MWh. Suplanuokite bent tiek.",
        "remove_row_backed": "{mwh} MWh yra padengta. Pirmiausia pašalinkite dengimą plane.",
        "duplicate_period": "Šis gamybos laikotarpis šiame pristatyme jau yra."
      },
      "correction": {
        "editor_hint": "Pristatytų ir anuliuotų pristatymų laikotarpiai nesikeičia. Kaip superadministratorius vis tiek galite pataisyti jų langą ir kainą; jau sukurtos sąskaitos lieka nepakitusios.",
        "schedule_hint": "Pristatyto mėnesio kainą galima pataisyti. Jau sukurtos sąskaitos išlaiko seną kainą.",
        "voided_delivery": "Šis pristatymas anuliuotas: pakeitimas matomas tik sandorio puslapyje, jo neskaito jokia sąskaita ar ataskaita.",
        "buyer_invoice_replaceable": "Pirkėjo sąskaita {number} išlaiko seną kainą. Sukurkite ją iš naujo, jei ji dar neišsiųsta.",
        "buyer_invoice_sent": "Pirkėjo sąskaita {number} išsiųsta ir išlaiko seną kainą. Jos nebegalima sukurti iš naujo.",
        "completion_invoices_issued": "Užbaigimo metu išrašyta gamintojo išmoka ir galimi komisiniai išlaiko seną kainą.",
        "dashboard_period_moves": "Jokia sąskaita neskaito pristatymo lango. Tik finansų suvestinė perkelia pardavimą į naujo lango pabaigos laikotarpį."
      },
      "commitments": {
        "title": "Įsipareigojimai",
        "empty": "Šio sandorio dar niekas nedengia.",
        "description": "Kiekviena eilutė yra vienas apimties paėmimas iš telkinio. Apimtis ir kainos sąlygos užfiksuotos paėmimo metu; telkinio pasiūla ir kainos nuo tada gali būti pasikeitusios.",
        "granularity": "Detalumas: {width}",
        "id_header": "ID",
        "pool_header": "Telkinys",
        "pulled_on": "Paimta",
        "volume": "Deponuota / įsipareigota",
        "price_conditions": "Kainos sąlygos",
        "released": "Atlaisvinta",
        "released_tooltip": "Diena, kai šis užtikrinimas buvo visiškai pašalintas: kiekis grįžo į fondo prieinamumą ir įsipareigojimas nebepretenduoja į jo atsargas.",
        "floor": "apatinė riba {price} €/MWh",
        "no_floor": "apatinės ribos nėra",
        "contango": {
          "any": "tik esant contango",
          "at_least_20_percent": "tik ≥ 20 % virš spot kainos"
        },
        "show_escrow": "Deponuota…",
        "show_escrow_tooltip": "Rodyti, kurių įmonių sertifikatai dengia šį įsipareigojimą; vyriausiasis administratorius gali iš čia grąžinti juos savininkams.",
        "contributions": "Įnašai · depozitas pagal įmonę",
        "escrow_title": "{pool} · paimta {date}",
        "company": "Įmonė",
        "no_escrow": "Prieš šį įsipareigojimą dar nieko nėra depozite.",
        "entry_width": {
          "quarter": "ketvirtinis",
          "month": "mėnesinis",
          "half_year": "pusmetinis",
          "year": "metinis"
        },
        "pay_as_produced": "pagal pagamintą kiekį",
        "strategy_overridden": "Parduota viršijant pardavimo strategiją",
        "sold_beyond_strategy": "{pool} — {mwh} MWh parduota viršijant pardavimo strategiją."
      },
      "free_escrow": {
        "title": "Depozitas laukia grąžinimo",
        "subtitle": "{mwh} MWh, kurių nebedengia joks aktyvus pristatymas",
        "return": "Grąžinti savininkui…",
        "company": "Įmonė",
        "period": "Gamybos laikotarpis"
      },
      "add_commitment": {
        "title_back": "Padengti {period}",
        "submit": "Pridėti įsipareigojimą",
        "search": "Ieškoti telkinių",
        "search_placeholder": "Įveskite telkinio pavadinimo dalį",
        "searching": "Ieškoma telkinių…",
        "no_pools": "Nė vienas jums prieinamas telkinys neatitinka šios paieškos.",
        "listed": "pasiūlyta {mwh} MWh",
        "no_availability": "{period} nieko nėra prieinama",
        "takes_title": "Kiek imti iš šio laikotarpio",
        "open": "Nepadengta",
        "take": "Imti",
        "take_for": "Imamas kiekis laikotarpiu {period}",
        "max": "iki {mwh}",
        "over_max": "čia galima paimti ne daugiau kaip {mwh} MWh",
        "impact": "Nepadengta apimtis sumažėja nuo {from} MWh iki {to} MWh.",
        "submit_beyond_strategy": "Pridėti viršijant pardavimo strategiją"
      },
      "resize": {
        "title": "Keisti įsipareigotą kiekį",
        "submit": "Keisti",
        "body": "{period} · {pool} · šiuo metu įsipareigota {mwh} MWh.",
        "new_volume": "Naujas įsipareigotas kiekis",
        "escrow_floor": "Prieš šią dalį jau yra {mwh} MWh depozite, todėl žemiau nusileisti negalima.",
        "shrink_warning": "Atiduodami {mwh} MWh tampa atviri ir grįžta į telkinio prieinamą kiekį. Įsipareigojimas likusiam kiekiui išlaiko užfiksuotas kainos sąlygas; vėlesnis to kiekio dengimas yra naujas įsipareigojimas tos dienos sąlygomis.",
        "submit_beyond_strategy": "Keisti viršijant pardavimo strategiją"
      },
      "move": {
        "title": "Perkelti arba padalyti",
        "submit": "Perkelti",
        "body": "{period} · {mwh} MWh. Jau depozite esantis kiekis keliauja kartu.",
        "target": "Tikslinis pristatymas",
        "target_placeholder": "Pasirinkite pristatymą",
        "volume": "Perkeliamas kiekis",
        "volume_placeholder": "Visa dalis",
        "volume_hint": "Palikite tuščią, kad perkeltumėte visą dalį.",
        "volume_out_of_range": "nuo 1 iki {mwh} MWh, dalies kiekis"
      },
      "narrow": {
        "title": "Susiaurinti laikotarpį",
        "submit": "Susiaurinti",
        "body": "{period} · {mwh} MWh. Kiekis paskirstomas po polaikotarpius proporcingai tam, kiek telkinys siūlo kiekviename iš jų.",
        "width": "Susiaurinti iki",
        "already_narrowest": "Šis laikotarpis jau yra siauriausias įmanomas.",
        "hint": "Jau depozite esantis kiekis priskiriamas tam polaikotarpiui, kuriam priklauso kiekvienas sertifikatas."
      },
      "remove_backing": {
        "title": "Ar pašalinti šio telkinio dengimą?",
        "pull": "Paimta {date} · {conditions}",
        "released_whole": "{mwh} MWh grįžta į telkinio {pool} prieinamą kiekį, o šis įsipareigojimas atlaisvinamas visiškai, nes tai paskutinis jo dengiamas kiekis.",
        "released_part": "{mwh} MWh grįžta į telkinio {pool} prieinamą kiekį, o šis įsipareigojimas atlaisvinamas iš dalies, nes likęs jo dengiamas kiekis išlieka.",
        "snapshot_lost": "Paėmimo metu užfiksuotos kainos sąlygos prarandamos. Vėlesnis šio kiekio dengimas yra naujas įsipareigojimas tos dienos telkinio sąlygomis ir tik jei kiekis dar bus prieinamas.",
        "confirm": "Pašalinti dengimą"
      },
      "return_escrow": {
        "section_title": "Grąžinti savininkui",
        "title": "Grąžinti depozitą savininkui",
        "submit": "Grąžinti pasirinktus",
        "loading": "Įkeliami depozite esantys sertifikatai…",
        "body": "Pasirinkti sertifikatai lieka Soldera registro sąskaitoje ir priskiriami naujam kiekvieno savininko virtualiam portfeliui. Kiekvieną eilutę galima grąžinti ir iš dalies.",
        "nothing": "Šiam sandoriui nieko nėra depozite.",
        "company": "Įmonė",
        "device": "Įrenginys",
        "month": "Gamybos mėnuo",
        "escrowed": "Depozite",
        "return_count": "Grąžinti",
        "select_all": "Pasirinkti visas eilutes",
        "select_row": "Pasirinkti {device}",
        "count_for": "Grąžinamas kiekis iš {device}",
        "over_count": "šioje eilutėje deponuota ne daugiau kaip {mwh} MWh",
        "summary_title": "Grąžinama",
        "results_title": "Grąžinta {moved} MWh, {failed} eilučių nepavyko.",
        "result_line": "{count} MWh iš įrašo {item}"
      },
      "pull_escrow": {
        "title": "Įtraukti į depozitą",
        "submit": "Įtraukti į depozitą",
        "body": "Perkelkite sertifikatus, kurie praėjo pro ateities sandorių žingsnį, į šio įsipareigojimo depozitą. Savininkas nesikeičia.",
        "company": "Įmonė",
        "company_placeholder": "Pasirinkite telkinio narį",
        "source_portfolio": "Šaltinio portfelis",
        "portfolio_placeholder": "Pasirinkite portfelį",
        "allowed_sources": "Įtraukti galima tik iš nepaskirstytų, sulaikytų, spot ir virtualių portfelių.",
        "loading_items": "Įkeliami sertifikatai…",
        "no_items": "Šiame portfelyje nėra nieko, ką būtų galima įtraukti.",
        "items_failed": "Sertifikatų įkelti nepavyko. Norėdami bandyti dar kartą, uždarykite šią formą ir atidarykite ją iš naujo.",
        "after_move": "Šio įsipareigojimo depozitas padidėja nuo {from} MWh iki {to} MWh iš įsipareigotų {total} MWh.",
        "results_title": "Perkelta {moved} eilučių, {failed} eilučių nepavyko.",
        "result_line": "{count} MWh iš įrašo {item}"
      },
      "producer_prices": {
        "button": "Gamintojų kainos…",
        "title": "Gamintojų kainos · {window}",
        "body": "Kiek kiekvienas gamintojas nurodo sąskaitoje už šį pristatymą. Tai Soldera pirkimo kainos, sandorio savininkui jos niekada nerodomos.",
        "no_lines": "Šiame pristatyme kol kas nė vienas gamintojas neturi sertifikatų. Jų eilutės atsiras čia, kai sertifikatai pateks į depozitą.",
        "company": "Gamintojas",
        "amount": "MWh",
        "price": "Vieneto kaina",
        "price_for": "{company} vieneto kaina",
        "delivery_price_note": "Tuščias paliktas gamintojas sąskaitą išrašo paties pristatymo kaina: {price}.",
        "trade_owner": "Sandorio tarpininkas",
        "trade_owner_help": "Gauna komisinį mokestį nuo apsikeitimo sandorio maržos.",
        "trade_owner_placeholder": "Pasirinkite sandorio tarpininką…",
        "trade_owner_none": "Nėra",
        "submit": "Išsaugoti",
        "lines_removed": "Tuo metu iš pristatymo dingo gamintojų eilučių: {count}, jos pašalintos | Tuo metu iš pristatymo dingo {count} gamintojo eilutė, ji pašalinta | Tuo metu iš pristatymo dingo gamintojų eilučių: {count}, jos pašalintos",
        "shipped_meanwhile": "Kol redagavote, šis pristatymas buvo išsiųstas. Jo kainos dabar yra istorija, todėl jūsų pakeitimai neišsaugoti.",
        "delivery_gone": "Šio pristatymo sandoryje nebėra, todėl jūsų pakeitimai neišsaugoti.",
        "blank_price": "tuščia (pristatymo kaina)",
        "default_price": "Numatytoji gamintojo kaina",
        "default_price_help": "Tušti palikti gamintojai ir gamintojai, kurių sertifikatai į pristatymą pateks vėliau, išrašo sąskaitas šia kaina. Palikite tuščią, kad būtų naudojama paties pristatymo kaina.",
        "default_price_note": "Tuščias paliktas gamintojas išrašo sąskaitą numatytąja gamintojo kaina: {price}.",
        "default_price_none": "Nėra (paties pristatymo kaina)",
        "blank_follows_default": "tuščia (numatytoji gamintojo kaina)",
        "no_escrow_yet": "Escrow dar nėra",
        "kept_outside_pools": "Nėra palaikančiame telkinyje",
        "kept_outside_pools_help": "Išsaugota iš laikų, kai šis gamintojas priklausė pristatymą palaikantiems telkiniams. Ji vėl galios, jei gamintojas sugrįš; pašalinkite, jei neturėtų galioti.",
        "add_producer": "Nustatyti gamintojo kainą prieš escrow",
        "add_producer_placeholder": "Pasirinkite pristatymą remiančio telkinio narį…",
        "add_producer_help": "Pristatymą remiančio telkinio nariui galima nustatyti savo kainą, kol jo sertifikatai dar neatkeliavo.",
        "eligible_error": "Nepavyko įkelti remiančių telkinių narių.",
        "pool_floor": "{pool} (minimumas {price})",
        "remove_producer": "Pašalinti įmonės {company} kainą"
      },
      "delivery_notes": {
        "button": "Pastabos…",
        "title": "Vidinės pastabos · {window}",
        "label": "Vidinės pastabos",
        "help": "Tik darbuotojams: niekada nekopijuojamos į pristatymo sandorį ir nerodomos gamintojams ar pirkėjams.",
        "submit": "Išsaugoti",
        "heading": "Vidinės pastabos",
        "default_producer_price": "Numatytoji gamintojų kaina: {price}"
      },
      "pap": {
        "schedule_title": "Nominuotas grafikas ir leistina paklaida",
        "edit_schedule": "Redaguoti grafiką",
        "save_schedule": "Išsaugoti grafiką",
        "window": "{start} — {end}",
        "no_window": "Sutarties laikotarpis nenurodytas",
        "no_schedule": "Nė vienas mėnuo dar nenominuotas.",
        "tolerance": "Leistina paklaida ± {percent} %",
        "pools": "Telkiniai | Telkinys | Telkiniai",
        "tolerance_label": "Leistina paklaida ± %",
        "tolerance_hint": "Kiek mėnuo gali viršyti nominuotą kiekį arba jo nepasiekti, kol nebus pažymėtas.",
        "month": "Mėnuo",
        "nominated": "Nominuota",
        "target_for": "Nominuotas kiekis mėnesiui {month}",
        "monitoring_title": "Mėnesinė stebėsena",
        "monitoring_loading": "Įkeliama stebėsena…",
        "monitoring_empty": "Kol kas nėra ko stebėti.",
        "nominated_vs_escrowed": "Nominuota ir depozite",
        "delta": "Skirtumas nuo nominuoto",
        "status": "Būsena",
        "status_pending": "Laukiama",
        "status_within": "Ribose",
        "status_over": "Virš ribų",
        "status_under": "Žemiau ribų",
        "status_delivered": "Pristatyta",
        "ship_early_title": "Ar pristatyti šį mėnesį dabar?",
        "ship_early_body": "Šis mėnuo dar nesibaigė: gamyba gali tęstis, o bus pristatyta tik tai, kas šiuo metu yra depozite. Pristatymas užšaldo mėnesį, todėl vėliau už jį išduoti sertifikatai taps laisvu depozitu, kurį reikės grąžinti rankiniu būdu.",
        "ship_early_confirm": "Vis tiek pristatyti",
        "sell_price": "Pardavimo kaina",
        "sell_price_for": "Pardavimo kaina mėnesiui {month}",
        "sell_price_invalid": "Įveskite didesnę nei 0 kainą, ne daugiau kaip 3 skaitmenys po kablelio.",
        "months_shipped": "{months} tuo metu buvo išsiųsti; jūsų šių mėnesių pakeitimai atmesti | {months} tuo metu buvo išsiųstas; jūsų šio mėnesio pakeitimai atmesti | {months} tuo metu buvo išsiųsti; jūsų šių mėnesių pakeitimai atmesti"
      },
      "transaction_status": {
        "DRAFT": "Juodraštis",
        "PENDING_BUYER_DETAILS": "Trūksta pirkėjo duomenų",
        "PENDING_CONTRACTS": "Trūksta sutarčių",
        "READY_TO_TRANSFER": "Paruošta pervesti",
        "DELIVERED": "Pristatyta",
        "COMPLETED": "Užbaigta",
        "voided": "Anuliuota"
      },
      "merge": {
        "changed_meanwhile": "Kol redagavote, kažkas kitas išsaugojo pakeitimų. Jūsų pakeitimai išsaugoti ir sujungti su jų pakeitimais. Patikrinkite rezultatą ir išsaugokite dar kartą.",
        "unaffected": "Kol redagavote, sandorį išsaugojo kažkas kitas, tačiau niekas iš čia rodomo nepasikeitė. Išsaugokite dar kartą, kad pritaikytumėte savo pakeitimus.",
        "taken_over": "Perimta išsaugotų pakeitimų: {count} | Perimtas {count} išsaugotas pakeitimas | Perimta išsaugotų pakeitimų: {count}",
        "conflicts": "Abiejose pusėse pakeista laukų: {count}; žemiau pasirinkite kiekvieno reikšmę | Abiejose pusėse pakeistas {count} laukas; žemiau pasirinkite jo reikšmę | Abiejose pusėse pakeista laukų: {count}; žemiau pasirinkite kiekvieno reikšmę",
        "yours": "Jūsų: {value}",
        "saved_now": "Dabar išsaugota: {value}",
        "keep_yours": "Palikti jūsų",
        "use_saved": "Naudoti išsaugotą"
      }
    }
  },
  "soldera_inventory": {
    "title": "Soldera atsargos",
    "description": "Kilmės garantijos, kurias Soldera gali pristatyti dabar arba iš būsimos gamybos. Pasirinkite kiekį ir nusiųskite Soldera savo pasiūlymą.",
    "not_enabled": "Soldera atsargos jūsų paskyrai neįjungtos. Dėl prieigos susisiekite: {email}.",
    "purchase_details": "Pirkimo informacija",
    "counterparty_emails": "Sąskaitų el. pašto adresai",
    "counterparty_emails_hint": "Kelis adresus atskirkite kableliais.",
    "price": "Kaina",
    "price_hint": "Jūsų kaina už sertifikatą (1 MWh). Sertifikatai, už kuriuos gamintojas prašo daugiau, nerodomi.",
    "select_certificates": "Pasirinkite sertifikatus",
    "create_purchase": "Siųsti įpareigojantį pasiūlymą",
    "regions": "Regionai",
    "blocked": {
      "no_selection": "Pasirinkite sertifikatus, kuriuos norite pirkti.",
      "no_price": "Įveskite didesnę nei nulis kainą.",
      "mixed_authorities": "Pasirinkite sertifikatus iš vienos sertifikatų schemos.",
      "no_company": "Pasirinkite įmonę, kurios vardu perkate."
    },
    "created_title": "Įpareigojantis pasiūlymas išsiųstas",
    "created_description": "Jūsų įpareigojantis pasiūlymas {mwh} MWh išsiųstas Solderai. Susisieksime su jumis dėl patvirtinimo.",
    "billing_country": "Atsiskaitymo šalis",
    "generate_breakdown": "Sukurti Excel suvestinę",
    "open_breakdown": "Atidaryti suvestinę",
    "breakdown_ready_title": "Suvestinė paruošta",
    "breakdown_ready_description": "Suvestinė atidaryta naujame skirtuke ir pasidalinta su {email}.",
    "tabs": {
      "spot": "Galima dabar",
      "forward": "Būsima gamyba"
    },
    "forward": {
      "select_pools": "Pasirinkite būsimą gamybą",
      "price_hint": "Jūsų kaina už MWh kiekvienam pristatymui. Gamyba, už kurią gamintojai prašo daugiau, nerodoma.",
      "no_pools": "Šiais laikotarpiais už šią kainą būsimos gamybos nesiūloma.",
      "spread_over_pools": "@:forwards.picker.take.spread",
      "all_technologies": "Visos technologijos",
      "all_countries": "Visos šalys",
      "columns": {
        "technology": "@:forwards.picker.take.technology",
        "country": "@:forwards.picker.take.country",
        "scheme": "Schema",
        "cod_age": "Seniausia COD (metai)",
        "support": "@:forwards.picker.take.support",
        "ecolabels": "@:forwards.picker.take.ecolabels",
        "capacity": "Galima MWh",
        "take": "Jūsų MWh"
      },
      "blocked": {
        "no_takes": "Įveskite norimą MWh kiekį bent iš vieno telkinio."
      },
      "warnings": {
        "pl_be_mixed": "Jūsų pasirinkimas sujungia {flagged} su {others}, kurie paprastai perkami kaip atskiri produktai.",
        "standard_aib_gc_mixed": "Jūsų pasirinkimas sujungia Standard AIB GC šalis ({standard}) su šalimis už standartinio sąrašo ribų ({outside}).",
        "technology_mixed": "Jūsų pasirinkimas sujungia {advanced} su {hsw}; HSW (hidro, saulės, vėjo) produktai to paprastai neapima."
      }
    }
  },
  "inventory_selection": {
    "quick_filters": "@:forwards.picker.criteria.quick_filters",
    "standard_aib_gc": "@:forwards.pools.eligibility.tier.standard_aib_gc",
    "vintage": "Gamybos metai",
    "tech_filters": {
      "hsw": "Hidro, saulė, vėjas",
      "biomass": "@:common.technology.biomass",
      "nuclear": "Branduolinė energija"
    },
    "auto_select": "Automatinis pasirinkimas",
    "target": "@:forwards.picker.take.target",
    "target_label": "@:forwards.picker.take.target_label",
    "spread_over_companies": "Paskirstyti tarp įmonių",
    "clear": "@:forwards.picker.take.clear",
    "available": "Prieinama",
    "selected": "Pasirinkta",
    "row_count": "{count} įrašų | {count} įrašas | {count} įrašai",
    "breakdowns": {
      "production_months": "Gamybos mėnesiai",
      "support_status": "@:forwards.picker.summary.by_support",
      "technology": "@:forwards.picker.take.technology",
      "commercial_operations_date": "@:forwards.picker.summary.by_cod",
      "re100_applicable": "@:forwards.picker.summary.re100",
      "ecolabel_status": "@:forwards.picker.summary.by_ecolabel",
      "supported": "Remiama",
      "unsupported": "Neremiama",
      "unknown": "@:common.unknown",
      "cod_le_5": "@:forwards.picker.summary.cod_young",
      "cod_6_15": "@:forwards.picker.summary.cod_middle",
      "cod_gt_15": "@:forwards.picker.summary.cod_old",
      "ekoenergy_pre_approved": "@:forwards.picker.ecolabel.ekoenergy",
      "okpower_new_compatible": "@:forwards.picker.ecolabel.okpower_new"
    }
  },
  "device_groups": {
    "group_devices": "Grupuoti įrenginius",
    "new_group": "Nauja grupė",
    "edit_group": "Redaguoti grupę",
    "groups_title": "Įrenginių grupės",
    "all_devices": "Visi įrenginiai",
    "ungrouped": "Nesugrupuoti",
    "suggested_from_address": "Pasiūlyta pagal adresą",
    "create_group": "Sukurti grupę",
    "save_group": "Išsaugoti grupę",
    "delete_group": "Ištrinti grupę",
    "delete_confirm": "Ištrinti grupę \"{name}\"? Jos įrenginiai liks nesugrupuoti.",
    "dismiss": "Paslėpti",
    "dismiss_suggestion": "Paslėpti {name}",
    "devices_count": "Įrenginių nėra | {count} įrenginys | {count} įrenginiai",
    "devices_and_power": "Įrenginių nėra | {count} įrenginys · {power} kW | {count} įrenginiai · {power} kW",
    "name_label": "Pavadinimas",
    "name_placeholder": "Grupės pavadinimas",
    "pick_devices": "Pasirinkti įrenginius",
    "paste_device_ids": "Įklijuoti įrenginių ID",
    "start_from_address": "Pradėti nuo adreso",
    "search_placeholder": "Ieškoti pagal įrenginio ID, pavadinimą ar adresą",
    "all_technologies": "Visos technologijos",
    "select_matching": "Pasirinkti {count}",
    "deselect": "Atžymėti",
    "paste_placeholder": "Vienas įrenginio ID eilutėje",
    "paste_found": "Rasta {found} iš {total}",
    "paste_not_found": "{id} nerastas",
    "paste_in_group": "{id} grupėje {group}",
    "add_devices": "Pridėti įrenginius | Pridėti {count} įrenginį | Pridėti {count} įrenginius",
    "modal_hint": "Grupė rodoma prekybos strategijos įrenginių pasirinkimuose ir portfelio įrenginių filtruose.",
    "device_column": "Įrenginys",
    "group_column": "Grupė",
    "in_group": "Grupėje {group}",
    "selected_summary": "Pasirinkta {count} · {power} kW",
    "add_to_group": "Pridėti į grupę",
    "new_group_from_selection": "Nauja grupė iš pasirinktų",
    "remove_from_group": "Pašalinti iš grupės",
    "clear_selection": "Išvalyti pasirinkimą",
    "hint_select_ungrouped": "Pasirinkite nesugrupuotus įrenginius, kad pridėtumėte juos į grupę",
    "hint_select_to_remove": "Pasirinkite įrenginius, kad pašalintumėte juos iš šios grupės",
    "select_all_shown": "Pasirinkti visus rodomus įrenginius",
    "select_device": "Pasirinkti {device}",
    "group_created": "Grupė \"{name}\" sukurta",
    "group_saved": "Grupė \"{name}\" išsaugota",
    "group_deleted": "Grupė \"{name}\" ištrinta",
    "picker": {
      "select_by_group": "Pasirinkti pagal grupę",
      "hint": "Pasirinkus grupę pridedami dabartiniai jos įrenginiai. Vėliau į grupę pridėti įrenginiai čia nepridedami.",
      "group_partial_count": "{selected} iš {count} įrenginių",
      "other_devices": "Kiti įrenginiai",
      "more": "+{count} daugiau",
      "show_less": "Rodyti mažiau"
    },
    "filter": {
      "groups": "Grupės",
      "devices": "Įrenginiai",
      "n_groups": "Grupių nėra | {count} grupė | {count} grupės"
    },
    "errors": {
      "name_taken": "Grupė tokiu pavadinimu jau yra.",
      "limit_reached": "Įmonė jau turi didžiausią leistiną įrenginių grupių skaičių.",
      "unknown_devices": "Kai kurie įrenginiai nebepasiekiami. Perkraukite puslapį ir bandykite dar kartą.",
      "devices_in_other_group": "Kai kurie įrenginiai jau priklauso kitai grupei: {devices}"
    }
  }
}
